import { TranslationKey } from './fr';

const translationEn: Record<TranslationKey, string> = {
    // metadata
    'metadata.description': "Innovorder's back-office",

    // Cookies
    'cookies.banner.message':
        "Notre site web utilise des cookies pour améliorer votre expérience. En continuant à naviguer, vous acceptez l'utilisation de ces cookies. Pour en savoir plus sur notre politique de confidentialité et pour gérer vos préférences de cookies, veuillez consulter notre page dédiée.",
    'cookies.banner.accept': 'Accept',
    'cookies.banner.decline': 'Decline',

    // legends
    'legend.DELIVERY': 'Delivery',
    'legend.DRIVE': 'Drive',
    'legend.SIT_IN': 'Sit in',
    'legend.TAKE_AWAY': 'Take away',
    'legend.KIOSK': 'Kiosk',
    'legend.WEB': 'Web Ordering',
    'legend.RECEPTION': 'Reception',
    'legend.POS': 'Point of sale',
    'legend.LOYALTY': 'Loyalty',
    'legend.EWALLET_KIOSK': 'Ewallet kiosk ',
    'legend.VENDING_MACHINE': 'Vending machines',

    // analytics page
    'analyticsPage.reload': 'Refresh report data',
    'analyticsPage.needBrandSelection': 'As an admin, you must select at least one brand.',
    'analyticsPage.notAuthorizedToSeeBrand': 'You are not allowed to see this brand.',
    'analyticsPage.cannotMixEducationAndNonEducationBrands':
        "You can't select both education and non-education brands.",
    'beta_banner.message': '👋 this is a <b>beta</b> version, numerous features / fixes are coming.',
    'analytics.metabaseError': 'An error occurred, please try again later…',
    'analytics.noAdmin': "Unfortunately, IO Analytics isn't available for admin… Don't worry, it's coming soon!",
    'analytics.realTime': 'Real Time',
    'analytics.ranking': 'Ranking',
    'analytics.products': 'Products',
    'analytics.sales': 'Sales',
    'analytics.salesSummary': 'Sales Summary',
    'analytics.demoStaging': 'Demo (Staging)',
    'analytics.attendance': 'Attendance',
    'analytics.billing': 'Billing',
    'analytics.dashboard': 'Metabase dashboard',
    'analytics.filter.restaurant': 'Filter by restaurant',
    'analytics.filter.group': 'Filter by group',
    'analytics.filter.consumption': 'Way of consuming',
    'analytics.filter.channel': 'Channels',
    'analytics.filter.HT': 'Without Tax',
    'analytics.filter.TTC': 'With Tax',
    'analytics.filter.takeAway': 'Take Away',
    'analytics.filter.sitIn': 'Sit In',
    'analytics.filter.delivery': 'Delivery',
    'analytics.filter.drive': 'Drive',
    'analytics.filter.kiosk': 'Kiosk',
    'analytics.filter.web': 'Web Ordering',
    'analytics.filter.pos': 'Point of Sale',
    'analytics.filter.ubereats': 'Ubereats',
    'analytics.filter.deliveroo': 'Deliveroo',
    'analytics.filter.justeat': 'Justeat',
    'analytics.filter.vendingmachine': 'Vending Machine',

    // Leaderboard
    'leaderboard.title': 'Leaderboard',
    'leaderboard.ranking': 'Ranking',
    'leaderboard.restaurantName': 'Restaurants',
    'leaderboard.revenue': 'Revenue',
    'leaderboard.averageBasket': 'Average basket',
    'leaderboard.ordersCount': 'Orders',
    'leaderboard.RestaurantSearchPlaceholder': 'Find a restaurant',

    // Tiles
    'tile.genericErrorMessage': 'An error occurred!',
    'tile.errorHint': 'Please try to refresh report data',

    // Random
    'random.or': 'or',

    // Tooltip
    'tooltip.example.label': 'Example:',

    // Paiement IO Pay Config
    'iopay.configuration.title': 'Adyen Configuration',
    'iopay.commissions.online.title': 'Online fees',
    'iopay.commissions.proximity.title': 'Proximity fees',
    'iopay.form.name': 'Label',
    'iopay.form.placeholder.name': 'Label',
    'iopay.form.accountHolder': 'Account holder',
    'iopay.form.placeholder.accountHolder': 'AH111222AAABBB',
    'iopay.form.balanceAccount': 'Balance account',
    'iopay.form.placeholder.balanceAccount': 'BA111222AAABBB',
    'iopay.form.storeId': 'Store ID',
    'iopay.form.placeholder.storeId': 'Store ID',
    'iopay.form.transferInstrumentId': 'Transfer instrument ID',
    'iopay.form.placeholder.transferInstrumentId': 'SE111222AAABBB',
    'iopay.form.fixOnlineCommissionAmount': 'Fixed commission amount (in cts)',
    'iopay.form.fixProximityCommissionAmount': 'Fixed commission amount (in cts)',
    'iopay.form.placeholder.fixOnlineCommissionAmount': 'Fixed commission amount (in cts)',
    'iopay.form.placeholder.fixProximityCommissionAmount': 'Fixed commission amount (in cts)',
    'iopay.form.variableOnlineCommissionPercent': 'Variable commission percent',
    'iopay.form.variableProximityCommissionPercent': 'Variable commission percent',
    'iopay.form.placeholder.variableOnlineCommissionPercent': 'Variable commission percent',
    'iopay.form.placeholder.variableProximityCommissionPercent': 'Variable commission percent',

    // Payment Edenred Config
    'edenred.configuration.title': 'Edenred module settings',
    'edenred.form.description':
        'Configure Edenred integration by entering the necessary information. Once registered, the Merchand ID of the restaurant will be automatically retrieved.',
    'edenred.form.warning.toSend': 'Information saved & still modifiable before being sent to Edenred',
    'edenred.form.warning.sent': 'Currently being processed by Edenred',
    'edenred.form.mid': 'Merchant ID',
    'edenred.form.name': 'Restaurant name',
    'edenred.form.placeholder.name': 'The name of my restaurant',
    'edenred.form.siret': 'Siret',
    'edenred.form.placeholder.siret': '12345678900012',
    'edenred.form.address': 'Address',
    'edenred.form.placeholder.address': '5 Anatole France Avenue',
    'edenred.form.zipCode': 'Zip code',
    'edenred.form.placeholder.zipCode': '75007',
    'edenred.form.city': 'City',
    'edenred.form.placeholder.city': 'Paris',

    // Paygreen Config
    'paygreen.configuration.title': '"E-luncheon vouchers module settings',
    'paygreen.form.description':
        'Once your account is created after filling the above form, the public and private keys will be given to you to finalize the configuration.',
    'paygreen.form.ongoing_v3_migration':
        'A migration of the Paygreen version is in progress, no action on the backoffice is necessary from your part',
    'paygreen.form.enablePaygreenV3': 'Enable Paygreen V3',
    'paygreen.form.publicKey': 'V2 Public Key (shopId)',
    'paygreen.form.privateKey': 'V2 Private Key (token)',
    'paygreen.form.secretKey': 'V3 Secret Key',
    'paygreen.form.shopId': 'V3 Shop ID',
    'paygreen.form.label': 'Integration Label',
    'paygreen.form.subShopId': 'V3 Sub shop ID (to be filled only in Marketplace mode)',
    'paygreen.form.supportsLuncheon': 'Payments with Restaurant Pass Sodexo or Chèque Déjeuner (UP)',
    'paygreen.form.supportsSwile': 'Allow payments with Swile (Lunchr)',
    'paygreen.form.supportsRestoflash': 'Allow payments with RestoFlash',
    'paygreen.form.placeholder.enablePaygreenV3': 'Enable Paygreen V3',
    'paygreen.form.placeholder.label': 'Integration Label',
    'paygreen.form.placeholder.publicKey': 'V2 Public Key (shopId)',
    'paygreen.form.placeholder.privateKey': 'V2 Private Key (token)',
    'paygreen.form.placeholder.secretKey': 'V3 Secret Key',
    'paygreen.form.placeholder.shopId': 'V3 Shop ID',
    'paygreen.form.placeholder.subShopId': 'V3 Sub shop ID (to be filled only in Marketplace mode)',
    'paygreen.form.placeholder.supportsLuncheon': 'Payments with Restaurant Pass Sodexo or Chèque Déjeuner (UP)',
    'paygreen.form.placeholder.supportsSwile': 'Allow payments with Swile (Lunchr)',
    'paygreen.form.placeholder.supportsRestoflash': 'Allow payments with RestoFlash',

    // Marketplace Ubereats Config
    'ubereats.title': 'UberEats Configuration',
    'ubereats.description.firstpart':
        "Configure your Ubereats integration by retrieving your UUID reference from the ubereats restaurants dashboard. If you don't know how to get this information:",
    'ubereats.description.secondpart': "How to find my restaurant's store ID?",
    'ubereats.description.thirdpart':
        'Once set up, your point of sale will automatically receive orders from Ubereats.',
    'ubereats.storid': 'Store ID',
    'ubereats.activestorids': 'Active(s) Store ID',

    // Marketplace Deliverect Config
    'deliverect.title': 'Deliverect module settings',
    'deliverect.subtitle': 'How to configure Deliverect integration?',
    'deliverect.description.firstpart':
        'You must first contact an account manager to allow you to create an account on the Deliverect environment.',
    'deliverect.description.secondpart':
        'Once this account is activated, the possibility of activating the sending of orders on the channels of your choice will be possible directly from this interface.',
    'deliverect.description.thirdpart': 'You will also be able to synchronize your products in the interface.',
    'deliverect.contact': 'Contact an account manager',

    // Marketplace Deliveroo config
    'deliveroo.title': 'Deliveroo module settings',
    'deliveroo.subtitle': 'How to configure Deliveroo integration?',
    'deliveroo.description.firstpart':
        'You must first contact an account manager to allow you to create an account on the Deliveroo environment.',
    'deliveroo.description.secondpart':
        'Once this account is configured, your POS will automatically receive Deliveroo orders in the delivery section.',
    'deliveroo.description.thirdpart': "You will also be able to synchronize your products in Deliveroo's interface.",
    'deliveroo.contact': 'Contact an account manager',

    // Module Crous Configuration
    'crous.title': 'Configuration of the CROUS catalog synchronization module',
    'crous.description':
        'Choose the restaurant whose catalogs you wish to import and enter the CROUS cash register number provided by the customer (pos_id)',
    'crous.listcrousrestaurants.label': 'Crous Restaurants',
    'crous.listcrousrestaurants.placeholder': 'Choose a restaurant',
    'crous.numerocaisse.label': 'Crous register number',
    'crous.numerocaisse.placeholder': 'Please enter the Crous cash register number',
    'crous.apikey.label': 'Crous API key',
    'crous.apikey.placeholder': 'Please enter the Crous API key',

    // Marketplace Common config
    'marketplace.vatdefault.placeholder': 'Default VAT (%)',
    'marketplace.vatdefault.message': 'Default VAT',
    'marketplace.storid.label': 'Locations ID:',
    'marketplace.storid.placeholder': 'Type your location ID',
    'marketplace.storid.unknown': 'unknown location ID',
    'marketplace.storid.alreadyused': 'This UUID is already active ({name})',
    'marketplace.activestorids.label': 'Actives virtual brands:',
    'marketplace.activestorids.emptystate': 'You does not have any active virtual brand',
    'marketplace.location.title': 'Brand {counter}',
    'marketplace.location.delete': 'Delete',

    // Status
    'status.status': 'Status',
    'status.active': 'Active',
    'status.inactive': 'Inactive',
    'status.disabled': 'Unavailable',
    'status.loading': 'Loading',
    'status.unknown': 'Unknown',
    'status.new': 'New',
    'status.file_uploaded': 'File uploaded',
    'status.processing': 'Processing',
    'status.done': 'Done',
    'status.error': 'Error',

    // Date
    'date.created': 'Date created',
    'date.updated': 'Date updated',

    // External Pos Config
    'external_pos.pos_ref.label': 'Deliverect POS ID',
    'external_pos.pos_ref.placeholder': 'Type your Deliverect POS ID',
    'external_pos.title': 'External Deliverect POS settings',
    'external_pos.subtitle': 'How to configure an external Deliverect POS?',
    'external_pos.description.firstpart':
        'You must first contact an account manager to allow you to create an account on the Deliveroo environment.',
    'external_pos.description.secondpart':
        'Once your external POS Deliverect is configured, it will automatically receive orders from activated Innovorder channels.',
    'external_pos.description.thirdpart':
        'With this integration, we recommend you to manage and synchronize your menus from Deliverect.',
    'external_pos.contact': 'Contact an account manager',
    'external_pos.channels.title': 'Deliverect external POS Integration :',
    'external_pos.channels.subtitle': 'Active channels :',

    // Webhook Config
    'webhook_url.label': 'Webhook URL',
    'webhook_url.placeholder': 'Webhook URL',
    'webhook_secret.label': 'Webhook Secret key',
    'webhook_secret.placeholder': 'Webhook secret key',
    'webhook.headers.label': 'Additional HTTP headers',
    'webhook.headers.name.placeholder': 'Header name',
    'webhook.headers.value.placeholder': 'Header value',
    'webhook.channels.title': 'Webhook triggering channels',
    'webhook.channels.subtitle': 'Available channels :',
    'webhook.title': 'Webhook settings',
    'webhook.firstpart.subtitle': 'The role of this webhook',
    'webhook.firstpart.description':
        'The role of this webhook is to notify that an order has been made by one of your guests on Innovorder.\n' +
        'If a sale is made for a guest identified by a badge, a call is made to this webhook to send him the necessary information about this order.',
    'webhook.secondpart.subtitle': 'How to configure the webhook?',
    'webhook.secondpart.description':
        'You have to fill in the URL of the webhook.\n' +
        'The secret key of the webhook is generated automatically.\n' +
        'You just have to click on the channels to activate for this webhook.\n' +
        'Once configured, the service must return an HTTP 200 response code with an empty response body to acknowledge the webhook event.',
    'webhook.documentationLink': 'See the documentation of this webhook',
    'webhook.modal.warning': 'Warning',
    'webhook.modal.confirmDelete': 'Are you sure you want to delete?',
    'webhook.channels.kiosk': 'Kiosk',
    'webhook.channels.web': 'Web',
    'webhook.channels.pos': 'POS',
    'webhook.channels.trayScan': 'Tray Scan',
    'webhook.channels.vendingMachine': 'Vending\nMachine',
    'webhook.eventTypes.title': 'Event types',
    'webhook.eventTypes.subtitle': 'Available event types :',
    'webhook.brand.title': 'Webhook settings',
    'webhook.brand.firstpart.subtitle': 'The role of this webhook',
    'webhook.brand.firstpart.description':
        'Webhooks allow you to receive real-time notifications when specific events occur in your Innovorder system. You can configure webhooks to be triggered by different events such as updates to client data, transaction events, or order notifications. When an event occurs, Innovorder will send an HTTP POST request to your specified endpoint with the relevant data.',
    'webhook.brand.secondpart.subtitle': 'How to configure the webhook?',
    'webhook.brand.secondpart.description':
        '1. Provide the URL of the webhook where you want to receive notifications.\n' +
        '2. Select the types of events you want to monitor among the available options.\n' +
        '3. Choose the channels where these events should trigger the webhook.\n' +
        '4. Add additional HTTP headers if required by your endpoint.\n' +
        '5. The webhook secret key is generated automatically for security.\n' +
        'Your endpoint must return an HTTP 200 response code with an empty response body to acknowledge the webhook event.',
    'webhook.system.badge': 'System',
    'webhook.system.readonly': 'This webhook is managed by the system and cannot be modified.',

    // Login
    'login.panelTitle': 'Welcome',
    'login.login': 'Log in',
    'login.password': 'Password',
    'login.ssoChecking': 'Checking SSO…',
    'login.ssoEnabled': 'Single Sign-On is enabled for this email.',
    'login.ssoLogin': 'Log in with SSO',
    'login.ssoFailed': 'SSO login failed. Please try again.',
    'login.ssoLoginRequired': 'This account requires SSO login. Redirecting you to SSO…',
    'login.noBrandsConfigured': 'No brands are configured for this user.',
    'login.guestBrandLoginFailed': 'Login failed. Please try again.',
    'login.rememberMe': 'Remember me',
    'login.forgotPassword': 'Forgot password?',
    'login.accountLocked': 'Account temporarily locked. Try again in {minutes} minutes.',
    'login.captchaRequired': 'Security verification required.',
    'login.ipNotAllowed': 'Login not allowed from this IP address.',
    'login.accountDisabled': 'This account has been disabled due to inactivity.',

    // Extend account
    'extendAccount.title': 'Account extension',
    'extendAccount.loadingBody': 'Validating the link…',
    'extendAccount.successTitle': 'Account extended',
    'extendAccount.successBody': 'Your account has been extended. You can now sign back in.',
    'extendAccount.invalidTitle': 'Invalid link',
    'extendAccount.invalidBody': 'This extension link is invalid or has expired.',
    'extendAccount.expiredHint': 'To recover access to your account, please contact your administrator.',
    'extendAccount.missingTokenBody': 'The link is incomplete. Please open the link again from your email.',
    'extendAccount.backToLogin': 'Back to sign-in',

    // Forgot Password
    'forgotPassword.title': 'Forgot password',
    'forgotPassword.subtitle': 'Enter your email to receive a reset link.',
    'forgotPassword.submit': 'Send reset link',
    'forgotPassword.backToLogin': 'Back to login',
    'forgotPassword.successTitle': 'Email sent',
    'forgotPassword.successMessage':
        'If an account exists for that email, a reset link has just been sent. Check your inbox.',
    'forgotPassword.recaptchaLoading': 'Loading reCAPTCHA…',
    'forgotPassword.recaptchaFailed': 'reCAPTCHA verification failed. Please try again.',
    'forgotPassword.recaptchaUnavailable': 'reCAPTCHA unavailable. Refresh the page and try again.',
    'forgotPassword.recaptchaNotConfigured':
        'Missing configuration (REACT_APP_RECAPTCHA_SITE_KEY). Contact an administrator.',

    // Reset Password
    'resetPassword.title': 'New password',
    'resetPassword.subtitle': 'Choose a new password for your account.',
    'resetPassword.submit': 'Reset',
    'resetPassword.backToLogin': 'Back to login',
    'resetPassword.successTitle': 'Password updated',
    'resetPassword.successMessage': 'Your password was updated successfully. You can now log in.',
    'resetPassword.invalidLinkTitle': 'Invalid link',
    'resetPassword.invalidLink': 'This reset link is invalid or expired. Request a new one from the login page.',
    'resetPassword.passwordTooShort': 'Password must be at least {min} characters.',
    'resetPassword.passwordsMismatch': "The two passwords don't match.",

    // MFA
    'mfa.verify.title': 'Two-factor verification',
    'mfa.verify.subtitle': 'Enter the 6-digit code from your authenticator app.',
    'mfa.verify.backupTitle': 'Backup code',
    'mfa.verify.backupSubtitle': 'Enter one of your single-use backup codes.',
    'mfa.verify.submit': 'Verify',
    'mfa.verify.useBackupInstead': 'Use a backup code instead',
    'mfa.verify.useTotpInstead': 'Use the authenticator app',
    'mfa.verify.useDifferentMethod': 'Use a different method',
    'mfa.verify.chooser.title': 'Choose a method',
    'mfa.verify.chooser.subtitle': 'Which method would you like to use to verify your identity?',
    'mfa.verify.chooser.webauthnHint': 'Use your security key or biometrics.',
    'mfa.verify.chooser.totpHint': 'Enter the code from your authenticator app.',
    'mfa.verify.failed': 'Invalid code. Please try again.',
    'mfa.verify.tokenExpired': 'The MFA session expired. Please log in again.',
    'mfa.verify.tabs.totp': 'Authenticator app',
    'mfa.verify.tabs.webauthn': 'Security key / biometric',
    'mfa.verify.webauthn.title': 'Verify with your security key',
    'mfa.verify.webauthn.subtitle': 'Tap your security key, use Touch ID or another platform authenticator.',
    'mfa.verify.webauthn.authenticate': 'Authenticate',
    'mfa.verify.webauthn.failed': 'Authentication failed. Please try a different method.',
    'mfa.verify.webauthn.noCredentials': 'No security key is registered for this account.',
    'mfa.verify.webauthn.ceremonyFailed':
        'Authentication was cancelled or your browser refused the request. Please try again.',
    'mfa.setup.title': 'Set up two-factor authentication',
    'mfa.setup.subtitle':
        'Scan this QR code with your authenticator app (Google Authenticator, 1Password, etc.) then enter the generated code.',
    'mfa.setup.loadingQr': 'Loading QR code...',
    'mfa.setup.copySecret': 'Copy secret key',
    'mfa.setup.copied': 'Copied!',
    'mfa.setup.confirm': 'Confirm',
    'mfa.setup.invalidCode': "Invalid code. Check your app's clock sync.",
    'mfa.setup.backupTitle': 'Save your backup codes',
    'mfa.setup.backupSubtitle':
        'Store these codes in a safe place. They let you log in if you lose access to your authenticator app. Each code can only be used once.',
    'mfa.setup.backupAcknowledge': "I've saved my codes, continue",
    'mfa.setup.tabs.totp': 'Authenticator app',
    'mfa.setup.tabs.webauthn': 'Security key / biometric',
    'mfa.setup.webauthn.title': 'Register a security key',
    'mfa.setup.webauthn.subtitle':
        'Use a hardware key (YubiKey), Touch ID, Windows Hello or another platform authenticator. Optionally name this device so you can identify it later.',
    'mfa.setup.webauthn.deviceNamePlaceholder': "Device name (e.g. 'My laptop')",
    'mfa.setup.webauthn.register': 'Register',
    'mfa.setup.webauthn.ceremonyFailed':
        'Registration was cancelled or your browser refused the request. Please try again.',
    'mfa.setup.webauthn.finalizing': 'Finalising your security key…',

    // Activate Account
    'activateAccount.title': 'Account Activation',
    'activateAccount.submit': 'Activate my account',
    'activateAccount.submitting': 'Activating...',
    'activateAccount.loading': 'Validating token...',
    'activateAccount.resend': 'Resend activation email',
    'activateAccount.resending': 'Resending...',
    'activateAccount.renewSuccess': 'A new activation email has been sent. Please check your inbox.',
    'activateAccount.error.missingToken': 'Missing token',
    'activateAccount.error.invalidToken': 'Expired token',
    'activateAccount.error.password.minLength': 'Password must contain at least {min} characters',
    'activateAccount.error.password.maxLength': 'Password must not exceed {max} characters',
    'activateAccount.error.password.requireUppercase': 'Password must contain at least one uppercase letter',
    'activateAccount.error.password.requireLowercase': 'Password must contain at least one lowercase letter',
    'activateAccount.error.password.requireNumbers': 'Password must contain at least one number',
    'activateAccount.error.password.requireSpecialCharacters': 'Password must contain at least one special character',
    'activateAccount.password.placeholder': 'Password',
    'activateAccount.confirmPassword.placeholder': 'Confirm password',

    // SideBar
    'sidebar.overview': 'Overview',
    'sidebar.orders': 'Orders',
    'sidebar.customers': 'Customers',
    'sidebar.brand': 'Brand',
    'sidebar.brands': 'Brands',
    'sidebar.restaurants': 'Restaurants',
    'sidebar.loyalty': 'Loyalty',
    'sidebar.coupons': 'Coupons',
    'sidebar.paymentMeans': 'Payment means',
    'sidebar.integrations': 'Integrations',
    'sidebar.reports': 'Reports',
    'sidebar.reportsSales': 'Sales',
    'sidebar.reportsEwallets': 'Badges Balance',
    'sidebar.monthly_sales_report': 'Monthly Sales Report',
    'sidebar.exports': 'Exports',
    'sidebar.exportsAccounting': 'Accounting',
    'sidebar.exportsEwallets': 'E-wallet',
    'sidebar.exportsSales': 'Sales Summary',
    'sidebar.salesSummary': 'Sales Summary',
    'sidebar.exportsPreInvoicing': 'Pre-invoicing',
    'sidebar.exportsBadge': 'Badge transactions',
    'sidebar.reportGenerationsHistory': 'Generations history',
    'sidebar.help': 'Need help?',
    'sidebar.languages': 'Languages',
    'sidebar.account': 'My account',
    'sidebar.media': 'Medias',
    'sidebar.marketplaces': 'Marketplaces',
    'sidebar.urssaf': 'Minimum Urssaf',
    'sidebar.vatRatesMatrix': 'VAT Reference',
    'sidebar.autoBilling': 'Automatic billing',
    'sidebar.logout': 'Log Out',
    'sidebar.password': 'My password',
    'sidebar.security': 'Security',
    'security.title': 'Security',
    'security.loading': 'Loading…',
    'security.actions.remove': 'Remove',
    'security.actions.cancel': 'Cancel',
    'security.totp.title': 'Authenticator app',
    'security.totp.subtitle': 'Time-based one-time codes from an app like Google Authenticator or 1Password.',
    'security.totp.label': 'Authenticator app',
    'security.totp.added': 'Added on {date}',
    'security.totp.empty': 'No authenticator app configured.',
    'security.totp.add': 'Add an authenticator app',
    'security.totp.modalTitle': 'Set up an authenticator app',
    'security.totp.confirmRemove': 'Are you sure you want to remove your authenticator app?',
    'security.passkeys.title': 'Security keys & passkeys',
    'security.passkeys.subtitle':
        'Hardware keys, Touch ID, Windows Hello and other platform authenticators registered for this account.',
    'security.passkeys.empty': 'No security key registered.',
    'security.passkeys.unnamedDevice': 'Unnamed device',
    'security.passkeys.lastUsed': 'Last used {date}',
    'security.passkeys.added': 'Added {date}',
    'security.passkeys.add': 'Add a passkey',
    'security.passkeys.confirmRemove':
        'Are you sure you want to remove this passkey? You will no longer be able to use this device to sign in.',
    'security.passkeys.ceremonyFailed':
        'Registration was cancelled or your browser refused the request. Please try again.',
    'security.passkeys.requestFailed': 'Something went wrong. Please try again.',
    'security.allowedIps.title': 'Allowed IP addresses',
    'security.allowedIps.subtitle':
        'Restrict your sign-in to a list of IPs or CIDR ranges. Allowlisted IPs also bypass CAPTCHA and lockout counters.',
    'security.allowedIps.empty': 'No restriction. You can sign in from any IP address.',
    'security.allowedIps.add': 'Add',
    'security.allowedIps.placeholder': '192.168.1.1 or 10.0.0.0/24',
    'security.allowedIps.invalid': 'Invalid IP address or CIDR range.',
    'security.allowedIps.confirmRemoveTitle': 'Remove this IP address?',
    'security.allowedIps.confirmRemove': 'This address will no longer be allowed to sign in to your account.',
    'security.allowedIps.cancel': 'Cancel',
    'security.allowedIps.warning':
        'Warning: while the list contains at least one entry, you will not be able to sign in from any other IP.',
    'sidebar.billing': 'My billing space',
    'sidebar.ioPay': 'Payments',
    'sidebar.news': "What's new?",
    'sidebar.analytics': 'Analytics',

    // Messages
    'message.message': 'Message',

    // Names
    'name.name': 'Name',
    'name.firstName': 'First name',
    'name.lastName': 'Last name',

    // Not found
    'notFound.message': "The page you're looking for doesn't seem to exist.",
    'notFound.backToHome': 'Go back home',
    'permissionDenied.title': 'Forbidden Access',
    'permissionDenied.message': "We're sorry, but you do not have permission to access this page.",
    'permissionDenied.backToHome': 'Go back home',

    // Error page
    'errorPage.message': 'Sorry, an error has occurred. We are actively working to fix this problem !',
    'errorPage.support': 'Contact our support team',

    // Files
    'file.noFile': 'No file',
    'file.cannotProcessJson': 'The JSON file cannot be processed. Check its format.',
    'file.fileNotAllowed': 'This type of file is not allowed. Allowed extensions : {allowedExtensionsString}',
    'file.fileTemplate': 'file template',
    'file.metabaseLink': 'metabase link',

    // File input
    'fileInput.placeholder.title': 'Add your files',
    'fileInput.placeholder.drop': 'Drop your files here!',
    'fileInput.placeholder': 'Drag & Drop you files here',
    'fileInput.browse': 'Import from your computer',

    // Image input
    'imageInput.section.modal.title': 'Add an image',
    'imageInput.section.modal.resize.label': 'Background image mode',
    'imageInput.section.modal.resize.details':
        'Use this when uploading images that will be used as a background for kiosks or web ordering.',
    'imageInput.section.library.title': 'From the library',
    'imageInput.section.upload.title': 'From my computer',

    // Languages
    'languages.fr_FR': 'French',
    'languages.en_EN': 'English',
    'languages.it_IT': 'Italian',
    'languages.sodexo_SODEXO': 'Sodexo',
    'languages.es_ES': 'Spanish',
    'languages.zh-CN_ZH-CN': 'Chinese (Simplified)',
    'languages.zh-TW_ZH-TW': 'Chinese (Traditional)',
    'languages.ar_AR': 'Arabic',
    'languages.de_DE': 'German',

    // UI
    'button.add': 'Add',
    'button.delete': 'Delete',
    'button.edit': 'Edit',
    'button.configure': 'Configure',
    'button.cancel': 'Cancel',
    'button.close': 'Close',
    'button.generate': 'Generate',
    'button.save': 'Save',
    'button.import': 'Import',
    'button.publish': 'Publish',
    'button.saveAndPublish': 'Save and publish',
    'button.uploadFile': 'Upload file',
    'button.previous': 'Back',
    'button.next': 'Next',
    'button.ok': 'OK',
    'button.refresh': 'Refresh',
    'button.validate': 'Validate',
    'button.confirm': 'Confirm',
    'button.yes': 'Yes',
    'button.understand': 'Understood',
    'button.convertToCrossSell': 'Convert to cross sell',
    'button.convertToCustomization': 'Convert to customization',
    'button.skipStep': 'Skip this step',
    'button.block': 'Block',
    'button.unblock': 'Unblock',
    'select.selectAll': 'Select all',
    'switch.activate': 'Activate',
    'form.preventLeave': 'You have unpublished changes. Are you sure you want to leave this page?',
    'field.required': 'This field is required',
    'field.optional': '(optional)',
    'field.greaterThanZero': 'This field must be greater than 0',
    'field.invalidEmail': 'This email is invalid',
    'field.invalidURL': 'This URL is invalid',
    'field.atLeastOneEventType': 'At least one event type must be selected',
    'field.unmatchedPassword': 'The two passwords have to match',
    'field.invalidPassword': 'Password should be at least 8 characters',
    'field.invalidPhoneNumber': 'Invalid phone number',
    'field.duplicate_email': 'This e-mail already exists',
    'field.duplicate_student_number': 'This student number already exists',
    'field.duplicate_badge_number': 'This badge number already exists',
    'field.ewallet_is_not_null_to_postpayment':
        'To convert the guest into a post-payment account, once balance have to be equal to 0€',
    'field.minTwo': 'Min 2 characters',
    'select.enabled': 'Enabled',
    'select.customised': 'Customised',
    'select.disabled': 'Disabled',
    'table.search': 'Search',
    'table.searchColumn': 'Search {name}',
    'table.searchColumn.placeholder': 'Search a value',
    'table.searchColumn.placeholder.from': 'Min',
    'table.searchColumn.placeholder.to': 'Max',
    'table.searchColumn.clearFilter': 'Remove filters',
    'table.clearAllFilters': 'Remove all filters',
    'table.rowsPerPage': 'Rows per page',
    'table.firstPage': 'First',
    'table.lastPage': 'Last',
    'table.noRowsAfterFilter': 'No results were found for your search',
    'table.noRowsAfterFilter.dateRangeHint': 'Have you tried changing the date range?',
    'table.noRowsAfterFilter.dateRangePresetHint': 'No results in the last {days} days.',
    'table.noRowsAfterFilter.dateRangeCustomHint': 'No results for the selected period.',
    'table.noRowsAfterFilter.dateRangeAction': 'Change the date range to display orders.',
    'table.sort': 'Sort by {name}',
    'table.columnSelection.button': 'Column management',
    'table.columnSelection.buttonFiltered': 'Column management ({count})',
    'table.columnSelection.header': 'Filter columns',
    'table.columnSelection.placeholder': 'Search a column',
    'table.columnSelection.allEntries': 'All columns',
    'table.selection.count': '{count} selected line{count, plural, =1 {} other {s}}',
    'table.empty': 'No data available',
    'pagination.previous': 'Previous',
    'pagination.next': 'Next',
    'navigation.back': 'Back',
    'navigation.next': 'Next',
    'navigation.disabled': 'Back',
    'navigation.backToV1': 'Back to older version',
    'savingBar.changesDone': '{changesCount, plural, =0 {} one {# change done} other {# changes done}}',
    'ticketLabel.name.mismatch.confirmation':
        'Attention, the product name has been changed, but the production label remains the same. Do you confirm this change?',

    // Form
    'form.validation.integer': 'This field must be an integer',
    'form.validation.positive': 'This field must be positive',
    'form.validation.positiveOrZero': 'This field must be positive or zero',
    'form.validation.length': 'This field must be {length} characters long',
    'form.validation.maxLength': 'This field exceeds the allowed size',
    'form.validation.email': 'This field must be a valid email',
    'form.validation.mustMatchValue': 'Value must be {value1} or {value2 }',
    'form.validation.siret.length': 'Value must be a 14-characters SIRET number (without spaces)',
    'form.validation.siret.invalid': 'SIRET number is invalid',

    // Integrations
    'integrations.section.title': 'Payment solutions',
    'integrations.section.subtitle':
        'Payment solutions allow you to offer functionalities such as online payment by credit card or by POS Electronic Payment Terminal.',
    'integrations.stripe': 'Stripe',
    'integrations.stripeDescription':
        'Integrate Stripe with your site and allow your customers to easily connect their account for the best online ordering experience.',
    'integrations.configured': 'Configured',
    'integrations.notConfigured': 'Not configured',
    'integrations.webhooks.title': 'Webhooks',
    'integrations.webhooks.description':
        'The different Webhook integrations are listed here. It is possible to create a new Webhook by clicking the "+" button or to modify an existing Webhook by clicking on it. A status allows you to view the configuration state.',

    // Pricing Rule
    'pricingRule.emptyMessage': 'No pricing rules affiliated with this brand.',
    'pricingRule.tableCard.title': 'Pricing Rules',
    'pricingRule.tableCard.subtitle':
        'The pricing rules are sets of one or more subsidy (s) in use in your establishments',
    'pricingRule.tableCard.description':
        'If the pricing rule includes both a percentage-based grant and a fixed-amount grant, place the discount that should be applied to the entire order amount first. The following discounts will then apply to the remaining balance, after deducting the previously applied discounts.',
    'pricingRule.tableCard.action': '+ Create a new pricing rule',
    'pricingRule.code': 'Code',
    'pricingRule.applyScope': 'Application Strategy',
    'pricingRule.strategy': 'Strategy',
    'pricingRule.labelTicket': 'Ticket label',
    'pricingRule.grants_fees.amount': 'Amount',
    'pricingRule.grants_fees.dailyLimit': 'Max uses per day',
    'pricingRule.grants': 'Grants',
    'pricingRule.entranceFees': 'Entrance Fees',
    'pricingRule.excludedTurnover': 'Excluded Turnover',
    'pricingRule.associatedPricingRules': 'Associated Pricing Rules',
    'pricingRule.action': 'Action',
    'pricingRule.product': 'Alimentary part',
    'pricingRule.fee': 'Fees including entrance fee',
    'pricingRule.modal.warning': 'Warning',
    'pricingRule.modal.required': 'The `Pricing Rule` field is required',
    'pricingRule.modal.confirmDelete': 'Are you sure you want to delete?',
    'pricingRule.modal.delete.error.detail': 'This pricing rule is linked to one or more guests',
    'pricingRule.modal.unassociatedUser': 'guest will no longer have a pricing rule',
    'pricingRule.modal.unassociatedUsers': 'guests will no longer have a pricing rule',
    'pricingRule.form.title': 'Pricing Rule',
    'pricingRule.form.description': 'Configure the pricing rule by bundling the existing grants of your choice.',
    'pricingRule.form.creation': 'Pricing Rule Creation',
    'pricingRule.form.update': 'Pricing Rule Update',
    'pricingRule.form.pricingRuleCode': 'Pricing Rule Code',
    'pricingRule.form.applyScope': 'Application Strategy',
    'pricingRule.form.authorizedChannels': 'Authorized Channels',
    'pricingRule.form.isUrssafEnabled': 'Apply the URSSAF minimum to this pricing rule?',
    'pricingRule.form.composition': 'Define the composition of this pricing rule',
    'pricingRule.form.compositionDescription':
        'The pricing rules are sets of one or more entrance fee(s), grant(s) and non-turnover components.',
    'pricingRule.emptyGrant': 'No grants associated with this pricing rule.',
    'pricingRule.emptyEntranceFee': 'No entrance fees associated with this pricing rule.',
    'pricingRule.emptyTurnoverExcluded': 'No turnover excluded components associated with this pricing rule.',
    'pricingRule.emptyAssociatedPricingRule': 'No pricing rules associated with this pricing rule.',
    'pricingRule.noResult': 'No results',
    'pricingRule.addGrant': 'Add a grant',
    'pricingRule.addEntranceFee': 'Add an entrance fee',
    'pricingRule.addComponentWithoutTurnover': 'Add a component without turnover',
    'pricingRule.addAssociatedPricingRule': 'Add an associated pricing rule',
    'pricingRule.search': 'Pricing rule search',
    'pricingRule.channels.kiosk': 'Kiosk',
    'pricingRule.channels.web': 'Web Ordering',
    'pricingRule.channels.pos': 'Point of Sale',
    'pricingRule.channels.ewalletKiosk': 'Ewallet Kiosk',
    'pricingRule.channels.vendingMachine': 'Vending Machine',
    'pricingRule.action.import': 'Import',
    'pricingRule.action.export': 'Export',
    'pricingRule.modal.import.title': 'Import Admissions, Entrance Fees, and Pricing Rules',
    'pricingRule.modal.import.firstPart': 'Download the {fileTemplate} to your computer',
    'pricingRule.modal.import.secondPart':
        'Fill in the template file with the information for your admissions, subsidies, and pricing rules to add or modify',
    'pricingRule.modal.import.thirdPart': 'Import your new file by clicking the button below',
    'pricingRule.modal.import.warning':
        'Deleting an admission, Entrance Fees, or pricing rule can only be done from the Innovorder back office',
    'pricingRule.modal.import.secondWarning':
        '⚠️\nImporting an admission or grant deletes DEFINITIVELY the personalized values. \n(the personalized values by restaurant or by service)\n',
    'pricingRule.modal.import.report.title': 'Import report',
    'pricingRule.modal.import.report.result': 'Import result',
    'pricingRule.modal.import.report.success': 'Success',
    'pricingRule.modal.import.report.error': 'Error',
    'pricingRule.modal.import.report.warning': 'Warning',
    'pricingRule.modal.import.report.entranceFees': 'Entrance Fees',
    'pricingRule.modal.import.report.grants': 'Grants',
    'pricingRule.modal.import.report.pricingRules': 'Pricing rules',
    'pricingRule.modal.import.report.successMessage': 'created: {created}, updated: {updated}',
    'pricingRule.modal.import.report.errorMessage': '• Line {line} → {field}: {message}',

    'pricingRule.export.report.entranceFee.entranceFeeId': 'Admission ID',
    'pricingRule.export.report.entranceFee.code': 'Admission Code',
    'pricingRule.export.report.entranceFee.labelTicket': 'Ticket Label',
    'pricingRule.export.report.entranceFee.amount': 'Amount (in €)',
    'pricingRule.export.report.entranceFee.dailyLimit': 'Daily Limit',
    'pricingRule.export.report.entranceFee.strategy': 'Strategy (1 for always / 2 for daily limit + assigned product)',
    'pricingRule.export.report.entranceFee.vat': 'VAT',
    'pricingRule.export.report.entranceFee.type': 'Revenue (inclus/exclus)',
    'pricingRule.export.report.entranceFee.type.admissionfee': 'inclus',
    'pricingRule.export.report.entranceFee.type.royaltyfee': 'exclus',
    'pricingRule.export.report.entranceFee.active':
        'Active on all restaurants by default (oui / non) (applies to creation only)',

    'pricingRule.export.report.grant.grantId': 'Grant ID',
    'pricingRule.export.report.grant.code': 'Grant Code',
    'pricingRule.export.report.grant.labelTicket': 'Ticket Label',
    'pricingRule.export.report.grant.threshold': 'Trigger Threshold in € (empty if none)',
    'pricingRule.export.report.grant.type': 'Amount Type (Absolu / Pourcentage)',
    'pricingRule.export.report.grant.type.absolute': 'Absolu',
    'pricingRule.export.report.grant.type.rate': 'Pourcentage',
    'pricingRule.export.report.grant.ceiling': 'Grant Ceiling In € (required if type = Percentage)',
    'pricingRule.export.report.grant.amount': 'Amount (in €)',
    'pricingRule.export.report.grant.dailyLimit': 'Daily Limit',
    'pricingRule.export.report.grant.strategy':
        'Strategy (1 for daily limit + amount / 2 for daily limit + amount + assigned products)',
    'pricingRule.export.report.grant.tag': 'Tags (empty if no tag application)',
    'pricingRule.export.report.grant.active': 'Active on all restaurants by default (oui / non)',

    'pricingRule.export.report.pricingRule.pricingRuleId': 'Pricing Rule ID',
    'pricingRule.export.report.pricingRule.code': 'Pricing Rule Code',
    'pricingRule.export.report.pricingRule.canals': 'Channels',
    'pricingRule.export.report.pricingRule.isUrssafEnabled': 'Apply minimum URSSAF (only for cart API)? (yes/no)',
    'pricingRule.export.report.pricingRule.entranceFees':
        'Included Admissions (specify code, separate by comma + space if multiple)',
    'pricingRule.export.report.pricingRule.grants':
        'Included Grants (specify code, separate by comma + space if multiple)',
    'pricingRule.export.report.pricingRule.includeCA': 'Included in Revenue',
    'pricingRule.export.report.pricingRule.applyScope': "Strategy (frais dont droit d'entrée et/ou part alimentaire)",
    'pricingRule.export.report.pricingRule.applyScope.product': 'part alimentaire',
    'pricingRule.export.report.pricingRule.applyScope.fee': "frais dont droit d'entrée",

    // EntranceFee
    'entranceFee.create': 'Create entrance fee',
    'entranceFee.title': 'Entrance fee',
    'entranceFee.description':
        'Indicate the name, the label and the amount of the entrance fees for all of your restaurants.',
    'entranceFee.customUse': 'Special entrance fee applications',
    'entranceFee.descCustomUse':
        'Apply entrance fees to the restaurants of your choice. Review the amounts for each restaurant.',
    'entranceFee.warningForm': `Fullfill all the mandatory fields of the entrance fee before activating it on a restaurant.`,
    'entranceFee.default': 'By default',
    'entranceFee.code': 'Entrance fee code',
    'entranceFee.codeAlreadyUsed': 'Entrance fee code already used',
    'entranceFee.labelTicket': 'Ticket label',
    'entranceFee.amount': 'Amount',
    'entranceFee.vat': 'Vat',
    'entranceFee.strategy': 'Strategy',
    'entranceFee.dailyLimit': 'Max uses per day',
    'entranceFee.type': 'Sales',
    'entranceFee.select.always': 'Daily limit',
    'entranceFee.select.daily': 'Daily limit + products',
    'entranceFee.select.salesExcluded': 'Excluded',
    'entranceFee.select.salesIncluded': 'Included',
    'entranceFee.emptyMessage': 'No entrance fees affiliated with this brand.',
    'entranceFee.tableCard.title': 'Entrance Fees',
    'entranceFee.tableCard.subtitle': 'Create and manage entrance fees used by your restaurants',
    'entranceFee.tableCard.action': '+ Create a new entrance fee',
    'entranceFee.table.state': 'State',
    'entranceFee.table.services': 'Enabled shifts',
    'entranceFee.table.state.enabled': 'Enabled',
    'entranceFee.table.state.customised': 'Enabled with custom values',
    'entranceFee.table.state.disabled': 'Disabled',
    'entranceFee.restaurants': 'Restaurants',
    'entranceFee.restaurant': 'Restaurant',
    'entranceFee.action': 'Action',
    'entranceFee.modal.warning': 'Warning',
    'entranceFee.modal.confirmDelete': 'Are you sure you want to delete?',
    'entranceFee.search': 'Entrance fee search',

    'entranceFee.configuration.title': `Specific application of the entrance fee - {name}`,
    'entranceFee.configuration.header.title': 'Manage the shifts of the restaurant',
    'entranceFee.configuration.search': 'Find shift',
    'entranceFee.configuration.table.activation': 'Activation',
    'entranceFee.configuration.table.name': 'Shift Name',
    'entranceFee.configuration.table.time': 'Schedules',
    'entranceFee.configuration.table.days': 'Period',
    'entranceFee.configuration.table.amount': 'Amount',
    'entranceFee.configuration.table.vat': 'VAT',
    'entranceFee.configuration.table.defaultShift': 'Default Shift',

    'entranceFee.warningShifts.title': 'Edit confirmation',
    'entranceFee.warningShifts.shift': 'Shift: {time} - Amount: {amount} - Variation: {variation}',
    'entranceFee.warningShifts.shift.amount': '\nAmount: {amount}',
    'entranceFee.warningShifts.confirm': 'Are you sure you want to continue?',

    // Grant
    'grant.create': 'Create grant',
    'grant.title': 'Grant',
    'grant.description': 'Indicate the amount and application rules of the grant for all of your restaurants.',
    'grant.description.title1': '1st strategy: daily limit + minimum amount',
    'grant.customUse': 'Special grant applications',
    'grant.descCustomUse': 'Apply grant to the restaurants of your choice. Review the amounts for each restaurant.',
    'grant.warningLimit': '⚠️ The custom daily limit cannot be higher than the default one.',
    'grant.warningForm': `Fullfill all the mandatory fields of the grant form before activating it on a restaurant.`,
    'grant.desc1': `The 15,00 € grant is only applied if:
    Today, the customer has not used this grant 3.65 times
        AND if the amount of the order exceeds 15,00 €.`,
    'grant.description.title2': '2nd strategy: daily limit + minimum amount + granted products',
    'grant.desc2': `The 15,00 € grant is only applied if:
    Today, the customer has not used this grant 3.65 times
    AND if the amount of the order exceeds AND if the cart contains at least 1 grantable product`,
    'grant.amount': 'Amount',
    'grant.default': 'Default values',
    'grant.code': 'Grant Code',
    'grant.codeAlreadyUsed': 'Grant Code already used',
    'grant.strategy': 'Strategy',
    'grant.dailyLimit': 'Daily limit',
    'grant.type': 'Amount type',
    'grant.tags': 'Apply only to product with tags:',
    'grant.tags.placeholder': 'SUB1, SUB2',
    'grant.labelTicket': 'Ticket Label',
    'grant.select.rate': 'Percentage',
    'grant.select.absolute': 'Absolute',
    'grant.select.minimum': 'Daily limit + minimum amount',
    'grant.select.minimumAndProduct': 'Daily limit + minimum amount + granted products',
    'grant.threshold': 'Threshold',
    'grant.ceiling': 'Grant ceiling',
    'grant.restaurants': 'Restaurants',
    'grant.action': 'Action',
    'grant.emptyMessage': 'No grants affiliated with this brand.',
    'grant.tableCard.title': 'Grants',
    'grant.tableCard.subtitle': 'Create and manage grants used by your restaurants',
    'grant.tableCard.action': '+ Add a new grant',
    'grant.settings.button': 'Settings',
    'grant.settings.modal.title': 'Grant settings',
    'grant.settings.modal.subtitle': 'Configure rules applied to grants for this brand.',
    'grant.settings.modal.toggle.label': 'Block luncheon voucher payment when a grant is applied',
    'grant.settings.modal.toggle.description':
        'When enabled, luncheon voucher payment methods (Edenred, Paygreen) become unavailable for guests whose cart contains a grant, in online ordering (CELV2).',
    'grant.settings.modal.cancel': 'Cancel',
    'grant.settings.modal.save': 'Save',
    'grant.table.enabled': 'Activate',
    'grant.table.state': 'Enable state',
    'grant.table.restaurant': 'Restaurant',
    'grant.table.services': 'Enabled shifts',
    'grant.table.state.enabled': 'Enabled',
    'grant.table.state.customised': 'Enabled with custom values',
    'grant.table.state.disabled': 'Disabled',
    'grant.table.threshold': 'Threshold',
    'grant.table.ceiling': 'Ceiling',
    'grant.table.dailyLimit': 'Daily limit',
    'grant.table.strategy': 'Strategy',
    'grant.table.action': 'Action',
    'grant.modal.warning': 'Warning',
    'grant.modal.confirmDelete': 'Are you sure you want to delete?',
    'grant.search': 'Grant search',

    'grant.configuration.title': 'Specific application of the grant - {name}',
    'grant.configuration.header.title': 'Manage the shifts of the restaurant',
    'grant.configuration.search': 'Find shift',
    'grant.configuration.table.activation': 'Activation',
    'grant.configuration.table.name': 'Shift name',
    'grant.configuration.table.time': 'Schedules',
    'grant.configuration.table.days': 'Period',
    'grant.configuration.table.amount': 'Amount',
    'grant.configuration.table.threshold': 'Threshold',
    'grant.configuration.table.ceiling': 'Ceiling',
    'grant.configuration.table.defaultShift': 'Default Shift',

    'grant.warningShifts.title': 'Edit confirmation',
    'grant.warningShifts.shift': '{time} - Amount: {amount} - Variation: {variation}',
    'grant.warningShifts.shift.amount': '\nAmount: {amount}',
    'grant.warningShifts.confirm': 'Are you sure you want to continue?',

    // Groups
    'group.tableCard.title': 'Groups',
    'group.tableCard.action': '+ Create a New Group',
    'group.tableCard.subtitle': 'Define guest grouping options by group and associate the corresponding pricing rules.',
    'group.tableCard.subtitle2': 'Define here the different possibilities of grouping your guests.',
    'group.emptyMessage': 'No groups affiliated with this brand.',
    'group.action': 'Action',
    'group.name': 'Group',
    'group.pricingRules': 'Pricing rules',
    'group.guestsCount': 'Number of guest(s)',
    'group.guestsCountLabel': 'guest(s)',
    'group.modal.warning': 'Warning',
    'group.modal.confirmDelete': 'Are you sure you want to delete?',
    'group.modal.deleteError': "You can't delete this group",
    'group.modal.deleteErrorReason': 'Disassociate the guest(s) to finalize this removal.',
    'group.warning.group_name_already_exist.message': 'Guest group name already exists.',
    'group.warning.group_name_already_exist.description':
        'Please propose a new group name or associate the selected pricing rule(s) with the existing group.',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.message':
        'One or more pricing rules that you want to dissociate from the current group are assigned to existing guests.',
    'group.warning.pricing_rule_is_always_assigned_to_a_guest_in_this_group.description':
        'Please deassign these pricing rules from existing guests before you can remove them from the list of available pricing rules for the group.',
    'group.modal.import.title': 'Import Groups, Sections, Subsections and Pricing Rules',
    'group.modal.import.firstPart': 'Download the {fileTemplate} to your computer',
    'group.modal.import.secondPart':
        'Fill in the template file with the information for your groups, sections, subsections and pricing rules to add or modify',
    'group.modal.import.thirdPart': 'Import your new file by clicking the button below',
    'group.modal.import.warning':
        'Deleting a group, section, subsection or pricing rule can only be done from the Innovorder back office',
    'group.modal.import.report.title': 'Import report',
    'group.export.group': 'Group',
    'group.export.section': 'Section',
    'group.export.subsection': 'Subsection',
    'group.export.pricingRule': 'Pricing rules',
    'group.modal.conflict.error.message': 'You can not update this group',
    'group.modal.conflict.error.description': 'Please reassign the students before updating this group',
    'group.modal.conflict.export.button': 'Export customers',
    'group.modal.import.report.groups': 'Groups',
    'group.modal.import.report.sections': 'Sections',
    'group.modal.import.report.subsections': 'Subsections',
    'group.modal.import.report.successMessage': 'created: {created}, updated: {updated}',
    'group.modal.import.report.errorMessage': '• Line {line} - column {field}: {message}',
    'group.delete.modal.conflict.error.message': 'You cannot delete this group',
    'group.delete.modal.conflict.error.description': 'Please reassign the students before deleting this group',
    'group.delete.modal.conflict.export.button': 'Export customers',

    'groups.export.student.customerId': 'Client ID',
    'groups.export.student.email': 'Email',
    'groups.export.student.password': 'Password',
    'groups.export.student.firstName': 'First name',
    'groups.export.student.lastName': 'Last name',
    'groups.export.student.phone': 'Phone',
    'groups.export.student.piCode': 'Pin code',
    'groups.export.student.badgeNumber': 'Badge number',
    'groups.export.student.studentNumber': 'Student number',
    'groups.export.student.group': 'Group',
    'groups.export.student.section': 'Section',
    'groups.export.student.subSection': 'Subsection',
    'groups.export.student.accountType': 'Account type',
    'groups.export.student.tariffCode': 'Tariff code',
    'groups.export.student.grantCode': 'Grant code',
    'groups.export.student.entranceFeeCode': 'Entrance fee code',
    'groups.export.student.pricingRuleCode': 'Pricing rule code',
    'groups.export.student.ewalletOverdraftAmount': 'Custom overdraft amount',
    'groups.export.student.exitDate': 'Archive date',
    'groups.export.student.accessFrom': 'Arrival date',
    'groups.export.student.accessUntil': 'Departure date',
    'groups.export.student.inactive': 'Inactive',
    'groups.export.student.active': 'Active',
    'groups.export.student.yes': 'Yes',
    'groups.export.student.no': 'No',

    // Sectionss
    'section.tableCard.title': 'Sections',
    'section.tableCard.subtitle':
        'Define guest grouping options by section and associate the corresponding pricing rules.',
    'section.tableCard.action': '+ Create a New Section',
    'section.name': 'Section',
    'group.warning.section_name_already_exist.message': 'The section name already exists.',
    'group.warning.section_name_already_exist.description':
        'Please propose a new section name or associate the selected pricing rule(s) with the existing section.',
    'section.modal.conflict.error.message': 'You can not update this section',
    'section.modal.conflict.error.description': 'Please reassign the students before updating this section',
    'section.delete.modal.conflict.error.message': 'You cannot delete this section',
    'section.delete.modal.conflict.error.description': 'Please reassign the students before deleting this section',

    // SubSections
    'subsection.tableCard.title': 'Sub-sections',
    'subsection.tableCard.subtitle':
        'Define guest grouping by sub-section and the associated pricing rules for each sub-section.',
    'subsection.tableCard.action': '+ Create a New Sub-section',
    'subsection.name': 'Sub-section',
    'group.warning.sub_section_name_already_exist.message': 'The sub-section name already exists.',
    'group.warning.sub_section_name_already_exist.description':
        'Please propose a new sub-section name or associate the selected pricing rule(s) with the existing sub-section.',
    'subsection.modal.conflict.error.message': 'You can not update this sub-section',
    'subsection.modal.conflict.error.description': 'Please reassign the students before updating this sub-section',
    'subsection.delete.modal.conflict.error.message': 'You cannot delete this sub-section',
    'subsection.delete.modal.conflict.error.description':
        'Please reassign the students before deleting this sub-section',

    // options
    'options.main': 'Main options',
    'options.educationMode': 'Collective catering',
    'options.birthdate': 'Birthday date',
    'options.tripAdvisorUsername': 'Tripadvisor Id',
    'options.advancedSecurityRules': 'Activate the password 12 chars length',
    'options.optIn': 'Opt-in',
    'options.productionDeclaration': 'Production declaration',
    'options.grantsAndEntranceFee': 'Grants and entrance fees',
    'options.pinCodeDoubleAuth': 'Use pin code to secure badge authentication on kiosk',
    'options.charlemagneExport': 'Export data for Charlemagne',
    'options.handleBadgeForChar': 'Handle only the last 4 characters on badge search"',
    'options.autoBilling': 'Activate the "auto billing" module',
    'options.linkProductImageBySku': 'Automatically link images whose names contain product SKU (during importing)',
    'options.externalIdsMapping': 'Activate ids translation',
    'options.ewalletAutoReload': 'Activate E-wallet autoreloader (via Stripe)',
    'options.foodCourt': 'Webordering v2 - Food Court',
    'options.foodCourtMode': 'Activate food court mode',
    'options.shuffleRestaurants': 'Randomize the display order of restaurants',
    'options.enableSodexoDictionary': 'Activer le dictionnaire Sodexo',
    'options.enableOrderDetailV2': 'Enable order detail V2',
    'options.usePickupPoints': 'Enable pickup points',
    'options.linkProductSkuToExternalMapping': 'Automatically link product SKU to external mapping',
    'options.linkStudentNumberToExternalMapping': 'Automatically link guest number to external mapping',
    'options.multiRestaurant': 'Kiosk - Multi Restaurant',
    'options.multiRestaurantMode': 'Activate multi-restaurant mode',
    'options.multiRestaurantModeMainRestaurant': 'Main Restaurant',
    'options.multiRestaurantModeMainUser': 'Kiosk User',
    'options.multiRestaurantModeAssignedRestaurants': 'Assigned Restaurants',
    'options.enableLinkingMenuToPosAndWeb': 'Enable linking the menu with both POS and Web',
    'options.configureSodexoConsumerTransaction': 'Enable Sodexo consumertransactions webhooks',
    'options.families': 'Families',
    'options.families.empty': 'No families',
    'options.families.new': 'New family',
    'options.families.namePlaceholder': 'Name',
    'options.families.add': 'Add',
    'options.families.delete': 'Delete',
    'options.families.deleteTitle': 'Confirm deletion of family {name}',
    'options.families.deleteConfirmation': 'Are you sure you want to delete the family "{name}"?',

    // Brand Info
    'brandInfo.title': 'Information',
    'brandInfo.ewalletOverdraft.title': 'E-wallet Overdraft',
    'brandInfo.ewalletOverdraft.description':
        'Allow customers to have a negative balance on their e-wallet up to the specified amount.',
    'brandInfo.ewalletOverdraft.enable': 'Enable e-wallet overdraft',
    'brandInfo.ewalletOverdraft.amount': 'Maximum overdraft amount',
    'brandInfo.ewalletOverdraft.amountPlaceholder': '0.00',
    'brandInfo.ewalletOverdraft.cannotDisable':
        'Cannot disable overdraft: {count} customer(s) currently have post-payment enabled.',

    // Restaurant
    'restaurant.search': 'Restaurant search',
    'restaurant.name': 'Restaurant name',
    'restaurant.options.main': 'Main options',
    'restaurant.options.includeDepositsInTurnover': 'Include deposits in turnover',

    // admin banner
    'adminBanner.message': 'You are logged in as',
    'adminBanner.backToAdmin': 'Back to admin',

    // auto billing
    'auto.billing.buttons.referential': 'Referential',
    'auto.billing.buttons.billing': 'Request billing',
    'auto.billing.request.card.title': 'Request billing',
    'auto.billing.request.card.subtitle':
        'The automatic invoicing module allows you to group together all the consumption of the guests assigned to a company in order to calculate (according to the rules set) the turnover and the collected for account of each company',
    'auto.billing.request.wizard.validate': 'Terminate',
    'auto.billing.request.wizard.title': 'Make a billing request',
    'auto.billing.request.card.action': 'Make a billing request',
    'auto.billing.request.popup.confirm.title': 'Make a billing request',
    'auto.billing.request.popup.confirm.text': 'Could you confirm this action?',
    'auto.billing.request.popup.success.title': 'Your billing request is validated',
    'auto.billing.request.popup.fail.title': 'Error',
    'auto.billing.request.popup.pending.title': 'Loading...',
    'auto.billing.request.popup.success.cancel': 'Close',
    'auto.billing.request.popup.success.text': 'You have successfully made a billing request',
    'auto.billing.request.popup.fail.text': 'Some problem occurred retry later',
    'auto.billing.request.preview.emptyMessage': 'No sales in selected period',
    'auto.billing.request.preview.errorUndefinedReferential': 'No referential is defined, fill it and try again',
    'auto.billing.request.preview.error': 'Some problem occurred retry later',
    'auto.billing.request.preview.code': 'Code',
    'auto.billing.request.preview.label': 'Label',
    'auto.billing.request.preview.quantity': 'Quantity',
    'auto.billing.request.preview.unitPriceWithTaxExcluded': 'Unit price with tax excluded',
    'auto.billing.request.preview.totalPriceWithTaxExcluded': 'Total price with tax excluded',
    'auto.billing.request.preview.totalTax': 'Total tax',
    'auto.billing.request.preview.totalPriceWithTaxIncluded': 'Total price with tax included',
    'auto.billing.request.preview.cdpf': 'Emitting CDPF',
    'auto.billing.request.preview.clientCode': 'Client code',
    'auto.billing.request.preview.clientLabel': 'Client label',
    'auto.billing.request.preview.billingPeriod': 'Billing period',
    'auto.billing.request.preview.billingPeriod.from': 'From',
    'auto.billing.request.preview.billingPeriod.to': 'To',
    'auto.billing.request.preview.invoiceSelector.GROUP': 'Group',
    'auto.billing.request.preview.invoiceSelector.ACCOUNT_PAYMENT_TYPE': 'Account payment type',
    'auto.billing.request.preview.invoiceSelector.PRICING_RULE': 'Pricing rule',
    'auto.billing.request.preview.total.amountWithTaxIncluded': 'Total amount with tax included',
    'auto.billing.request.preview.total.amountWithTaxExcluded': 'Total amount with tax excluded',
    'auto.billing.request.preview.total.tax': 'Total tax',
    'auto.billing.request.filter.title': 'Filters',
    'auto.billing.request.filter.entities.title': 'ENTITIES CHOICE',
    'auto.billing.request.filter.entities.all': 'All entities',
    'auto.billing.request.filter.restaurants.title': 'RESTAURANTS CHOICE',
    'auto.billing.request.filter.dropDown.errorMessage': 'You must select at least one option',
    'auto.billing.request.filter.restaurants.all': 'All restaurants',
    'auto.billing.request.filter.pricingRules.title': 'PRICING RULES',
    'auto.billing.request.filter.pricingRules.all': 'All pricing rules',
    'auto.billing.request.filter.pricingRules.noPricingRules': 'No pricing rules',
    'auto.billing.request.accountPaymentTypes.title': 'ACCOUNT PAYMENT TYPES',
    'auto.billing.request.filter.accountPaymentTypes.all': 'All account payment types',
    'auto.billing.request.accountPaymentTypes.CASH': 'Cash',
    'auto.billing.request.accountPaymentTypes.PREPAYMENT': 'Pre-payment',
    'auto.billing.request.accountPaymentTypes.POSTPAYMENT': 'Post-payment',
    'auto.billing.request.history.table.emptyMessage': 'No billing history',
    'auto.billing.request.history.table.date': 'Generation date',
    'auto.billing.request.history.table.period': 'Period',
    'auto.billing.request.history.table.user': 'User',
    'auto.billing.request.history.table.previewButton': 'Preview',
    'auto.billing.request.history.table.downloadButton': 'Download',
    'auto.billing.referential.serviceCodes.card.title': 'Codes prestations',
    'auto.billing.referential.serviceCodes.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.table.label': 'Label',
    'auto.billing.referential.billingEntities.table.code': 'Code',
    'auto.billing.referential.billingEntities.table.groups': 'Associated groups',
    'auto.billing.referential.billingEntities.table.groupingBy': 'Grouping by',
    'auto.billing.referential.billingEntities.table.emptyMessage': 'No billing entity is defined for this brand',
    'auto.billing.referential.billingEntities.card.title': 'Billing entities',
    'auto.billing.referential.billingEntities.card.subtitle': ' ',
    'auto.billing.referential.billingEntities.add': '+ Add new Entity',
    'auto.billing.referential.billingEntities.form.create.title': 'Add new billing entity',
    'auto.billing.referential.billingEntities.form.create.subtitle':
        'Texte expliquant la création des entités de facturation et ce qu’il est possible de faire en les paramètrants, texte de deux lignes',
    'auto.billing.referential.billingEntities.costCompute.title': 'Cost compute',
    'auto.billing.referential.billingEntities.costCompute.subtitle':
        'Texte expliquant les modes de calcul et ce qu’il est possible de faire en les paramètrants, texte de deux lignes',
    'auto.billing.referential.billingEntities.form.label.title': 'LABEL',
    'auto.billing.referential.billingEntities.form.code.title': 'CODE',
    'auto.billing.referential.billingEntities.form.code.text': 'CODE',
    'auto.billing.referential.billingEntities.form.groups.text': 'TARGET',
    'auto.billing.referential.billingEntities.form.groupingBy.title': 'GROUPING BY',
    'auto.billing.referential.billingEntities.form.groupingBy.options.PRICING_RULE': 'Pricing rule',
    'auto.billing.referential.billingEntities.form.groupingBy.options.BILLING_ENTITY': 'Without ventilation',
    'auto.billing.referential.billingEntities.form.groupingBy.options.GROUP': 'Group',
    'auto.billing.referential.billingEntities.form.groupingBy.options.ACCOUNT_PAYMENT_TYPE': 'Account payment type',
    'auto.billing.referential.billingEntities.errors.duplicate.code':
        'The following code "{code}" already associated with "{entity}" billing entity',
    'auto.billing.referential.billingEntities.errors.duplicate.group':
        'The flowing groups ({groups}) already associated with "{entity}" billing entity',
    'auto.billing.referential.serviceCodes.perceivedAmountCode.label': 'PERÇU POUR COMPTE',
    'auto.billing.referential.serviceCodes.admissionLevelCostCode.label': 'BILLING BY ADMISSION SLICE',
    'auto.billing.referential.serviceCodes.fixedCostCode.label': 'BILLING BY FIXED COST',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.card.title': 'Perceived amount code',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.code.label': 'Code',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.vat.label': 'VAT',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.add': '+ Add new code',
    'auto.billing.referential.serviceCodes.perceivedAmountCodes.emptyMessage': 'No code defined',
    'auto.billing.referential.accountingCostCompute.constantCost': 'Billing by constant cost',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.constantCost': 'Constant Cost',
    'auto.billing.referential.accountingCostCompute.costSlicesMode.summedUpByAdmissionFeesAmount':
        'Summed up by admission fees amount',
    'auto.billing.referential.accountingCostCompute.modal.sliceFrom': 'SLICE FROM',
    'auto.billing.referential.accountingCostCompute.modal.to': 'To',
    'auto.billing.referential.accountingCostCompute.modal.constantCost': 'CONSTANT COST',
    'auto.billing.referential.accountingCostCompute.modal.summedUpByAdmissionFeesAmount':
        'SUMMED UP BY ADMISSION FEES AMOUNT',
    'auto.billing.referential.accountingCostCompute.modal.billingMode': 'BILLING MODE',
    'auto.billing.referential.accountingCostCompute.modal.title': 'Add new slice',
    'auto.billing.referential.accountingCostCompute.modal.input.maxLowerThanOrEqualToMin':
        'Slice max must be greater than min',
    'auto.billing.referential.accountingCostCompute.modal.input.intersection':
        'This slice intersect with [{from} - {to}]',
    'auto.billing.referential.accountingCostCompute.modal.input.negative': 'Value must be positive',
    'auto.billing.referential.accountingCostCompute.partitionedConstantCost': 'Billing by partitioned constant cost',
    'auto.billing.referential.accountingCostCompute.summedUpByAdmissionFeesAmount':
        'Billing by summed up by admission fees amount',
    'auto.billing.referential.accountingCostCompute.partitionedCostByGuest': 'XXXX',
    'auto.billing.referential.accountingCostCompute.addSlice': '+ Add slice',
    'auto.billing.referential.accountingCostCompute.amount': 'Amount with tax',
    'auto.billing.filters.entity': 'Billing entity',
    'auto.billing.referential.accountingGroups.code.text': "XXXX GROUP'S CODE",
    'auto.billing.referential.accountingGroups.costCompute.slice.table.to': 'to',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.range': 'Guests count',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.mode': 'Billing mode',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.value': 'Values',
    // Routes
    'route.brands': 'Brands',
    'route.brandInfo': 'Informations',
    'route.brandInfoV2': 'Informations',
    'route.brandMedias': 'Medias',
    'route.configIOPay': 'Configure Adyen',
    'route.configEdenred': 'Configure Edenred',
    'route.configPaygreen': 'Configure Paygreen',
    'route.integrations': 'Integrations',
    'route.stripeIntegration': 'Stripe',
    'route.grantsAndEntranceFees': 'Grants and entrance fees',
    'route.services': 'Services',
    'route.createShift': 'New service',
    'route.editShift': 'Edit service',
    'route.options': 'Options',
    'route.brandHistory': 'History',
    'route.groups': 'Hierarchy',
    'route.brandChannels': 'Channels',
    'route.brandMenus': 'Menus',
    'route.brandMenu': 'Informations',
    'route.brandRestaurants': 'Restaurants',
    'route.brandUsers': 'Users',
    'route.billing': 'My billing space',
    'route.home': 'Home',
    'route.pricingRule': 'Pricing rule',
    'order.field.pricingRuleInOrder': 'Pricing rule in order',
    'route.logout': 'Log out',
    'route.configUbereats': 'Uber Eats integration',
    'route.configDeliveroo': 'Deliveroo integration',
    'route.configDeliverect': 'Deliverect integration',
    'route.configCrous': 'Crous Integration',
    'route.createGrant': 'Create grant',
    'route.grant': 'Grant',
    'route.createEntranceFee': 'Create entrance fee',
    'route.entranceFee': 'Entrance fee',
    'route.createPricingRule': 'Create Pricing rule',
    'route.analytics': 'Analytics',
    'route.restaurantIntegration': 'Integration',
    'route.autoBilling': 'Automatic billing',
    'route.autoBilling.referential': 'Referential',
    'route.autoBilling.request': 'Billing request',
    'route.autoBilling.referential.createEntity': 'Create new billing entity',
    'route.autoBilling.referential.editEntity': 'Edit billing entity',
    'route.orders': 'Orders',
    'route.orderDetails': 'Order details',
    'route.restaurantInfo': 'Information',
    'route.restaurantChannels': 'Channels',
    'route.restaurantUsers': 'Users',
    'route.restaurantMenus': 'Menus',
    'route.restaurantMenu': 'Informations',
    'route.restaurantTickets': 'Tickets',
    'route.restaurantMedias': 'Media',
    'route.restaurantIntegrations': 'Integrations',
    'route.restaurantPayments': 'Payment methods',
    'route.restaurantOptions': 'Options',
    'route.restaurantPricingRevaluation': 'Pricing revaluation',
    'route.tableLayout': 'Tables Layouts',
    'route.tableLayout.room': 'Rooms',
    'route.createGroup': 'New group',
    'route.createSection': 'New section',
    'route.createSubSection': 'New sub-section',
    'route.editGroup': 'Edit group',
    'route.editSection': 'Edit section',
    'route.editSubSection': 'Edit sub-section',
    'route.adminTools': 'Admin tools',
    'route.menus': 'Menus',
    'route.menuOperations': 'Menu imports',
    'route.posLayout': 'POS Layout',
    'route.categories': 'Categories',
    'route.products': 'Products',
    'route.steps': 'Steps',
    'route.tags': 'Tags',
    'route.functions': 'Functions',
    'route.brandCustomer': 'Customers',
    'route.brandOrders': 'Orders',
    'route.crossSelling': 'Cross-selling',
    'route.salesSummary': 'Sales Summary',
    'route.tickets': 'Tickets',
    'route.reportStatus': 'Report status',
    'route.pos': 'POS',
    'route.posConfiguration': 'Configuration',
    'route.posDevices': 'Devices',
    'route.posAccess': 'Access',
    'route.posAccess.users': 'POS users',
    'route.posAccess.roles': 'POS roles',
    'route.posAccess.groups': 'POS groups',
    'route.accessFlags': 'Authorizations',
    'route.userRestaurants': 'Associated restaurants',
    'route.updateUserPassword': 'Change password',
    'route.userInfo': 'Info',
    'route.badgeReader': 'Badge readers',
    'route.posDeviceInformation': 'Device information',
    'route.posDeviceConfiguration': 'Configuration',
    'route.posDeviceAdditionalDevices': 'Peripherals',
    'route.posDeviceArchives': 'Fiscal Archives',
    'route.posDeviceFeatures': 'Features',
    'route.posDevicePreferences': 'Preferences',
    'route.posDeviceCatalogHistory': 'Catalog History',
    'route.listCustomers': 'Customers',
    'route.customerSettings': 'Settings',
    'route.customerPricingRules': 'Pricing rules',
    'route.splioLoyaltyIntegration': 'Splio',
    'route.pickupPoints': 'Pickup points',
    'route.comoLoyaltyIntegration': 'Como',
    'route.zerosixLoyaltyIntegration': 'Zerosix',
    'route.operationZones': 'Operation zone',
    'route.createBrandWebhook': 'Create a webhook',
    'route.editBrandWebhook': 'Edit a webhook',

    // Operation Zones
    'operationZones.page.title': 'Operation zone',
    'operationZones.page.description':
        'Define the territories where your brand operates. A primary zone must be designated for the legal entity of reference.',
    'operationZones.emptyState': 'No zone selected',
    'operationZones.emptyState.description':
        'Select one or more territories from the list below to define your operation zones.',
    'operationZones.availableTerritories': 'Available territories',
    'operationZones.selectedCount': '{count} selected',
    'operationZones.solution': 'Solution',
    'operationZones.warning.title': 'Incomplete configuration',
    'operationZones.warning.description':
        '{count, plural, one {{count} selected zone needs to be configured to be operational.} other {{count} selected zones need to be configured to be operational.}}',
    'operationZones.warning.hint': 'Please complete the legal and technical information via the "Configure" button.',
    'operationZones.immutabilityNotice':
        'The operation zone cannot be modified after the restaurant is created. <supportLink>Contact support</supportLink> if needed.',
    'operationZones.primaryZone': 'PRIMARY ZONE',
    'operationZones.setPrimary.disabled': 'Configure this zone before setting it as primary',
    'operationZones.cannotRemoveLastZone': 'A restaurant must have at least one operation zone',
    'operationZones.primaryBadge': 'PRIMARY',
    'operationZones.secondaryZonesActive': '+ {count} ACTIVE SECONDARY {count, plural, one {ZONE} other {ZONES}}',
    'operationZones.configure': 'Configure',
    'operationZones.viewVatRates': 'View VAT rates',
    'operationZones.toConfigure': 'To configure',
    'operationZones.entity': 'Entity',
    'operationZones.vat': 'VAT',
    'operationZones.posConfig': 'POS Configuration',
    'operationZones.notFilled': 'Not filled in',
    'operationZones.pending': 'Pending',
    'operationZones.initialized': 'Initialized',
    'operationZones.configured': 'Configured',
    'operationZones.noPosDevice': 'Create a POS before configuring this zone',
    'operationZones.configModal.title': 'Configuration: {zoneName}',
    'operationZones.configModal.subtitle': 'Legal and fiscal settings ({code})',
    'operationZones.configModal.entitySection': 'Entity information',
    'operationZones.configModal.socialReason': 'Company name',
    'operationZones.configModal.address': 'Address',
    'operationZones.configModal.postalCode': 'Postal code',
    'operationZones.configModal.city': 'City',
    'operationZones.configModal.vatNumber': 'VAT number',
    'operationZones.configModal.siret': 'SIRET',
    'operationZones.configModal.save': 'Save',
    'operationZones.configModal.socialReason.placeholder': 'Ex: Restaurant SARL',
    'operationZones.configModal.address.placeholder': '123 Main Street ...',
    'operationZones.configModal.postalCode.placeholder': '75000',
    'operationZones.configModal.city.placeholder': 'Paris',
    'operationZones.configModal.vatNumber.placeholder': 'Ex: FR 12 345678901',
    'operationZones.configModal.siret.placeholder': 'Ex: 522 296...',
    'operationZones.multiProvider': 'Multiple options',
    'operationZones.configModal.nifCif': 'NIF / CIF',
    'operationZones.configModal.nifCif.placeholder': 'Ex: B12345678',
    'operationZones.configModal.fiscalRepresentative': 'Fiscal representative',
    'operationZones.configModal.fiscalRepresentative.placeholder': 'Fiscal representative name',
    'operationZones.configModal.fiscalIdCode': 'Fiscal identification code',
    'operationZones.configModal.fiscalIdCode.placeholder': 'Ex: RSSMRA85T10A562S',
    'operationZones.configModal.vatNumberBtw': 'VAT number (BTW)',
    'operationZones.configModal.vatNumberBtw.placeholder': 'Ex: BE 0123.456.789',
    'operationZones.configModal.enterpriseNumber': 'Enterprise number',
    'operationZones.configModal.enterpriseNumber.placeholder': 'Ex: 0123.456.789',
    'operationZones.configModal.if': 'IF',
    'operationZones.configModal.if.placeholder': 'Ex: 12345678',
    'operationZones.configModal.ice': 'ICE',
    'operationZones.configModal.ice.placeholder': 'Ex: 001234567000045',
    'operationZones.configModal.selectProvider': 'Select compliance mode',
    'operationZones.configModal.fiskaltrust': 'Fiskaltrust',
    'operationZones.configModal.fiskaltrustDescription': 'Fiscal compliance middleware for cash register',
    'operationZones.configModal.noIntegration': 'No integration',
    'operationZones.configModal.noIntegrationDescription': 'No fiscal middleware will be configured',
    'operationZones.configModal.nf525': 'NF525',
    'operationZones.configModal.nf525Description': 'French fiscal compliance certification',
    'operationZones.configModal.boiteNoire': 'Boîte Noire',
    'operationZones.configModal.boiteNoireDescription': 'Belgian fiscal compliance module',
    'operationZones.configModal.middlewareSection': 'Middleware Configuration (Fiskaltrust)',
    'operationZones.configModal.cashboxId': 'Cashbox ID',
    'operationZones.configModal.cashboxId.placeholder': 'Ex: a1b2c3d4-...',
    'operationZones.configModal.accessToken': 'Access Token',
    'operationZones.configModal.accessToken.placeholder': 'Ex: AZE123...',
    'operationZones.configModal.back': 'Back',
    'operationZones.deactivate.title': 'Deactivate operation zone',
    'operationZones.deactivate.message':
        'Are you sure you want to deactivate this operation zone? All configured information (legal entity, tax settings, POS configuration) will be lost.',

    // Admin tools
    'adminTools.confirmModal.description': 'Are you sure to confirm this action?',
    'brand.adminTools.editCustomerLoyalties.title': 'Add/remove loyalty IO to a customer of this brand',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.emailsOrCards': 'name@domain.com or A1B2C3D4E5',
    'brand.adminTools.editCustomerLoyalties.form.placeholder.loyaltyAmountToAdd': '400 for 4€',
    'brand.adminTools.editCustomerLoyalties.form.emailsOrCards': 'Customer email or loyalty card number',
    'brand.adminTools.editCustomerLoyalties.form.loyaltyAmountToAdd': 'Amount',
    'brand.adminTools.editCustomerLoyalties.form.error': 'An error occured while running this script.',
    'brand.adminTools.editCustomerLoyalties.form.success': 'The script ran successfully.',
    'brand.adminTools.unarchiveCustomer.title': 'Unarchive customer',
    'brand.adminTools.unarchiveCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.unarchiveCustomer.form.customerId': 'CustomerId to unarchive',
    'brand.adminTools.unarchiveCustomer.form.error': 'An error occured while running this script.',
    'brand.adminTools.unarchiveCustomer.form.success': 'The script ran successfully.',
    'brand.adminTools.deleteTransaction.title': 'Delete transaction',
    'brand.adminTools.deleteTransaction.form.placeholder.transactionId': '1234567',
    'brand.adminTools.deleteTransaction.form.transactionId': 'Transaction to delete',
    'brand.adminTools.deleteTransaction.form.error': 'An error occured while running this script.',
    'brand.adminTools.deleteTransaction.form.success': 'The script ran successfully.',
    'brand.adminTools.addUserToRestaurant.title': 'Add restaurant user to another restaurant from the same brand',
    'brand.adminTools.addUserToRestaurant.form.placeholder.email': 'example@restaurant.com',
    'brand.adminTools.addUserToRestaurant.form.email': 'Email of the user',
    'brand.adminTools.addUserToRestaurant.form.placeholder.restaurantId': '1111',
    'brand.adminTools.addUserToRestaurant.form.restaurantId': 'RestaurantId of the restaurant to add for this user',
    'brand.adminTools.addUserToRestaurant.form.error': 'An error occured while running this script.',
    'brand.adminTools.addUserToRestaurant.form.success': 'The script ran successfully.',
    'brand.adminTools.deleteUnassignedImages.title': 'Delete unassigned images in Medias directory',
    'brand.adminTools.deleteUnassignedImages.description1':
        'Script to clear all unused images (e.g. from products/menus that have since been deleted)',
    'brand.adminTools.deleteUnassignedImages.description2':
        'It is advisable to delete all unnecessary menus from the brand and these restaurants before running this script, so that the cleaning is effective.',
    'brand.adminTools.deleteUnassignedImages.form.error': 'An error occured while running this script.',
    'brand.adminTools.deleteUnassignedImages.form.success': 'The script ran successfully.',
    'brand.adminTools.importGeojsonPolygon.title': 'Import geoJson as delivery area',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.restaurantId': '1234',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.areaName': 'Creteil',
    'brand.adminTools.importGeojsonPolygon.form.placeholder.geoJsonPolygon':
        '[[4.8395748,50.0926849],[4.8393237,50.0926889],[4.8392677,50.0926748]]',
    'brand.adminTools.importGeojsonPolygon.form.restaurantId': 'RestaurantId',
    'brand.adminTools.importGeojsonPolygon.form.areaName': 'Name of the area you want to create',
    'brand.adminTools.importGeojsonPolygon.form.geoJsonPolygon': 'Put geoJson polygon data',
    'brand.adminTools.importGeojsonPolygon.form.error': 'An error occured while running this script.',
    'brand.adminTools.importGeojsonPolygon.form.success': 'The script ran successfully.',
    'brand.adminTools.deleteCustomer.title': 'Delete customer',
    'brand.adminTools.deleteCustomer.description1':
        'Enter the customerId you want to delete (You can enter a comma separated list of customerId, without spaces, like this: 1234567,1234568,1234569)',
    'brand.adminTools.deleteCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.deleteCustomer.form.customerId': 'CustomerId to delete',
    'brand.adminTools.deleteCustomer.form.error': 'An error occured while running this script.',
    'brand.adminTools.deleteCustomer.form.success': 'The script ran successfully.',

    'brand.adminTools.razCustomer.title': 'Raz customer',
    'brand.adminTools.razCustomer.description1':
        'Enter the customerId you want to RAZ (You can enter a comma separated list of customerId, without spaces, like this: 1234567,1234568,1234569)',
    'brand.adminTools.razCustomer.form.placeholder.customerId': '1234567',
    'brand.adminTools.razCustomer.form.customerId': 'CustomerId(s) to RAZ (separated by coma)',
    'brand.adminTools.razCustomer.form.placeholder.brandId': '414',
    'brand.adminTools.razCustomer.form.brandId':
        'BrandId to RAZ (if you enter a brandId, all post-payment customers will be RAZ, customerId(s) field will be ignore)',
    'brand.adminTools.razCustomer.form.placeholder.date': '01/02/2024',
    'brand.adminTools.razCustomer.form.date': 'Date to process the RAZ (hour is 5am), leave empty if RAZ is now',
    'brand.adminTools.razCustomer.form.error': 'An error occured while running this script.',
    'brand.adminTools.razCustomer.form.success': 'The script ran successfully.',

    'brand.adminTools.copySchedules.title': 'Copy restaurant pickup or web schedules',
    'brand.adminTools.copySchedules.form.placeholder.scheduleType': 'pickup or cel',
    'brand.adminTools.copySchedules.form.placeholder.idSource': '900',
    'brand.adminTools.copySchedules.form.placeholder.idsDestination': '901',
    'brand.adminTools.copySchedules.form.scheduleType': 'Type of the schedule you want to copy (enter pickup of cel)',
    'brand.adminTools.copySchedules.form.idSource': 'RestaurantId of the source',
    'brand.adminTools.copySchedules.form.idsDestination':
        'RestaurantId(s) of the destination (You can enter a comma separated list of restaurantIds, without spaces, like this: 901,902,903)',
    'brand.adminTools.copySchedules.form.error': 'An error occured while running this script.',
    'brand.adminTools.copySchedules.form.success': 'The script ran successfully.',

    'brand.adminTools.changeOrderDateInReport.title':
        'Edit the date of an order in the reports (it will also change the date of the transaction)',
    'brand.adminTools.changeOrderDateInReport.form.orderPosId': 'Order number (orderId), can be separated by a comma',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.orderPosId': '1234567,1234568,1234569,...',
    'brand.adminTools.changeOrderDateInReport.form.day': 'Day',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.day': 'example: 14',
    'brand.adminTools.changeOrderDateInReport.form.month': 'Month',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.month': 'example: 7',
    'brand.adminTools.changeOrderDateInReport.form.year': 'Year',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.year': 'example: 2025',
    'brand.adminTools.changeOrderDateInReport.form.hour': 'Hour',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.hour': 'example: 10',
    'brand.adminTools.changeOrderDateInReport.form.minutes': 'Minutes',
    'brand.adminTools.changeOrderDateInReport.form.placeholder.minutes': 'example: 35',
    'brand.adminTools.changeOrderDateInReport.form.error': 'An error occurred while running the script.',
    'brand.adminTools.changeOrderDateInReport.form.success': 'The script has been executed successfully.',

    'brand.adminTools.editPasswordExpiresAt.title': 'Force a brand/customer to edit its password',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.shouldResetPassword': 'force or cancel',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.brandId': '900',
    'brand.adminTools.editPasswordExpiresAt.form.placeholder.customerId': '',
    'brand.adminTools.editPasswordExpiresAt.form.shouldResetPassword':
        'Force to change password (force) or Cancel changing password (cancel)',
    'brand.adminTools.editPasswordExpiresAt.form.brandId': 'Targeted brand',
    'brand.adminTools.editPasswordExpiresAt.form.customerId':
        'Customer(s) targeted (You can enter a comma separated list of customerId, without spaces, like this: 123456,2344567,345678). Leave empty to target the entire brand',
    'brand.adminTools.editPasswordExpiresAt.form.error': 'An error occured while running this script.',
    'brand.adminTools.editPasswordExpiresAt.form.success': 'The script ran successfully.',

    'brand.adminTools.editProductSkuFromProductId.title': 'Edit products SKU from Excel file',
    'brand.adminTools.editProductSkuFromProductId.description': 'Download {fileTemplate} on your machine',
    'brand.adminTools.editProductSkuFromProductId.form.error': 'An error occured while running this script.',
    'brand.adminTools.editProductSkuFromProductId.form.success': 'The script ran successfully.',

    'brand.adminTools.importProductInMenu.title': 'Import products in already created Menu from Excel file',
    'brand.adminTools.importProductInMenu.description': 'Download {fileTemplate} on your machine',
    'brand.adminTools.importProductInMenu.form.error': 'An error occured while running this script.',
    'brand.adminTools.importProductInMenu.form.success': 'The script ran successfully.',

    'brand.adminTools.importBackofficeUsers.title': 'Import backoffice users',
    'brand.adminTools.importBackofficeUsers.description': 'Download {fileTemplate} on your machine',
    'brand.adminTools.importBackofficeUsers.form.error': 'An error occured while running this script.',
    'brand.adminTools.importBackofficeUsers.form.success': 'The script ran successfully.',

    'brand.adminTools.editProductInfoFromProductId.title': 'Edit products from Excel file',
    'brand.adminTools.editProductInfoFromProductId.description1': `Use this {metabaseLink} to have the list of products on your menu, fill in the columns dedicated to edition and upload the file. (Do not change the name of the columns)`,
    'brand.adminTools.editProductInfoFromProductId.description2': 'Download {fileTemplate} on your machine',
    'brand.adminTools.editProductInfoFromProductId.form.error': 'An error occured while running this script.',
    'brand.adminTools.editProductInfoFromProductId.form.success': 'The script ran successfully.',

    'brand.adminTools.editStepInfoFromStepId.title': 'Edit steps from Excel file',
    'brand.adminTools.editStepInfoFromStepId.description0':
        'This script allows you to modify step names, references and labels in bulk, not the product list.',
    'brand.adminTools.editStepInfoFromStepId.description1': `Use this {metabaseLink} to have the list of steps on your menu, fill in the columns dedicated to edition and upload the file. (Do not change the name of the columns)`,
    'brand.adminTools.editStepInfoFromStepId.form.error': 'An error occured while running this script.',
    'brand.adminTools.editStepInfoFromStepId.form.success': 'The script ran successfully.',

    'brand.adminTools.editProductPriceInAdminTools.title': 'Edit products prices (in and out steps) from Excel file',
    'brand.adminTools.editProductPriceInAdminTools.description1': `Use this {metabaseLink} to have the list of products on your menu, fill in the columns dedicated to edition and upload the file. (Do not change the name of the columns)`,
    'brand.adminTools.editProductPriceInAdminTools.description2': 'Download {fileTemplate} on your machine',
    'brand.adminTools.editProductPriceInAdminTools.form.error': 'An error occured while running this script.',
    'brand.adminTools.editProductPriceInAdminTools.form.success': 'The script ran successfully.',

    'brand.adminTools.importProductFromSku.title': 'Edit and import products according to their SKU from Excel file',
    'brand.adminTools.importProductFromSku.description1': `Use this {metabaseLink} to have the list of products on your menu, you can edit or add new products (SKU is not required for new products)`,
    'brand.adminTools.importProductFromSku.description1bis': `Do not edit the SKU of existing products, it's the unique identifier of the product. Do not change the name of the columns`,
    'brand.adminTools.importProductFromSku.description2': 'Download {fileTemplate} on your machine',
    'brand.adminTools.importProductFromSku.form.error': 'An error occured while running this script.',
    'brand.adminTools.importProductFromSku.form.success': 'The script ran successfully.',

    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdSource': 'menuId of the source menu',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdSource': 'MenuId of the source menu',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.menuIdDestination':
        'menuId of the destination menu',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.menuIdDestination': 'MenuId of the destination menu',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterCategory': '(optional)',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterCategory': 'Category filter',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.placeholder.filterTag': '(optional)',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.filterTag': 'Tag filter',
    'brand.adminTools.copyProductFromMenuIdToMenuId.title': 'Copy products from one menu to another',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description1':
        'Enter the source menuId and the destination menuId. You can also filter the products by category and/or tag to copy only certain products.',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description2':
        'Note that external references and steps will not be copied',
    'brand.adminTools.copyProductFromMenuIdToMenuId.description3':
        'And images will only be copied if the destination menu is on the same restaurant as the source menu, or if the source menu is at the brand level and the destination menu is at the restaurant from the same brand',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.error': 'An error occured while running this script.',
    'brand.adminTools.copyProductFromMenuIdToMenuId.form.success': 'The script ran successfully.',

    'brand.adminTools.editProductTagFromProductId.title': 'Add Tag(s) to products from Excel file',
    'brand.adminTools.editProductTagFromProductId.description': 'Download {fileTemplate} on your machine',
    'brand.adminTools.editProductTagFromProductId.form.error': 'An error occured while running this script.',
    'brand.adminTools.editProductTagFromProductId.form.success': 'The script ran successfully.',

    'brand.adminTools.makeEwalletTransaction.title': 'Make E-Wallet transactions from Excel file',
    'brand.adminTools.makeEwalletTransaction.description': 'Download {fileTemplate} on your machine',
    'brand.adminTools.makeEwalletTransaction.form.error': 'An error occured while running this script.',
    'brand.adminTools.makeEwalletTransaction.form.success': 'The script ran successfully.',
    'brand.adminTools.bulkUploadDualScreenImage.title': 'Bulk upload dual screen image for all POS devices of a brand',
    'brand.adminTools.bulkUploadDualScreenImage.description':
        'Upload an image (PNG or JPG) and enter the brandId. The image will be applied to all POS devices of the brand.',
    'brand.adminTools.bulkUploadDualScreenImage.brandIdLabel': 'Brand ID',
    'brand.adminTools.bulkUploadDualScreenImage.brandIdPlaceholder': 'Enter Brand ID',
    'brand.adminTools.bulkUploadDualScreenImage.form.success': 'The image has been uploaded to all POS devices.',
    'brand.adminTools.transformGuestFile.title':
        'Transform your guest database retrieved from the new site into Innovorder format',
    'brand.adminTools.transformGuestFile.fileFormat': 'Original file format',
    'brand.adminTools.transformGuestFile.form.success': 'The file has been successfully transformed',
    'brand.adminTools.transformGuestFile.form.url': 'click here to download the file',
    'brand.adminTools.transformGuestFile.fileFormat.JES': 'JES',
    'brand.adminTools.transformGuestFile.fileFormat.CSI': 'CSI',
    'brand.adminTools.transformGuestFile.fileFormat.X-GIL': 'x-gil',
    'brand.adminTools.transformGuestFile.fileFormat.PI-ELECTRONICS': 'Pi Electronique',
    'brand.adminTools.generateSalesReport.title': 'IO sales report in SI Sodexo',
    'brand.adminTools.generateSalesReport.description':
        'Synchronize IO sales in SI Sodexo for a specific restaurant (if you use a period, the sales will be synchronized for the selected period)',
    'brand.adminTools.generateSalesReport.form.checkbox': 'Use a period',
    'brand.adminTools.generateSalesReport.form.restaurant': 'Select a restaurant',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.title': 'Link products SKUs to external IDs mappings',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.description':
        'Creates mappings between internal productIds and product SKUs for a specific menu',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.restaurant': 'Restaurant',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.menu': 'Menu',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.success': 'The script has been executed successfully.',
    'brand.adminTools.linkProductsSkusToExternalIdsMappings.form.error': 'An error occurred while running the script.',

    // Spotlight
    'spotlight.search.placeholder': 'What do you want to do?',
    'spotlight.section.suggestion': 'Suggestion',
    'spotlight.section.history': 'History',
    'spotlight.context.brand': 'Brand',
    'spotlight.context.restaurant': 'Restaurant',
    'spotlight.error.noHistory': 'You do not yet have an eligible URL that is part of your history',

    // Orders
    'orderList.title': 'Orders',
    'orderList.subtitle': 'Find orders from your customers and friends',
    'orderList.filters.allRestaurants': 'All my restaurants',
    'orderList.filters.restaurantHeader': 'My restaurants',
    'orderList.filters.restaurantPlaceholder': 'Search a restaurant',
    'orderList.filters.dateRange.lastXdays': 'Last {days} days',
    'orderList.filters.dateRange.custom': 'Custom',
    'orderList.generation_history': 'Generations history',
    'orderList.export': 'Export',
    'orderList.generate': 'Generate',
    'orderList.export.title': 'Export',
    'orderList.export.selectOneDay': 'Select a date',
    'orderList.export.selectPeriod': 'Select a range of dates',
    'orderList.export.format': 'Select your export format',
    'orderList.export.file.xlsx': 'Excel',
    'orderList.export.file.csv': 'CSV',
    'orderList.export.file.pdf': 'PDF',
    'orderList.export.dateRage.errorMessage': 'You can’t select more than 31 days',
    'orderList.export.presetDate.currentWeek': 'Current week',
    'orderList.export.presetDate.currentMonth': 'Current month',
    'orderList.export.presetDate.lastMonth': 'Last month',
    'orderList.export.presetDate.chooseDate': 'Please select a period',
    'orderList.export.includeOrderStates': 'Include different orders states',
    'order.field.ticketNumber': 'Ticket number',
    'order.field.status': 'Status',
    'order.field.restaurant': 'Restaurant',
    'order.field.channel': 'Channel',
    'order.field.customerName': 'Customer name',
    'order.field.customerNameMassCatering': 'Guest name',
    'order.field.badgeNumber': 'Badge number',
    'order.field.phone': 'Phone number',
    'order.field.pricingRule': 'Pricing rule',
    'order.field.company': 'Company',
    'order.field.orderId': 'Order number',
    'order.field.consumptionMode': 'Consumption mode',
    'order.field.orderDate': 'Order date',
    'order.field.expectedDate': 'Delivery date',
    'order.field.ticketDate': 'Ticket date',
    'order.field.totalWithVat': 'Total with tax',
    'order.field.turnoverWithVat': 'Turnover with tax',
    'order.field.paymentMethod': 'Payment method',
    'order.field.paymentStatus': 'Payment status',
    'order.field.paymentAmount': 'Payment amount',
    'order.status.PAID': 'Paid',
    'order.status.CANCELLED': 'Cancelled',
    'order.status.VALIDATED': 'Validated',
    'order.status.PAID_CANCELLED': 'Paid (cancelled)',
    'order.status.CONTRA_ENTRY': 'Contra-entry',
    'order.status.INCOHERENT': 'Incoherent order',
    'order.channel.': 'Unknown',
    'order.channel.1': 'Kiosk',
    'order.channel.2': 'WEB',
    'order.channel.5': 'POS',
    'order.channel.8': 'Vending Machine',
    'order.channel.9': 'Uber Eats',
    'order.channel.10': 'Deliveroo',
    'order.channel.11': 'Just Eat',
    'order.consumptionMode.1': 'Delivery',
    'order.consumptionMode.2': 'Take away',
    'order.consumptionMode.3': 'On site',
    'order.consumptionMode.4': 'Drive',
    'order.webPaymentStatus.PAYMENT_OK': 'Paid',
    'order.webPaymentStatus.PAYMENT_PENDING': 'Pending',
    'order.webPaymentStatus.PAYMENT_REFUSED': 'Refused',
    'order.webPaymentStatus.PAYMENT_REFUNDED': 'Refunded',
    'order.paymentMethod.AlloResto': 'AlloResto',
    'order.paymentMethod.AmericanExpress': 'American Express',
    'order.paymentMethod.Cash': 'Cash',
    'order.paymentMethod.Change': 'Change',
    'order.paymentMethod.Check': 'Check',
    'order.paymentMethod.CreditCard': 'Credit card',
    'order.paymentMethod.CreditNote': 'Credit note',
    'order.paymentMethod.CreditNoteIssued': 'Credit note issued',
    'order.paymentMethod.Deliveroo': 'Deliveroo',
    'order.paymentMethod.ELuncheonVoucher': 'E-Lunch voucher',
    'order.paymentMethod.EWallet': 'E-Wallet',
    'order.paymentMethod.ExternalPayment': 'ExternalPayment',
    'order.paymentMethod.Foodora': 'Foodora',
    'order.paymentMethod.Ingenico': 'Ingenico',
    'order.paymentMethod.LuncheonVoucher': 'Lunch voucher',
    'order.paymentMethod.Lydia': 'Lydia',
    'order.paymentMethod.Nepting': 'Nepting',
    'order.paymentMethod.OnlineCreditCard': 'Online Credit Card',
    'order.paymentMethod.Paygreen': 'Paygreen',
    'order.paymentMethod.RestoFlash': 'Resto Flash',
    'order.paymentMethod.Stripe': 'Stripe',
    'order.paymentMethod.Transfer': 'Transfer',
    'order.paymentMethod.UberEats': 'Uber Eats',
    'order.paymentMethod.Unknown': 'Other',
    'order.paymentMethod.Unknown2': 'Other 2',
    'order.paymentMethod.Edenred': 'Edenred',
    'orderDetail.error.incoherent': 'Contact support for order regularization',
    'orderDetail.title.1': 'Kiosk',
    'orderDetail.title.2': 'WEB ordering',
    'orderDetail.title.5': 'Point of sale',
    'orderDetail.title.8': 'Vending Machine',
    'orderDetail.title.9': 'Uber Eats',
    'orderDetail.title.10': 'Deliveroo',
    'orderDetail.title.11': 'Just Eat',
    'orderDetail.title.contraEntry': 'Contra Entry Order',
    'orderDetail.status.PAID': 'Paid',
    'orderDetail.status.VALIDATED': 'Validated',
    'orderDetail.status.CANCELLED': 'Cancelled',
    'orderDetail.tabStatus.PAID': 'Paid Sale',
    'orderDetail.tabStatus.VALIDATED': 'Validated Cart',
    'orderDetail.tabStatus.CANCELLED': 'Cancellation',
    'orderDetail.paymentStatus.PAID': 'Paid',
    'orderDetail.paymentStatus.CANCELLED': 'Cancelled',
    'orderDetail.paymentStatus.REFUNDED': 'Refunded',
    'orderDetail.shift.default': 'Default Shift',
    'orderDetail.header.guestNumber': 'Guest Number:',
    'orderDetail.header.currency': 'Currency:',
    'orderDetail.header.orderedAt': 'Ordered at',
    'orderDetail.header.deliverAt': 'Planed to deliver at',
    'orderDetail.header.deliverAtRange': 'Scheduled for slot:',
    'orderDetail.header.status': 'Status',
    'orderDetail.header.payment': 'Payment',
    'orderDetail.header.table': 'Table',
    'orderDetail.kpi.date': '{date, date}',
    'orderDetail.kpi.time': '{date, date, ::HHmm}',
    'orderDetail.kpi.timeRange': '{start, date, ::HHmm} to {end, date, ::HHmm}',
    'orderDetail.ticketInfo': 'Order details',
    'orderDetail.comment': 'Comment',
    'orderDetail.userName': 'Customer informations',
    'orderDetail.taxInfo': 'Taxes details',
    'orderDetail.paymentInfo': 'Payment methods',
    'orderDetail.customerInfo': 'Customer informations',
    'orderDetail.deliveryInfo': 'Delivery',
    'orderDetail.loyaltyInfo': 'Loyalty',
    'orderDetail.posInfo': 'POS informations',
    'orderDetail.transactionInfo': 'Transaction details',
    'orderDetail.orderPhotos': 'Photos associated with the order',
    'orderDetail.customer.name': 'Last name and first name',
    'orderDetail.customer.email': 'Email',
    'orderDetail.customer.phone': 'Phone number',
    'orderDetail.customer.badgeNumber': 'Badge number',
    'orderDetail.customer.pricingRule': 'Pricing rule',
    'orderDetail.customer.pricingRuleAssigned': 'Pricing rule assigned',
    'orderDetail.customer.group': 'Group',
    'orderDetail.customer.section': 'Section',
    'orderDetail.customer.subSection': 'Subsection',
    'orderDetail.customer.balanceInformation.ewalletBalanceBeforeOrder': 'Old E-Wallet balance',
    'orderDetail.customer.balanceInformation.ewalletBalanceAfterOrder': 'New E-Wallet balance',
    'orderDetail.Pos.restaurant': 'Restaurant',
    'orderDetail.Pos.seller': 'Seller',
    'orderDetail.Pos.deviceName': 'POS Name',
    'orderDetail.Pos.deviceId': 'POS ID',
    'orderDetail.action.text': 'Order actions',
    'orderDetail.action.cancel': 'Cancel',
    'orderDetail.action.refund': 'Refund',
    'orderDetail.action.cancelWithContraEntry': 'Cancel (contra entry)',
    'orderDetail.cancel.title.reason': 'Cancel order',
    'orderDetail.cancel.title.manualPaymentMethod': 'Payment method for refund',
    'orderDetail.cancel.text1': "If necessary, you can cancel a customer's order.",
    'orderDetail.cancel.text2': 'You must choose a reason for cancellation below.',
    'orderDetail.cancel.text3': 'If the reason is not in the list, click on “Other”.',
    'orderDetail.cancel.text4': 'The reason you select will be emailed to the customer.',
    'orderDetail.cancel.text5': 'The quantities of products deducted will be returned to stock.',
    'orderDetail.cancel.text6': 'You can choose the payment method to associate with the refund.',
    'orderDetail.cancel.text7':
        '⚠️ It is necessary to refund the client in physical form to avoid accounting discrepancies.',
    'orderDetail.cancel.reason.placeholder': 'Select your cancellation reason',
    'orderDetail.cancel.reason.description.label': 'Free field (optional)',
    'orderDetail.cancel.reason.description.placeholder': '250 characters maximum',
    'orderDetail.cancel.manualPaymentMethod.placeholder': 'Select your payment method',
    'orderDetail.cancel.reason.CANNOT_FULFILL_ORDER': 'Cannot complete order',
    'orderDetail.cancel.reason.ORDERING_MISTAKE': 'Order mistake',
    'orderDetail.cancel.reason.UNSATISFIED_CUSTOMER': 'Unsatisfied customer (Quantities will not be returned in stock)',
    'orderDetail.cancel.reason.CUSTOMER_NO_SHOW': 'Customer not shown',
    'orderDetail.cancel.reason.CUSTOMER_LEAVES': 'Customer leaves',
    'orderDetail.cancel.reason.LEARNING_MODE': 'Learning',
    'orderDetail.cancel.reason.TECHNICAL': 'Technical error',
    'orderDetail.cancel.reason.OTHER': 'Other...',
    'orderDetail.cancel.manualPaymentMethod.Cash': 'Cash',
    'orderDetail.cancel.manualPaymentMethod.CreditCard': 'Credit Card',
    'orderDetail.cancel.confirm': 'Cancel order',
    'orderDetail.cancel.validate': 'Validate cancellation',
    'orderDetail.ticket.itemSum': 'Total items',
    'orderDetail.ticket.grantSum': 'Total grants',
    'orderDetail.ticket.entranceFeeSum': 'Total entrance fees',
    'orderDetail.ticket.discountSum': 'Total discounts',
    'orderDetail.ticket.tvaSum': 'Total taxes',
    'orderDetail.ticket.finalPrice': 'TOTAL',
    'orderDetail.ticket.discount': 'Discount code:',
    'orderDetail.ticket.pricingRule': 'Pricing rule: ',
    'orderDetail.tax.taxrate': 'Tax rate',
    'orderDetail.tax.totalExclTax': 'Excl. tax',
    'orderDetail.tax.totalTax': 'Tax',
    'orderDetail.tax.totalInclTax': 'Incl. tax',
    'orderDetail.transaction.transactionIds': 'Transaction ID',
    'orderDetail.payment.quantity': 'Quantity',
    'orderDetail.payment.price': 'Price',
    'orderDetail.delivery.address': 'Address',
    'orderDetail.delivery.apartmentNumber': 'Apartment number',
    'orderDetail.delivery.digicode': 'Digicode',
    'orderDetail.delivery.phoneNumber': 'Phone number',
    'orderDetail.delivery.additionalInfo': 'Additional info',
    'orderDetail.linkedOrder.title.origin': 'Link with the contra-entry order',
    'orderDetail.linkedOrder.title.contra_entry': 'Link with the cancelled order',
    'orderDetail.linkedOrder.date.origin': 'Contra-entry order date',
    'orderDetail.linkedOrder.date.contra_entry': 'Cancelled order date',
    'orderDetail.contraEntryInfo.title': 'Contra-entry information',
    'orderDetail.contraEntryInfo.validator': 'Validator',
    'orderDetail.contraEntryInfo.cancellationReasonDescription': 'Free field',

    // Payments
    'route.ioPayTransactions': 'Transactions',
    'route.ioPayReports': 'Reports',
    'route.ioPayTransfers': 'Transfers',
    'route.ioPayConfiguration': 'Configuration',
    'route.ioPayTransferDetail': 'Transfer details',
    'route.ioPayTransactionDetail': 'Transaction details',
    'ioPay.title': 'Adyen',

    'transactions.title': 'Transactions',
    'transactions.detail.title': 'Transaction detail',
    'transactions.subtitle': 'Find transactions from your customers',
    'transaction.field.id': 'Id',
    'transaction.field.type': 'Type',
    'transaction.field.brand': 'Brand',
    'transaction.field.customerEmail': 'Email',
    'transaction.field.date': 'Date',
    'transaction.field.paymentMethod': 'Payment method',
    'transaction.field.paymentStatus': 'Payment status',
    'transaction.field.paymentAmount': 'Payment amount',
    'transaction.field.paymentAmount.tooltip': 'Amount paid by the customer',
    'transaction.field.amount': 'Transaction amount',
    'transaction.field.amount.tooltip': 'Total of amounts paid by Innovorder minus any reimbursements',
    'transaction.field.reversalAmount': 'Amount paid by Innovorder',
    'transaction.field.reversalAmount.tooltip':
        'Amount refunded by deducting only the payment commission (the amount may be negative if funds do not pass through Innovorder and are directly refunded to your bank account)',
    'transaction.field.fee': 'Fee',
    'transaction.field.channel': 'Channel',
    'transaction.field.transfer': 'Transfer',
    'transaction.field.currency': 'Currency',
    'transaction.field.status': 'Status',
    'transaction.field.ip': 'IP',
    'transaction.field.referer': 'Referer',
    'transaction.field.userAgent': 'User Agent',
    'transaction.field.customerCompleteName': 'Customer name',
    'transaction.field.email': 'Email',
    'transaction.field.customerId': 'Customer ID',
    'transaction.field.badgeNumber': 'Badge number',
    'transaction.field.lastUpdate': 'Last update',
    'transaction.field.source': 'Source',
    'transaction.field.orderId': 'Order ID',
    'transaction.field.error': 'Error',
    'transaction.field.restaurant': 'Restaurant',
    'transaction.field.paymentMethodType.WEB': 'Online credit card',
    'transaction.field.paymentMethodType.PROXIMITY': 'Credit card',
    'transaction.field.paymentMethod.MEAL_VOUCHER': 'Luncheon voucher',
    'transaction.field.paymentMethod.BANK_CARD': 'Credit Card',
    'transaction.status.PENDING': 'Pending',
    'transaction.status.PENDING_3DS': '3DS in progress',
    'transaction.status.DONE': 'Success',
    'transaction.status.FAILED': 'Failed',
    'transaction.status.ERROR': 'Error',
    'transaction.type.CAPTURE': 'Payment',
    'transaction.type.REFUND': 'Refund',
    'transaction.channel.WEB': 'Web',
    'transaction.channel.PROXIMITY': 'Proximity',
    'transaction.source.WEBORDERING': 'Webordering',
    'transaction.source.EWALLET': 'Ewallet Reload',
    'transaction.source.KIOSK': 'Kiosk',
    'transaction.source.NOTIFICATION': 'Notification',

    'transaction.detail.card.main': 'Transaction Details',
    'transaction.detail.card.finance': 'Financial data',
    'transaction.detail.card.web': 'Web data',
    'transaction.detail.card.customer': 'Customer information',
    'transaction.detail.card.order': 'Associated order',
    'transaction.detail.card.paymentMethod': 'Payment methods',

    'transfers.title': 'Transfers',
    'transfers.subtitle': 'Transfers emitted to your account',

    'configuration.iopay.title': 'Adyen Settings',
    'configuration.iopay.subtitle':
        'Here, you will find all the legal entities you have created for your company. We have assembled a clear and concise overview of your restaurants and e-wallets to simplify the configuration process.',
    'configuration.error.unaccessible': 'No data or missing permissions',

    'transfer.field.id': 'Id',
    'transfer.field.ref': 'Reference',
    'transfer.field.configurationName': 'Merchant',
    'transfer.field.amount': 'Payment amount',
    'transfer.field.transactionCount': 'Transaction count',
    'transfer.field.status': 'Status',
    'transfer.field.executedAt': 'Execution date',
    'transfer.status.PENDING': 'Pending',
    'transfer.status.SUCCESS': 'Confirmed',
    'transfer.status.SENT_OUT': 'Sent out',
    'transfer.status.FAILED': 'Failed',
    'transfer.kpi.date': '{date, date}',
    'transfer.detail.title': 'Transfer details',
    'transfer.transactions.title': 'Transfer transactions',

    'legalEntity.field.entity': 'Legal entity',
    'legalEntity.field.siret': 'SIRET',
    'legalEntity.field.city': 'City',
    'legalEntity.field.status': 'Status',
    'legalEntity.field.associatedRestaurants': 'Associated restaurants',
    'legalEntity.field.actions': 'Actions',

    'legalEntity.status.1': 'KYC Error',
    'legalEntity.status.2': 'To complete',
    'legalEntity.status.3': 'In Progress',
    'legalEntity.status.4': 'OK',

    'legalEntity.create.title': 'Create a new legal entity',

    'legalEntity.action.addRestaurant': 'Add restaurant',
    'legalEntity.action.addEwallet': 'Add E-Wallet',
    'legalEntity.action.completeKyc': 'Complete KYC',
    'legalEntity.action.updateKyc': 'Update KYC',

    'legalEntity.wizard.step1.title': 'Creation of a new legal entity',
    'legalEntity.wizard.step1.legalName': 'Company legal name',
    'legalEntity.wizard.step1.legalName.placeholder': 'Please enter your legal name',
    'legalEntity.wizard.step1.legalName.tooltip': 'Legal name of the company as recorded exactly on the SIRET',
    'legalEntity.wizard.step1.organizationType': 'Organization type',
    'legalEntity.wizard.step1.organizationType.placeholder': 'Please select your organization type',
    'legalEntity.wizard.step1.siret': 'SIRET',
    'legalEntity.wizard.step1.siret.placeholder': 'Please enter your SIRET',
    'legalEntity.wizard.step1.siret.tooltip': 'Company SIRET',
    'legalEntity.wizard.step1.addressStreet': "Legal entity's address",
    'legalEntity.wizard.step1.addressStreet.placeholder': "Please enter your legal entity's address",
    'legalEntity.wizard.step1.addressStreet2': 'Additional address information (optional)',
    'legalEntity.wizard.step1.addressStreet2.placeholder': 'Please enter your additional address information, if any',
    'legalEntity.wizard.step1.addressZipcode': 'Zip code',
    'legalEntity.wizard.step1.addressZipcode.placeholder': 'Please enter your zip code',
    'legalEntity.wizard.step1.addressCity': 'City',
    'legalEntity.wizard.step1.addressCity.placeholder': 'Please enter your city',
    'legalEntity.wizard.step1.industryCode': 'Industry code',
    'legalEntity.wizard.step1.contactEmail': 'Contact email',
    'legalEntity.wizard.step1.contactEmail.placeholder':
        'Please enter the e-mail address associated with this legal entity',
    'legalEntity.wizard.step1.iban': 'IBAN',
    'legalEntity.wizard.step1.iban.placeholder': 'Please enter your IBAN',
    'legalEntity.wizard.step1.iban.tooltip': 'IBAN of the legal entity',

    'legalEntity.wizard.step2.title': 'Adding a restaurant',
    'legalEntity.wizard.step2.titleMassCatering': 'Adding a restaurant or e-wallet',
    'legalEntity.wizard.step2.chooseRestaurant': 'Select your restaurant',
    'legalEntity.wizard.step2.chooseRestaurantMassCatering': 'Select your restaurant or e-wallet',
    'legalEntity.wizard.step2.completeFieldsTitle': 'Complete the following fields',
    'legalEntity.wizard.step2.conecsTitle': 'CONECS IDs',
    'legalEntity.wizard.step2.conecsTitleOptional': '(optional)',
    'legalEntity.wizard.step2.conecsTitleOptional.tooltip':
        'Provide the CONECS IDs to activate the CONECS payment method proximity for this restaurant',
    'legalEntity.wizard.step2.ewallet': 'E-wallet',
    'legalEntity.wizard.step2.selectRestaurant': 'Restaurant',
    'legalEntity.wizard.step2.selectRestaurantMassCatering': 'Restaurant or e-wallet',
    'legalEntity.wizard.step2.selectRestaurant.placeholder': 'Please select your restaurant',
    'legalEntity.wizard.step2.phoneNumber': 'Phone number',
    'legalEntity.wizard.step2.phoneNumber.placeholder': 'Please enter the phone number associated with this restaurant',
    'legalEntity.wizard.step2.shopperStatement': 'Shopper statement',
    'legalEntity.wizard.step2.shopperStatement.placeholder':
        "Please enter the shopper statement displayed on the customer's bank statement",
    'legalEntity.wizard.step2.shopperStatement.tooltip': "Label displayed on the final customer's bank statement",
    'legalEntity.wizard.step2.restaurantAddressStreet': 'Restaurant address',
    'legalEntity.wizard.step2.restaurantAddressStreet.placeholder': 'Please enter the restaurant address',
    'legalEntity.wizard.step2.restaurantAddressStreet2': 'Additional information (optional)',
    'legalEntity.wizard.step2.restaurantAddressStreet2.placeholder': 'Please enter the additional information, if any',
    'legalEntity.wizard.step2.restaurantAddressZipcode': 'Zip code',
    'legalEntity.wizard.step2.restaurantAddressZipcode.placeholder': 'Please enter the zip code',
    'legalEntity.wizard.step2.restaurantAddressCity': 'City',
    'legalEntity.wizard.step2.restaurantAddressCity.placeholder': 'Please enter the city',
    'legalEntity.wizard.step2.restaurantIban': 'IBAN',
    'legalEntity.wizard.step2.restaurantIban.placeholder': 'Please enter the IBAN associated with this restaurant',
    'legalEntity.wizard.step2.restaurantIban.tooltip': 'IBAN for fund transfer (by default, that of the legal entity)',
    'legalEntity.wizard.step2.conecsId': 'CONECS ID',
    'legalEntity.wizard.step2.conecsId.placeholder': 'Please enter the CONECS ID associated with this restaurant',
    'legalEntity.wizard.step2.conecsAssociatedSiret': 'CONECS associated SIRET',
    'legalEntity.wizard.step2.conecsAssociatedSiret.placeholder': 'Please enter the CONECS associated SIRET',

    'legalEntity.organizationType.1': 'Private company',
    'legalEntity.organizationType.2': 'Public company',
    'legalEntity.organizationType.3': 'Incorporated partnership',
    'legalEntity.organizationType.4': 'Non-profit or charitable organization',
    'legalEntity.organizationType.5': 'Governmental organization',
    'legalEntity.organizationType.6': 'Incorporated association',

    'legalEntity.industryCode.specialFoodServices': 'Special food services',
    'legalEntity.industryCode.fullServiceRestaurants': 'Full-service restaurants',
    'legalEntity.industryCode.limitedServiceRestaurants': 'Limited-service restaurants',
    'legalEntity.industryCode.cafeteriasGrillBuffets': 'Cafeterias, grill buffets, and buffets',
    'legalEntity.industryCode.snacksNonalcoholicBeverages': 'Snacks and nonalcoholic beverage bars',
    'legalEntity.industryCode.bakeries': 'Bakeries',

    // BILLING PAGE
    'billing.title': 'My billing space',
    'billing.subtitle': 'Welcome, this space has been created to simplify invoice management.',
    'billing.description':
        "You'll find invoices organized chronologically by payment service, and now it's easy to view recent payments, download invoices and track invoice history with a single click.",
    'billing.information.edit': 'Modify billing information',
    'billing.noIssuedInvoices': 'No invoices issued',
    'billing.table.creationDate': 'Creation Date',
    'billing.table.amount': 'Amount',
    'billing.table.status': 'Status',
    'billing.table.service': 'Service',
    'billing.table.invoiceNumber': 'Invoice number',
    'billing.table.invoiceName': 'Invoice name',
    'billing.table.dueDate': 'Due date',
    'billing.table.downloadPDF': 'Download PDF',

    'billing.editConfiguration.selectEntityStep.title': 'Legal entities',
    'billing.editConfiguration.selectEntityStep.subtitle':
        'Select a legal entity where to modify billing configuration',
    'billing.editConfiguration.selectEntityStep.legalEntity': 'Legal entities',
    'billing.editConfiguration.selectEntityStep.legalEntity.placeHolder': 'Please select from the list',
    'billing.editConfiguration.selectEntityStep.noLabel': 'Unnamed legal entity',

    'billing.editConfiguration.configureBillingStep.title': 'Billing information',
    'billing.editConfiguration.configureBillingStep.beneficiaryName': 'Beneficiary name',
    'billing.editConfiguration.configureBillingStep.beneficiaryEmail': 'Email address attached to the invoice',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress': 'Beneficiary address',
    'billing.editConfiguration.configureBillingStep.beneficiaryAddress2': 'Additional information',
    'billing.editConfiguration.configureBillingStep.beneficiaryZipCode': 'Postal code',
    'billing.editConfiguration.configureBillingStep.beneficiaryCity': 'City',
    'billing.editConfiguration.configureBillingStep.recipients': 'Invoice recipients',
    'billing.editConfiguration.configureBillingStep.recipients.placeholder': 'Recipient email addresses',
    'billing.editConfiguration.configureBillingStep.recipients.createLabel':
        'Add the email address "{email}" to recipients',
    'billing.editConfiguration.configureBillingStep.genericErrorMessage':
        'An error occured during creation or modification if billing configuration',

    'billing.invoices.download': 'Download',

    'billing.invoices.status.1': 'To pay',
    'billing.invoices.status.2': 'Paid',

    'billing.invoices.psp.4': 'Stripe',

    'billing.invoices.name.4': 'Stripe Unified invoice',

    'reports.title': 'Adyen Reports',
    'reports.subtitle':
        'Check the transactions transferred on your bank account, with the transaction detail for each transfer. This report allows you to ensure accounting reliability of E-wallet transactions with Adyen.',
    'reports.text': 'Generate a/several report type(s)',
    'reports.choosePeriod': 'Choose period',
    'reports.chooseReport': 'Choose one or several report type(s)',
    'reports.outgoingTransfers': 'Outgoing transfers',
    'reports.reportType': 'REPORT TYPE(S)',
    'reports.error.missingDates': 'Please select two dates',
    'reports.error.missingReportType': 'Please select a report',
    'reports.error.missingBrand': 'No brand linked to the current user',

    // PRICING REVALUATION
    'pricingRevaluation.tableCard.title': 'Pricing revaluation',
    'pricingRevaluation.tableCard.subtitle':
        'Indicate the desired revaluation rate, if it should be applied to the options, to the supplements, then select the menus to be revalued and click on the confirm button.',
    'pricingRevaluation.input.placeholder': 'Revaluation rate',
    'pricingRevaluation.options.exceeding': 'Apply to exceedings',
    'pricingRevaluation.options.options': 'Apply to options',
    'pricingRevaluation.options.updateInPlace': 'Connected fridge menu/tray scan',
    'pricingRevaluation.options.updateInPlace.tooltip':
        'If checked, the revaluation will be applied directly to the original menu, to keep the IDs (a copy of the menu without revaluation will be created). \nIf unchecked, the revaluation will be applied to a copy of the menu (new IDs) and the original menu will not be changed.',
    'pricingRevaluation.table.menu.name': 'Menu name',
    'pricingRevaluation.table.menu.isActive': 'Active menu',
    'pricingRevaluation.table.menu.channels': 'Channels',
    'pricingRevaluation.table.menu.selected': 'Selected',
    'pricingRevaluation.table.emptyMessage': 'No menus found on this restaurant',
    'pricingRevaluation.table.search': 'Search for menus',

    'auto.billing.referential.billingEntities.form.label.subtitle': 'Add new billing entity',
    'auto.billing.referential.accountingGroups.costCompute.slice.table.emptyMessage':
        'No range defined for this billing method',

    // PAYMENT METHODES
    'consumptionMode.MODE_DELIVERY': 'Delivery',
    'consumptionMode.MODE_TAKE_AWAY': 'Take away',
    'consumptionMode.MODE_SIT_IN': 'Sit in',
    'consumptionMode.MODE_DRIVE': 'Drive',
    'paymentMethods.tableCard.title': 'Configure',
    'paymentMethods.tableCard.subtitle': 'your payment methods',
    'paymentMethods.tab.pos': 'POS',
    'paymentMethods.tab.web': 'Web',
    'paymentMethods.tab.kiosk': 'Kiosk(s)',
    'paymentMethods.tab.kiosk.integration.title': 'Immediate payments',
    'paymentMethods.tab.kiosk.integration.desc1':
        'Credit card payments on kiosk needs the restaurant to have an Ingenico account',
    'paymentMethods.tab.kiosk.integration.desc2':
        'Other immediate payments are available if you activate authentification on kiosk',
    'paymentMethods.tab.kiosk.payment.title': 'Payment later',
    'paymentMethods.tab.kiosk.payment.desc': 'Indicate to users the payment methods accepted by your restaurant.',
    'paymentMethods.tab.kiosk.payment': 'Payment',
    'paymentMethods.tab.kiosk.payment.accepted': 'accepted',
    'paymentMethods.tab.kiosk.payment.refused': 'refused',
    'paymentMethods.consumptionMode': 'Select consumption modes',
    'paymentMethods.externalId': 'External code',
    'configure.ingenico': 'Configure Ingenico',
    'configure.nepting': 'Configure Nepting',
    'configure.stripe': 'Configure Stripe',
    'configure.edenred': 'Configure Edenred',
    'configure.iopay': 'Configure Adyen',
    'configure.paygreen': 'Configure Paygreen',
    'configure.ewallet': 'Configure E-Wallet',
    'configure.yavin': 'Configure IOPay',
    'configure.yavin.neptingConfigured': 'Cannot configure IOPay since Nepting is used.',
    'configure.nepting.yavinConfigured': 'Cannot configure Nepting since IOPay is used.',
    'configure.stripe.iopayConfigured': 'Cannot configure Stripe as Adyen is used.',
    'configure.iopay.stripeConfigured': 'Cannot configure Adyen as Stripe is used.',

    // CUSTOMER FORM
    'customer.form.modalDescription': 'Please fill the required fields *',
    'customer.form.firstName': 'First name *',
    'customer.form.lastName': 'Last name *',
    'customer.form.badgeNumber': 'Badge number {index} *',
    'customer.form.badgeType': 'Badge type',
    'customer.form.badge.default': 'Set as default',
    'customer.form.badgeType.placeholder': 'Please fill the badge type',
    'customer.form.addBadge': 'Add badge',
    'customer.form.email': 'Email *',
    'customer.form.phoneNumber': 'Phone number (Optional)',
    'customer.form.arrivalDate': 'Arrival date (Optional)',
    'customer.form.departureDate': 'Departure date (Optional)',
    'customer.form.password': 'Password *',
    'customer.form.confirmPassword': 'Confirm password *',
    'customer.form.clientInfoSection': 'Guest Informations',
    'customer.form.pricingRuleSection': 'Pricing rules configuration',
    'customer.form.accountPaymentTypeLabel': 'Account payment type *',
    'customer.form.accountPaymentTypePlaceHolder': 'Please select an account type',
    'customer.form.guestGroupIdLabel': 'Group *',
    'customer.form.guestGroupIdPlaceHolder': 'Please select a group',
    'customer.form.pricingRuleCodeLabel': 'Pricing rules Code *',
    'customer.form.pricingRuleCodePlaceHolder': 'Please select a pricing rule',
    'customer.form.tariffCode': 'TARIFF CODE (OPTIONAL)',
    'customer.form.studentNumber': 'GUEST NUMBER (OPTIONAL)',
    'customer.form.pricingRuleInfo': 'Your pricing rule code does not appear in the list? Please create it ',
    'customer.form.groupInfo': 'To define your groups, go to the Brand > Hierarchization page',
    'customer.form.sectionInfo': 'To define your sections, go to the Brand > Hierarchization page',
    'customer.form.subSectionInfo': 'To define your sub-sections, go to the Brand > Hierarchization page',
    'customer.form.here': 'here',
    'customer.form.section': 'SECTION (OPTIONAL)',
    'customer.form.subSection': 'SUBSECTION (OPTIONAL)',

    // Customer form selection options
    'customer.form.selectOptions.cash': 'Cash',
    'customer.form.selectOptions.prepayment': 'Pre-payment',
    'customer.form.selectOptions.postpayment_bankdebit': 'Post-payment: payday withdrawal',
    'customer.form.selectOptions.postpayment_guest': 'Post-payment: guest',

    // BRAND CUSTOMERS LIST
    'brand.customers.action.import': 'Import',
    'brand.customers.action.export': 'Export',
    'brand.customers.page.title': 'Customers',
    'brand.customers.page.description': 'You will find here the complete list of customers registered to your brand.',

    // IMPORT CUSTOMERS MODAL
    'customer.modal.import.title': 'Import customers',
    'customer.modal.import.firstPart': 'Download the {fileTemplate} to your computer',
    'customer.modal.import.secondPart': 'Fill in the file with your customer data',
    'customer.modal.import.thirdPart': 'Upload the file to import your customers',
    'customer.modal.import.report.title': 'Import report',
    'customer.modal.import.report.result': 'Result',
    'customer.modal.import.report.success': 'Success',
    'customer.modal.import.report.error': 'Error',
    'customer.modal.import.report.message': '{created} created, {updated} updated, {unchanged} unchanged',
    'customer.modal.import.warning':
        "Warning! The columns 'Tariff code', 'Grant code', 'Admission code' and 'Pricing rule code' are deprecated and will be ignored during import. Please use the pricing rules table to configure this information.",
    'customer.modal.import.addNew.title': 'Add new customers',
    'customer.modal.import.addNew.step1': 'Download the {link} to your computer',
    'customer.modal.import.addNew.step1.link': 'template file',
    'customer.modal.import.addNew.step2': 'Fill in the file with your new customer data',
    'customer.modal.import.addNew.step3': 'Upload the completed file below',
    'customer.modal.import.update.title': 'Update existing customers',
    'customer.modal.import.update.step1': 'Download {link} to your computer',
    'customer.modal.import.update.step1.link': 'the current customer database',
    'customer.modal.import.update.step1.loading': 'Loading...',
    'customer.modal.import.update.step2': 'Modify the data of customers you want to update',
    'customer.modal.import.update.step3': 'Upload the modified file below',
    'customer.modal.import.update.warning':
        'Note: The customer ID must match an existing customer for the update to be performed.',
    'customer.modal.import.options.title': 'Import options',
    'customer.modal.import.options.multiBadge': 'Multi-badge import',
    'customer.modal.import.options.autoImportGuestHierarchy': 'Auto-import hierarchy (groups, sections, sub-sections)',
    'customer.modal.import.error.noResponse': 'Import failed - no response from server',
    'customer.modal.import.error.invalidResponse': 'Invalid response from server',
    'customer.modal.import.error.fileTooLarge': 'File is too large (max 20 MB)',
    'customer.modal.import.loading.reading': 'Reading file...',
    'customer.modal.import.loading.importing': 'Import in progress...',
    'customer.modal.import.result.lineError': 'Line {lineNumber}{nameDisplay}: {error}',
    'customer.modal.import.result.fieldError': 'Fields ({fields}) were not updated (line {line})',
    'customer.modal.import.result.genericError': 'An error occurred',
    'customer.modal.import.result.created': 'Customers created: {count}',
    'customer.modal.import.result.updated': 'Customers updated: {count}',
    'customer.modal.import.result.unchanged': 'Customers unchanged/not created: {count}',
    'customer.modal.import.result.errors': 'Errors',
    'customer.modal.import.result.warnings': 'Warnings',
    'customer.modal.import.result.otherWarning.PRICING_RULE': 'Some pricing rules do not exist on the system: ',
    'customer.modal.import.result.otherWarning.ENTRANCE_FEE': 'Some entrance fees do not exist on the system: ',
    'customer.modal.import.result.otherWarning.EMPTY_GUEST_GROUP': 'Some guests have an empty group (lines: ',
    'customer.modal.import.result.otherWarning.UNEXISTING_GUEST_GROUP': 'Some guest groups do not exist (lines: ',
    'customer.modal.import.result.otherWarning.UNAUTHORIZED_PRICING_RULE':
        'Some pricing rules are not authorized for the group (lines: ',
    'customer.modal.import.result.restrictedFieldsInfo':
        'The "Password", "Pin code" and "Balance" fields can only be updated if the customer has not yet made a transaction.',

    // CREATE CUSTOMER
    'customer.create.modalTitle': 'Create a new customer',

    // UPDATE A CUSTOMER
    'customer.update.modalTitle': 'update customer',

    // CUSTOMER INFO TABS
    'customer.tab.info': 'Client Infos',
    'customer.tab.ewallet': 'E-Wallet',
    'customer.tab.student': 'Mass catering',
    'customer.tab.orders': 'Orders history',

    // CUSTOMER ROUTES
    'route.customerPricingPolicy': 'Pricing Policy',

    // CUSTOMER PRICING POLICY
    'customer.pricingPolicy.defaultTitle': 'Default policy',
    'customer.pricingPolicy.defaultDescription':
        'Default pricing policy will be applied to any customer creating its account through the web ordering module.',
    'customer.pricingPolicy.customTitle': 'Custom policy',
    'customer.pricingPolicy.entranceFee': 'Entrance fee',
    'customer.pricingPolicy.pricingPolicy': 'Pricing policy',
    'customer.pricingPolicy.group': 'Group',
    'customer.pricingPolicy.groupPlaceholder': 'MY GROUP',
    'customer.pricingPolicy.domainName': 'Domain name',
    'customer.pricingPolicy.delete': 'Delete',
    'customer.pricingPolicy.noEntranceFee': 'No admission',
    'customer.pricingPolicy.noPricingRule': 'No pricing rule',
    'customer.pricingPolicy.noGroup': 'No group',
    'customer.pricingPolicy.enableWhitelisting': 'Restrict subscription to declared domains',
    'customer.pricingPolicy.enableWhitelistingInfo':
        'By activating this option, online registration is only allowed for declared domains',
    'customer.pricingPolicy.save': 'Save',

    // CUSTOMER INFO STUDENT TAB
    'customer.student.info.title': 'Informations',
    'customer.student.info.desctiption': 'Informations for mass catering mode',
    'customer.student.info.account.type': 'Badge type',
    'customer.student.info.group': 'Group',
    'customer.student.info.section': 'Section',
    'customer.student.info.sub.section': 'Sub-section',
    'customer.student.info.badge.number': 'Badge number',
    'customer.student.info.pricing.code': 'Tariff Code',
    'customer.student.info.student.number': 'Guest number',
    'customer.student.pricing.rules.title': 'Pricing rules',
    'customer.student.pricing.rules.desctiption':
        'You can assign each customer specific rules. A customer may have a subsidy and / or admission code OR a tariff regime code (a set of admission fees and / or subsidies).',
    'customer.student.pricing.rules.deprecated':
        '⚠️ Warning: entrance fee code and grant code are now deprecated (Include them in the pricing rule). {moreInfo}',
    'customer.student.pricing.rules.more_info': 'More information',
    'customer.student.pricing.rules.grant.code': 'Grant code',
    'customer.student.pricing.rules.entrance.fee.code': 'Entrance fee Code',
    'customer.student.pricing.rules.code': 'Pricing rules Code',
    'customer.student.overdraft.title': 'E-Wallet overdraft',
    'customer.student.overdraft.desctiption': 'You can enable a custom overdraft for ewallet use of a customer',
    'customer.student.overdraft.price.label': 'E-Wallet overdraft',
    'customer.student.overdraft.disabled': 'The default ewallet overdraft is set for this customer.',
    'customer.student.badge.title': 'Bloking the customer main badge',
    'customer.student.badge.description': 'You can temporarily block the operation of the main badge.',
    'customer.student.badge.table.default': 'Principal',
    'customer.student.badge.table.number': 'Badge number',
    'customer.student.badge.table.type': 'Type',
    'customer.student.badge.table.status': 'Status',
    'customer.student.badge.table.action': 'Action',
    'customer.student.badge.table.status.active': '✓ Active',
    'customer.student.badge.table.status.blocked': '✕ Blocked',
    'customer.student.add.badge': '+ Add badge',
    'customer.student.badge.form.add': 'Add badge',
    'customer.student.badge.form.update': 'Update badge',
    'customer.student.badge.form.default': 'Set as primary',
    'customer.ordersList.title': 'Orders',
    'customer.ordersList.subtitle': 'Find orders from your customer',
    'customer.ordersList.downloadTickets': 'Download tickets',
    'customer.ordersList.exportStarted': 'Ticket export started. Please wait...',
    'customer.ordersList.exportSuccess': 'Tickets exported successfully!',
    'customer.ordersList.exportFailed': 'Ticket export failed. Please try again.',
    'customer.ordersList.exportNoTicketsForDates': 'No tickets for the selected dates.',
    'customer.ordersList.downloadChoice.all': 'All tickets',
    'customer.ordersList.downloadChoice.selectedRange': 'Only the selected dates',
    'order.field.downloadTicket': 'Download',

    // POS LAYOUT
    'pos_layout.name': 'POS Layout',
    'pos_layout.page.title': 'POS Layout',
    'pos_layout.page.description': 'Organize your POS layout to deploy it on the associated devices.',
    'pos_layout.sort': 'Reorganize',
    'pos_layout.sort.random': 'Random',
    'pos_layout.sort.by_name': 'By name',
    'pos_layout.sort.by_price': 'By price',
    'pos_layout.tabletSize': 'Tablet size',
    'pos_layout.inches': 'Inches',
    'pos_layout.publishDescription':
        'Are you sure you want to save and publish the menu and layout on the associated POS?',
    'pos_layout.assignPos': 'Assign POS',
    'pos_layout.modal.warning': 'Warning',
    'pos_layout.modal.publish.description':
        'The following categories in the key plan do not have any associated products: \n• {categories} \nDo you want to confirm the publication of this layout?',
    'pos_layout.modal.save.description':
        'The following categories in the key plan do not have any associated products: \n• {categories} \nDo you want to save this layout?',
    'pos_layout.customPrice': 'Custom price',
    'pos_layout.functions.create.title': 'Add a function key',
    'pos_layout.functions.edit.title': 'Edit function key',
    'pos_layout.functions.type': 'Key type',
    'pos_layout.functions.type.placeholder': 'Select a type',
    'pos_layout.functions.type.webview': 'Link Web / URL',
    'pos_layout.functions.name': 'Key name',
    'pos_layout.functions.url': 'Web link/Target URL',
    'pos_layout.functions.submit': 'Save',
    'pos_layout.functions.verifyLink': 'Verify link',
    'pos_layout.functions.widthPercent': 'Width',
    'pos_layout.functions.heightPercent': 'Height',

    // POS DEVICE
    'pos_device.role.independent': 'Independent',
    'pos_device.role.master': 'Main',
    'pos_device.role.slave': 'Dependant',
    'pos_device.role.independent.plural': 'Independent',
    'pos_device.role.master.plural': 'Main',
    'pos_device.role.slave.plural': 'Dependant',

    // ACTIONS
    'action.action': 'Action',
    'action.edit': 'Edit',
    'action.duplicate': 'Duplicate',
    'action.copy': 'Copy',
    'action.export': 'Export',
    'action.publish': 'Publish',
    'action.delete': 'Delete',
    'action.hide': 'Hide',

    // CUSTOMERS
    'customers.page.title': 'Customers',
    'customers.page.description': 'Show your customers',
    'customers.id': 'ID',
    'customers.name': 'Client',
    'customers.email': 'Email',
    'customers.phone': 'Phone',
    'customers.totalSpentAmount': 'Total spent',
    'customers.orderCount': 'Order count',
    'customers.averageCart': 'Average cart',
    'customers.lastOrder': 'Last order',
    'customers.frequency': 'Frequency',
    'customers.status': 'Status',
    'customers.ewalletBalance': 'Ewallet balance',
    'customers.archivedAt': 'Archived at',
    'customers.disabledAt': 'Disabled at',
    'customers.showArchivedCustomers': 'Show archived customers',
    'customers.showDisabledCustomers': 'Show disabled customers',
    'customers.options': 'Options',
    'customers.domainNames': 'Domain Names',
    'customers.selectDomainNames': 'Select Domain Names',
    'customers.groups': 'Groups',
    'customers.selectGroups': 'Select Groups',

    // MENU
    'menu.name': 'Menu name',
    'menu.categories': 'Categories',
    'menu.products': 'Products',
    'menu.functions': 'Functions',
    'menu.page.title': 'Menus',
    'menu.page.description': 'Create and manage your menus',
    'menu.table.associatedChannels': 'Associated channels',
    'menu.action.newMenu': '+ New menu',
    'menu.action.manualImportCrous': 'Force Crous Import',
    'menu.action.seeOperations': 'See imports',
    'menu.action.changeColor': 'Change color',
    'menu.action.editCategory': 'Edit category',
    'menu.action.editProduct': 'Edit product',
    'menu.action.editFunction': 'Edit function',
    'menu.action.import': 'Import menu',
    'menu.action.noImport': 'I do not want to import a file',
    'menu.modal.manualImportCrous.title': 'Manual import of the CROUS catalog',
    'menu.modal.manualImportCrous.description':
        'Are you sure you want to launch a manual import of the CROUS catalog for this restaurant?',
    'menu.action.aiMenuScan': 'AI Scan (beta)',
    'menu.modal.aiMenuScan.title': 'Scan your new menu (beta)',
    'menu.modal.aiMenuScan.description.part1': 'Import your new menu from PDF or image format',
    'menu.modal.aiMenuScan.description.part2': 'Click on generate the Excel menu',
    'menu.modal.aiMenuScan.description.part3':
        'Automatically download the excel file of the new menu with available data',
    'menu.modal.aiMenuScan.action.generate': 'Generate the excel menu',
    'menu.modal.aiMenuScan.action.cancel': 'Cancel',
    'menu.modal.bannersDeactivated':
        '{count, plural, one {# promotional banner has been deactivated} other {# promotional banners have been deactivated}}',
    'menu.modal.create.importMenu': 'Import menu',
    'menu.modal.create.createMenu': 'Create menu',
    'menu.modal.error.wrongName': 'Enter a valid name',
    'menu.modal.create.import.excel.tab': 'Excel',
    'menu.modal.create.import.json.tab': 'JSON',
    'menu.modal.create.import.pos.tab': 'POS',
    'menu.modal.create.import.excel.title': 'Add a new menu',
    'menu.modal.create.import.excel.description.firstPart': 'Download the {fileTemplate} on your computer',
    'menu.modal.create.import.excel.description.secondPart':
        'Fill the template file with the information of your products composing the new menu',
    'menu.modal.create.import.excel.description.thirdPart': 'Import the new menu file by clicking on the button below',
    'menu.modal.create.import.pos.title': 'Import existing menu',
    'menu.modal.create.import.pos.description.firstPart': 'Choose a POS device to import the menu from',
    'menu.modal.create.import.json.title': 'Import an existing menu',
    'menu.modal.create.import.json.description.firstPart': 'Make sure that your file is a JSON file',
    'menu.modal.create.import.json.description.secondPart': 'Import the new menu file by clicking on the button below',
    'menu.modal.duplicate.title': 'Duplicate menu',
    'menu.modal.delete.title': 'Delete menu',
    'menu.modal.delete.description': 'Do you really want to delete menu : "{menuName}"?',
    'menu.modal.copy.title': 'Copy menu',
    'menu.modal.publish.title': 'Publish menu',
    'menu.modal.publish.autoPublish': 'Reload kiosks after validation',
    'menu.modal.publish.devicePublish': 'Publish the menus on the following POS:',
    'menu.modal.publish.deliverooPublish': 'Publish the menus on the following Deliveroo stores:',
    'menu.modal.publish.ubereatsPublish': 'Publish the menus on the following UberEats stores:',
    'menu.modal.publish.duplicateBarCode':
        '\n- The barcode {barCode} is duplicated for the following products: {products}',
    'menu.modal.error.name': 'Enter a name in dedicated field',
    'menu.modal.error.channels': 'You must disable the option to synchronize with associated POS',
    'menu.modal.menu.name': 'Menu name',
    'menu.modal.message.defaultIncompatibleDisclaimer':
        'You can only associate master or independent POS with a minimum software version 7.0',
    'menu.modal.message.versionIncompatibleDisclaimer':
        'You can only associate POS with a minimum software version {values}',
    'menu.modal.message.roleIncompatibleDisclaimer': 'You cannot associate {values} POS',
    'menu.modal.channels.selectActive': 'Activate menu on following channels',
    'menu.modal.channels.associatedChannels': 'Associated channels',
    'menu.modal.channels.pos.selectActive': 'Select POS to associate with the menu',
    'menu.modal.channels.pos.notFound': 'No POS found.',
    'menu.modal.channels.shouldSyncPos': 'POS synchronization',
    'menu.modal.channels.isSyncFromPosEnabled': 'Update the menu when changes are made from the associated POS',
    'menu.modal.channels.associatePos': 'Select POS to associate',
    'menu.modal.channels.deliveroo.selectActive': 'Select Deliveroo store to associate with the menu',
    'menu.modal.channels.ubereats.selectActive': 'Select UberEats store to associate with the menu',
    'menu.modal.channels.createMenu': 'Create menu',
    'menu.modal.channels.editMenu': 'Edit menu',
    'menu.modal.channels.selectPos': 'Select POS',
    'menu.modal.channels.associateDeliveroo': 'Select Deliveroo store to associate',
    'menu.modal.channels.associateUberEats': 'Select UberEats',
    'menu.modal.channels.selectDeliveroo': 'Select Deliveroo',
    'menu.modal.channels.selectUberEats': 'Select UberEats store to associate',
    'menu.modal.externalId': 'External code',
    'menu.modal.warn.shift.title': 'Dangerous operation',
    'menu.modal.warn.shift.text': `Editing a menu in the middle of a shift can disturb the customer experience on the associated kiosks.`,
    'menu.modal.warn.shift.button': 'OK',

    'menu.importPOS.cancel': 'Not now',
    'menu.importPOS.title': 'Import missing menus from your POS',
    'menu.importPOS.step1.title': 'New: Add your POS menus here with one click!',
    'menu.importPOS.step1.bullet.1': 'Easier and more in-depth management of touch plan and menus',
    'menu.importPOS.step1.bullet.2':
        'The ability to prepare your touch plan in advance and activate it with a single click',
    'menu.importPOS.step1.bullet.3': 'The possibility of using the same menu for checkout, kiosk and online ordering',
    'menu.importPOS.step1.info':
        'Only checkouts with a version higher than 7 and of independent or master category can have their menu on the backoffice.',

    'menu.importPOS.step3.title': "It's all good!",
    'menu.importPOS.step3.subtitle': 'You can now manage your tills directly from the backoffice!',
    'menu.importPOS.step3.info1': 'Click on the menu of your choice to view and modify it.',
    'menu.importPOS.step3.info2':
        'You can apply a menu to prepare your next menu or modify the associated tills and other consumption modes for each menu.',
    'menu.importPOS.step3.info3':
        "As long as you don't publish a menu on its associated till(s), it will remain unchanged on the crates.\n<strong>You must therefore publish changes to the menu on the tills when you wish to update them.</strong>\nThis can be done in the options for each menu on the menus page, or from the touch plan page.",
    'menu.importPOS.step3.link': 'Documentation',
    'menu.importPOS.step2.pos': 'POS registers imported into the back-office',
    'menu.importPOS.step2.switch': 'Update the menu with future changes from the associated cash register',

    'menuoperation.page.title': 'Menu operations',
    'menuoperation.page.description': 'Find the menu operations for your restaurant',
    'menuoperation.type': 'Type',
    'menuoperation.type.update': 'Update',
    'menuoperation.type.publish': 'Publish',
    'menuoperation.type.propagation': 'Propagation',
    'menuoperation.message.from': 'From ',
    'menuoperation.message.from.brandMenu': 'From brand menu:',
    'menuoperation.message.to': 'To ',
    'menuoperation.errorModal.title': 'Publication report',
    'menuoperation.errorModal.message': 'The publication could not be completed.',
    'menuoperation.errorModal.checklist.intro': 'Please check the following points before validating again:',
    'menuoperation.errorModal.checklist.requiredFields': 'All required product fields are completed',
    'menuoperation.errorModal.checklist.requiredMenuImage': 'The menu has an image',
    'menuoperation.errorModal.checklist.noSubCategories': 'The menu has no sub-categories',
    'menuoperation.errorModal.checklist.imageFormats':
        'Images respect the required formats (between 320x320px and 6000x6000px)',
    'menuoperation.errorModal.checklist.syncSettings': 'Synchronization settings are correctly configured',
    'menuoperation.errorModal.checklist.stepDepthLimit':
        'The step depth limit is not exceeded (2 levels max for Deliveroo).',
    'menuoperation.actions': 'Actions',
    'menuoperation.action.download': 'Previous menu',
    'menuoperation.action.download.before': 'Initial Menu',
    'menuoperation.action.download.after': 'Final Menu',
    'menuoperation.download.error.title': 'Download failed',
    'menuoperation.download.error': 'Unable to download the archived menu. Please try again later.',

    // Menu tags
    'menu.tags.title': 'Tags',
    'menu.tags.table.name': 'Name',
    'menu.tags.create.link': 'Create new tag',
    'menu.tags.create.title': 'Create tag',
    'menu.tags.create.error.alreadyTaken': 'This tag already exists',
    'menu.tags.edit.title': 'Edit tag',
    'menu.tags.form.color.label': 'Color',
    'menu.tags.delete.confirm': 'Are you sure you want to delete {count} tag(s)?',
    'menu.steps.form.minChoice': 'Minimum choice',
    'menu.steps.form.maxChoice': 'Maximum choice',
    'menu.steps.form.stepRef': 'Reference',
    'menu.steps.form.maxChoice.error.greaterThanMin': 'Should be greater than min',

    // Menu functions
    'menu.functions.title': 'Functions',
    'menu.functions.subtitle': 'Add, edit and assign functions to your key layout',
    'menu.functions.table.name': 'Name',
    'menu.functions.table.type': 'Type',
    'menu.functions.table.status': 'Status',
    'menu.functions.table.action': 'Action',
    'menu.functions.status.active': 'Active',
    'menu.functions.status.inactive': 'Inactive',
    'menu.functions.noData': 'No functions created',
    'menu.functions.delete.confirm': 'Are you sure you want to delete {count} function(s)?',

    // Menu steps
    'menu.steps.title': 'Steps',
    'menu.steps.add.title': 'New Step',
    'menu.steps.createCustomization.title': 'Create a customization',
    'menu.steps.createCrossSelling.title': 'Create a cross-sell',
    'menu.steps.column.type': 'Type',
    'menu.steps.typeName.1': 'Customization',
    'menu.steps.typeName.2': 'Cross-sell',
    'menu.steps.delete.confirm': 'Are you sure you want to delete {count} step(s)?',
    'menu.steps.convert.toCustomization.confirm':
        'Following the conversion, it will be necessary to configure the details and options for your customization step. Would you like to continue ?',
    'menu.steps.convert.toCrossSelling.confirm':
        'When converting the step, the information about minimum/maximum choices and enabled options will not be retained. Do you want to continue ?',
    'menu.steps.bulkConvertError':
        'In order to perform a bulk conversion, all steps must be of the same type (cross selling or customization).',
    'menu.steps.duplicate': 'Duplicate',
    'menu.steps.convert': 'Convert',
    'menu.steps.column.name': 'Name',
    'menu.steps.column.choices': 'Possible choices',
    'menu.steps.column.min': 'Min',
    'menu.steps.column.max': 'Max',
    'menu.steps.column.stepRef': 'Reference',
    'menu.steps.column.parentsProducts': 'Parent products',
    'menu.steps.edit.title': 'Edit step',
    'menu.steps.editCustomization.title': 'Edit customization step',
    'menu.steps.editCrossSelling.title': 'Edit cross selling step',
    'menu.steps.convert.title': 'Attention',
    'menu.steps.form.ticketLabel': 'Ticket label',
    'menu.steps.form.isDescriptionDisplayEnabled': 'Display description',
    'menu.steps.form.options': 'Options',
    'menu.steps.form.isExcessAllowed': 'Allow excess',
    'menu.steps.form.isGroupEnabled': 'Enable group',
    'menu.steps.form.isImageDisplayEnabled': 'Display image',
    'menu.steps.form.isQuantitySelectionEnabled': 'Quantity selection',
    'menu.steps.form.isWeightStrategyEnabled': 'Weight strategy',
    'menu.steps.form.stepProduct': 'Choices list',
    'menu.steps.form.stepProduct.add': 'Add choice',
    'menu.steps.form.stepProduct.orderByName': 'Order by name',
    'menu.steps.form.stepProduct.orderByPrice': 'Order by price',
    'menu.steps.form.stepProduct.setForAllOption': 'Set for all',
    'menu.steps.form.stepProduct.name': 'Name',
    'menu.steps.form.stepProduct.price': 'Price',
    'menu.steps.form.stepProduct.excessPrice': 'Excess price',
    'menu.steps.form.stepProduct.weight': 'Unit weight',
    'menu.steps.form.stepProduct.group': 'Group',
    'menu.steps.form.stepProduct.maxQuantity': 'Max quantity',
    'menu.steps.form.stepProduct.posIsSelectedByDefault': 'Selected by default (POS)',
    'menu.steps.form.stepProduct.posMinProductQuantity': 'Min quantity (POS)',
    'menu.steps.form.stepProduct.posDefaultProductQuantity': 'Default quantity (POS)',
    'menu.steps.form.stepProduct.displayPOSFields': 'Display POS attributes',
    'menu.steps.form.stepProduct.import': 'Import',
    'menu.steps.form.stepProduct.importWithPrice': 'Import with price',
    'menu.steps.form.stepProduct.importWithoutPrice': 'Import without price',
    'menu.steps.propagate.title': 'Propagate steps',

    // Menu categories
    'menu.categories.title': 'Categories',
    'menu.categories.subtitle': 'Edit menu categories',
    'menu.categories.addCategory': 'Add category',
    'menu.categories.noData': 'No category in the menu.',
    'menu.categories.addProduct': 'Add product',
    'menu.categories.createProduct': 'Create product',
    'menu.categories.deleteCategory': 'Delete',
    'menu.categories.removeProduct': 'Remove',
    'menu.categories.deleteCategory.confirm':
        'Are you sure you want to delete this category? It will no longer be available, and its children (products and sub-categories) will become orphans.',
    'menu.categories.create.title': 'Create category',
    'menu.categories.edit.title': 'Edit category',
    'menu.categories.products': '{productCount, plural, =0 {no products} one {# product} other {# products}}',
    'menu.categories.create.error.alreadyTaken': 'This category is already taken',

    // Menu products
    'menu.products.title': 'Products',
    'menu.products.table.image': 'Image',
    'menu.products.table.name': 'Name',
    'menu.products.table.categories': 'Categories',
    'menu.products.table.price': 'Price',
    'menu.products.table.vat': 'VAT',
    'menu.products.table.sku': 'SKU',
    'menu.products.table.tags': 'Tags',
    'menu.products.reload.kiosk': 'Reload',
    'menu.products.create.link': 'Create new product',
    'menu.products.massEdit': 'Grouped edition',
    'menu.products.duplicate': 'Duplicate',
    'menu.products.copy': 'Propagate',
    'menu.products.copy.title': 'Propagate products',
    'menu.products.copy.form.restaurants.title': 'I select my target restaurants',
    'menu.products.copy.form.restaurants.label': 'Destinations',
    'menu.products.copy.form.restaurants.tooltip':
        'Choose the restaurants from the brand that will receive the product and/or its steps propagation.',
    'menu.products.copy.form.restaurants.tooltip.title': 'I select my target restaurants',
    'menu.products.copy.form.restaurants.tooltip.example':
        'From the brand menu, you decide to propagate the Brownie dessert only to restaurants A and B → only these restaurants will have this new product.',
    'menu.products.copy.form.publishAfterCopy.title': 'Propagation on the till',
    'menu.products.copy.form.publishAfterCopy.tooltip': 'Automatically publish menus to associated tills',
    'menu.products.copy.form.publishAfterCopy.tooltip.title': 'Automatic publication',
    'menu.products.copy.form.publishAfterCopy.tooltip.example':
        'If enabled, menus will be automatically published to all tills associated with target restaurants.',
    'menu.products.copy.form.publishAfterCopy': 'Automatically publish menus to associated tills',
    'menu.products.copy.form.publishAfterCopy.disclaimer':
        '⚠️ Attention, it is necessary to add on the touch plan the new propagated products',
    'menu.products.copy.form.strategy.title': 'Propagation strategy for existing steps on the target menus',
    'menu.products.copy.form.strategy.tooltip':
        'Steps already present in the restaurant are replaced by those configured on the brand menu (products and prices included).',
    'menu.products.copy.form.strategy.tooltip.title': 'Strategy: Update existing steps',
    'menu.products.copy.form.strategy.tooltip.example':
        'Restaurant A has the "Choose a dessert" step with Pain perdu, Fruits, Cookie (2€).\nBrand propagates it with Cookie (1€), Brownie (2€) → Restaurant A will now have Cookie (1€), Brownie (2€).\n\n👉 The Cookie unit product is updated, the Brownie unit product is created and the Pain perdu product is removed from the step.',
    'menu.products.copy.form.strategy.replace':
        'Update the existing steps of the menu(s) restaurant(s) by those of the brand menu',
    'menu.products.copy.form.strategy.replace.tooltip.title': 'Strategy: Update existing steps',
    'menu.products.copy.form.strategy.replace.tooltip.description':
        'Steps already present in the restaurant are replaced by those configured on the brand menu (products and prices included).',
    'menu.products.copy.form.strategy.replace.tooltip.example':
        'Restaurant A has the "Choose a dessert" step with Pain perdu, Fruits, Cookie (2€).\nBrand propagates it with Cookie (1€), Brownie (2€) → Restaurant A will now have Cookie (1€), Brownie (2€).\n\n👉 The Cookie unit product is updated, the Brownie unit product is created and the Pain perdu product is removed from the step.',
    'menu.products.copy.form.strategy.update_and_keep_existing':
        'Update the existing steps of the menu(s) restaurant(s) and keep the existing products not present in the step of the brand menu',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.title':
        'Strategy: Update and keep existing products',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.description':
        'Restaurant steps are updated with those from the brand, but products already present and absent from the brand menu are kept.',
    'menu.products.copy.form.strategy.update_and_keep_existing.tooltip.example':
        'Restaurant A has the "Choose a dessert" step with Pain perdu (1€), Fruits (2€), Cookie (2€).\nBrand propagates it with Cookie (1€), Brownie (2€) → Restaurant A will have Pain perdu (1€), Fruits (2€), Cookie (1€), Brownie (2€).\n\n👉 The Cookie unit product is updated, the Brownie unit product is created and the Pain perdu product is kept in the step.',
    'menu.products.copy.form.strategy.keep_existing': 'Do not modify the steps already existing in the target menus',
    'menu.products.copy.form.strategy.keep_existing.tooltip.title': 'Strategy: Do not modify existing steps',
    'menu.products.copy.form.strategy.keep_existing.tooltip.description':
        'Steps already present in the restaurant are not modified during propagation.',
    'menu.products.copy.form.strategy.keep_existing.tooltip.example':
        'Restaurant A has the "Choose a dessert" step with Pain perdu (1€), Fruits (2€), Cookie (2€).\nBrand propagates it with Cookie (1€), Brownie (2€) → Restaurant A keeps Pain perdu (1€), Fruits (2€), Cookie (2€).\n\n👉 The Cookie unit product is updated and the Brownie unit product is created.',
    'menu.products.copy.form.channel.title': 'I select my target channels',
    'menu.products.copy.form.channel.tooltip':
        'Choose the channels (e.g.: Till, Online Order (CEL), Kiosk) on which the product and/or its steps propagation will be applied.',
    'menu.products.copy.form.channel.tooltip.title': 'I select my target channels',
    'menu.products.copy.form.channel.tooltip.example':
        'You propagate the Brownie dessert but only choose Kiosk → the product will be visible only on the kiosk menus of the selected restaurants.',
    'menu.products.copy.form.updateIgnoreAttributes.title':
        'When propagating, I don`t want to overwrite the following properties on :',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip':
        'When propagating a product from the brand to a restaurant where it already exists (individually or via a step), you can choose to preserve certain properties of this unit product: tag, parent category, image, price, VAT, name and description.',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.title':
        'Preserve certain properties when propagating an existing product',
    'menu.products.copy.form.updateIgnoreAttributes.tooltip.example':
        'The Cookie unit product already exists in the restaurant with a custom image and specific price → if you check "Image" and "Price", these values will be preserved, even after propagation from the brand.\n\n👉 For new products, all properties from the brand are automatically propagated.',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.products': 'Products already present in the target menus',
    'menu.products.copy.form.updateIgnoreAttributes.subtitle.steps': 'Steps already present in the target menus',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.title':
        'Preserve certain properties when propagating an existing step',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.description':
        'When propagating a step from the brand to a restaurant where it already exists, you can choose to preserve certain properties of this step: product price in the step, maximum quantity per product (if the Quantity option is enabled) and exceeding price.',
    'menu.products.copy.form.updateIgnoreAttributes.steps.tooltip.example':
        'In the restaurant, the Choose a dessert step has a Cookie at 2€ with a max quantity of 3.\nThe brand propagates in the step a Cookie at 1€ with a max quantity of 1.\n→ If you preserve "Product price" and "Max quantity", the restaurant keeps Cookie at 2€ and max quantity of 3.\n\n👉 For new steps, all properties from the brand are automatically propagated.',
    'menu.products.copy.form.updateIgnoreAttributes.placeholder':
        'When propagating, I don`t want to overwrite the following properties',
    'menu.products.copy.form.channel.web': 'Online command',
    'menu.products.copy.form.channel.kiosk': 'Kiosk',
    'menu.products.copy.form.channel.pos': 'POS',
    'menu.products.copy.form.channel.marketplace': 'Marketplace (UberEats/Deliveroo)',
    'menu.products.copy.form.channel.null': 'Without channel',
    'menu.products.copy.form.other.strategies.title': 'Creation of new products',
    'menu.products.copy.form.other.strategies.tooltip':
        'When propagating new products, the brand propagates in the step a Cookie at 2 € with a max quantity of 3. If you keep "Product price" and "Max quantity", the restaurant keeps Cookie at 2 € and max quantity of 3. → If you keep "Product price" and "Max quantity", the restaurant keeps Cookie at 2 € and max quantity of 3.',
    'menu.products.copy.form.other.strategies.tooltip.title': 'Creation of new products',
    'menu.products.copy.form.other.strategies.tooltip.example':
        'When propagating new products, the brand propagates in the step a Cookie at 2 € with a max quantity of 3. If you keep "Product price" and "Max quantity", the restaurant keeps Cookie at 2 € and max quantity of 3.\n→ If you keep "Product price" and "Max quantity", the restaurant keeps Cookie at 2 € and max quantity of 3.',
    'menu.products.copy.form.other.strategies.tags': 'Create at will the missing tags of products',
    'menu.products.copy.form.other.strategies.categories': 'Create at will the missing categories of products',
    'menu.products.copy.form.posMenus.title': 'Active POS Menus',
    'menu.products.copy.form.posMenus.description':
        'This table only displays restaurants where multiple POS menus are active. If only one POS menu is active, the propagation is done by default on this menu.',
    'menu.products.copy.form.posMenus.tooltip':
        'Select the POS menus where you want to propagate the products for each restaurant.',
    'menu.products.copy.form.posMenus.tooltip.title': 'POS menus selection',
    'menu.products.copy.form.posMenus.tooltip.example':
        'If a restaurant has multiple POS menus, you can choose to propagate to one or more specific menus.',
    'menu.products.copy.form.posMenus.column.restaurant': 'Restaurant name',
    'menu.products.copy.form.posMenus.column.menus': 'Active menu(s)',
    'menu.products.copy.form.posMenus.empty': 'No POS menus available for the selected restaurants',
    'menu.products.copy.form.posMenus.placeholder': 'Select menus...',
    'menu.products.copy.form.posMenus.warning':
        '⚠️ Warning, by default, all active menus of a restaurant are selected for product propagation.',
    'menu.products.copy.form.marketplaceMenus.title': 'Active Marketplace Menus',
    'menu.products.copy.form.marketplaceMenus.description':
        'This table only displays restaurants where multiple marketplace menus are active. If only one marketplace menu is active, the propagation is done by default on this menu.',
    'menu.products.copy.form.marketplaceMenus.tooltip':
        'Select the marketplace menus where you want to propagate the products for each restaurant.',
    'menu.products.copy.form.marketplaceMenus.tooltip.title': 'Marketplace menus selection',
    'menu.products.copy.form.marketplaceMenus.tooltip.example':
        'If a restaurant has multiple marketplace menus, you can choose to propagate to one or more specific menus.',
    'menu.products.copy.form.marketplaceMenus.column.restaurant': 'Restaurant name',
    'menu.products.copy.form.marketplaceMenus.column.menus': 'Active menu(s)',
    'menu.products.copy.form.marketplaceMenus.empty': 'No marketplace menus available for the selected restaurants',
    'menu.products.copy.form.marketplaceMenus.placeholder': 'Select menus...',
    'menu.products.copy.form.marketplaceMenus.warning':
        '⚠️ Warning, by default, all active menus of a restaurant are selected for product propagation.',
    'menu.products.copy.form.publishAfterCopy.marketplace.title': 'During propagation, I want to:',
    'menu.products.copy.form.publishAfterCopy.marketplace': 'Automatically publish menus to associated marketplaces',
    'menu.products.copy.form.publishAfterCopy.marketplace.disclaimer':
        'The menus will be published on the marketplaces associated with the restaurants.',
    'menu.products.copy.form.disclaimer':
        '⚠️ Attention, these products will be copied to all selected restaurants, in all their menus. Before saving, check their name, description, image, VAT and price.',
    'menu.copy.validate.title': 'Verification of products / steps to propagate',
    'menu.copy.validate.success': 'All products / steps to propagate have a configured SKU / step reference',
    'menu.copy.validate.warning': 'SKU not set in the product sheet of the brand menu',
    'menu.copy.validate.error': 'Duplicate SKU or step reference not set in the brand menu',
    'menu.copy.validate.step.missing.identifier.detail': 'Step reference not set on the step',
    'menu.copy.validate.product.missing.identifier.detail': 'SKU not set on the product',
    'menu.copy.validate.step.duplicate.identifier.detail':
        'Conflict on the reference <b>{identifier}</b> between the steps',
    'menu.copy.validate.product.duplicate.identifier.detail':
        'Conflict on the SKU <b>{identifier}</b> between the products',
    'menu.products.copy.form.attribute.price': 'Price',
    'menu.products.copy.form.attribute.vat': 'VAT',
    'menu.products.copy.form.attribute.name': 'Name',
    'menu.products.copy.form.attribute.description': 'Description',
    'menu.products.copy.form.attribute.categories': 'Parent categories',
    'menu.products.copy.form.attribute.tags': 'Tags',
    'menu.products.copy.form.attribute.imageId': 'Image',
    'menu.products.copy.form.attribute.exceedPrice': 'Exceeding price',
    'menu.products.copy.form.attribute.maxProductQuantity': 'Max quantity',
    'menu.products.overwrite': 'Check the box on the left to edit fields',
    'menu.products.overwriteRelations': 'Check the box on the left to replace everything instead of adding items',
    'menu.products.error.alreadyTaken': 'This product already exists',
    'menu.products.error.billingCodeRequired': 'Auto billing requires to fill this field',
    'menu.products.add.title': 'Add product',
    'menu.products.edit.title': 'Edit product',
    'menu.products.propagate.title': 'Propagate products',
    'menu.products.create.title': 'Create product',
    'menu.products.delete.confirm': 'Are you sure you want to delete {count} product(s)?',
    'menu.products.form.price': 'Price (including tax)',
    'menu.product.form.pricePerkg': 'Price (including tax) / kg',
    'menu.products.form.priceType': 'Price type',
    'menu.products.form.priceType.placeholder': 'Price type',
    'menu.products.form.priceType.fixed': 'Fixed price',
    'menu.products.form.priceType.customizablePrice': 'Product with customizable price',
    'menu.products.form.priceType.customizablePriceAndLabel': 'Product with customizable price and label',
    'menu.products.form.availability': 'Availability by channel',
    'menu.products.form.kioskAvailability': 'Kiosk availability',
    'menu.products.form.webAvailability': 'Web availability',
    'menu.products.form.servingCount': 'Service count',
    'menu.products.form.barCode': 'Barcode',
    'menu.products.form.ticketLabel': 'Production label',
    'menu.products.form.ticketLabel.checkbox': 'Having a production label different from the product name.',
    'menu.products.form.noVat': 'No VAT',
    'menu.products.form.vat': 'Default VAT',
    'menu.products.form.image.placeholder': 'Image',
    'menu.products.form.externalId': 'External code',
    'menu.products.form.sku': 'sku',
    'menu.products.form.sku.placeholder': 'Choose a SKU',
    'menu.products.form.sku.noOption': 'SKU can only be created at brand leveL.',
    'menu.products.form.createSku': 'Create SKU "{value}"',
    'menu.products.form.replaceSkuAll': 'Replace SKU "{currentSku}" with "{value}" (on all products with the same SKU)',
    'menu.products.form.replaceSkuThisProduct': 'Replace SKU "{currentSku}" with "{value}" (only on this product)',
    'menu.products.form.createTag': 'Create tag "{value}"',
    'menu.products.form.billingCode': 'Billing code',
    'menu.products.form.purchasePrice': 'Purchase price',
    'menu.products.form.description': 'Description',
    'menu.products.form.description.tooLong': 'The description must not exceed 1500 characters',
    'menu.products.form.additionalInformation': 'Additional information',
    'menu.products.form.section.options': 'Options',
    'menu.products.form.section.quantity': 'Stock management',
    'menu.products.form.section.externalData': 'External data',
    'menu.products.form.currentQuantitySwitch': 'Enable stock management for product',
    'menu.products.form.defaultQuantitySwitch': 'Daily stock reset',
    'menu.products.form.currentQuantityInput': 'Quantity in stock',
    'menu.products.form.defaultQuantityInput': 'Quantity at start of day',
    'menu.products.form.defaultQuantityHint':
        'Every day between 4 and 5 a.m., the quantity is reset to the default value.',
    'menu.products.form.isEligibleLuncheon': 'Eligible for luncheon vouchers',
    'menu.products.form.isFinalProduct': 'Final product',
    'menu.products.form.admissible': 'Admissible',
    'menu.products.form.subsidizable': 'Subsidizable',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants': 'Multiply entrance fees/grants on each cart addition',
    'menu.products.form.shouldMultiplyEntranceFeesAndGrants.tooltip':
        'By enabling this option, entrance fees (and grants) will be multiplied in the order if the product is added multiple times to the cart or if another product with the same option is added. Multiplication is limited by the daily limit and cap defined in the pricing policy.',
    'menu.products.form.excludedFromUrssaf': 'Excluded from URSSAF',
    'menu.products.form.section.pos': 'Specific POS',
    'menu.products.form.minQuantity': 'Minimum quantity',
    'menu.products.form.alwaysAskForCustomization': 'Always ask for customization',
    'menu.products.form.discountable': 'Discountable',
    'menu.products.form.isDeposit': 'Is deposit',
    'menu.products.form.posPrice': 'Deposit price',
    'menu.products.form.vatSitIn': 'VAT sit-in',
    'menu.products.form.vatDelivery': 'VAT delivery',
    'menu.products.form.vatTakeAway': 'VAT take-away',
    'product.vatGroup': 'VAT Group',
    'product.vatGroup.withHint': 'VAT Group (eat-in / take-away / delivery)',
    'product.selectVatGroup': 'Select a VAT group',
    'product.vatGroup.noOperationZone': 'No operation zone configured for this restaurant',
    'product.vatGroup.eatIn': 'Eat-in',
    'product.vatGroup.takeAway': 'Take-away',
    'product.vatGroup.delivery': 'Delivery',
    'product.vatGroup.hint':
        'To change VAT per consumption mode, please now edit the « VAT Group (eat-in / take-away / delivery) » field',
    'menu.products.form.section.kitchenOptions': 'Kitchen screen options',
    'menu.products.form.isMenu': 'Is a menu',
    'menu.products.form.is_customization': 'Is a customization',
    'menu.products.form.isProducible': 'Display in summary',
    'menu.products.form.no_kitchen': "Don't display on kitchen screen",
    'menu.products.form.section.consumptionMode': 'Available by consumption mode',
    'menu.products.form.consumptionModeType.mode_sit_in': 'Sit in',
    'menu.products.form.consumptionModeType.mode_delivery': 'Delivery',
    'menu.products.form.consumptionModeType.mode_take_away': 'Take away',
    'menu.products.form.consumptionModeType.mode_drive': 'Drive',
    'menu.products.form.tags': 'Tags',
    'menu.products.form.tags.placeholder': 'Search tags',
    'menu.products.form.categories': 'Parent categories',
    'menu.products.form.categories.placeholder': 'Search category',
    'menu.products.form.productType': 'Type',
    'menu.products.form.productType.placeholder': 'Product type',
    'menu.products.form.productType.product': 'Product',
    'menu.products.form.productType.deposit': 'Deposit',
    'menu.products.form.measurementUnit': 'Measured in',
    'menu.products.form.measurementUnit.placeholder': 'Measured in',
    'menu.products.form.measurementUnit.unit': 'Unit',
    'menu.products.form.measurementUnit.kg': 'kg',
    'menu.products.form.kg.channelRestriction': 'Products in kg are not available on Kiosk channel.',
    'menu.products.form.externalReference': 'External references',
    'menu.products.form.machineCode': 'Nayax product machine code',
    'menu.products.form.steps': 'Steps',
    'menu.products.form.steps.page': 'Page {pageNumber}',
    'menu.products.form.steps.addToNewPage': 'Add to new page',
    'menu.products.form.steps.addEachToNewPage': 'Add each step to a new page',
    'menu.products.form.steps.addToPage': 'Page to add the step to',
    'menu.products.form.steps.addEmptyPage': 'Add empty page',
    'menu.products.form.externalReference.placeholder': 'Reference name',
    'menu.products.form.externalReference.name': 'Name',
    'menu.products.form.externalReference.value': 'Value',
    'menu.products.form.steps.add': 'Add step',
    'menu.products.form.steps.addPage': 'Drop step here to add a page',
    'menu.products.form.steps.column.name': 'Name',
    'menu.products.form.steps.column.type': 'Type',
    'menu.products.form.steps.column.choices': 'Possible choices',
    'menu.products.form.steps.column.position': 'Page',
    'menu.products.form.steps.column.subPosition': 'Position',
    'menu.products.form.steps.column.min': 'Min',
    'menu.products.form.steps.column.max': 'Max',
    'menu.products.form.steps.column.parentsProducts': 'Parent products number',
    'menu.products.form.steps.cross-selling.add': 'Add cross-selling',
    'menu.products.form.steps.customization.add': 'Add customization',
    'menu.products.form.steps.type.cross-selling': 'Cross-selling',
    'menu.products.form.steps.type.customization': 'Customization',

    // Report Generations History
    'reportGenerationsHistory.title': 'Generations history',
    'reportGenerationsHistory.subtitle': "You will find here the list of your export generation's history.",
    'reportGenerationsHistory.tableCard.title': 'Exports',
    'reportGenerationsHistory.tableCard.subtitle': 'List of exports',
    'reportGenerationsHistory.tableCard.actionLabel': 'Refresh the page',
    'reportGenerationsHistory.emptyMessage': 'Your generations history is empty',
    'reportGenerationsHistory.tableHeader.createdAt': 'Date',
    'reportGenerationsHistory.tableHeader.fileName': 'File name',
    'reportGenerationsHistory.tableHeader.reportType': 'Report',
    'reportGenerationsHistory.tableHeader.status': 'Progress',
    'reportGenerationsHistory.tableHeader.action': 'Download',
    'reportGenerationsHistory.tableRow.reportType.pre_invoicing': 'Pre-invoicing',
    'reportGenerationsHistory.tableRow.reportType.orders': 'Orders',
    'reportGenerationsHistory.tableRow.reportType.badge_balance': 'Badge transactions',
    'reportGenerationsHistory.tableRow.reportType.sales_summary': 'Sales summary',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary':
        'Sales summary by account payment type',
    'reportGenerationsHistory.tableRow.reportType.collective_catering_sales_summary_exclude_tax':
        'Sales summary by account payment type with tax excluded',
    'reportGenerationsHistory.tableRow.reportType.ewallet': 'E-wallet',
    'reportGenerationsHistory.tableRow.reportType.accounting': 'Accounting',
    'reportGenerationsHistory.tableRow.reportType.monthly_sales_report': 'Monthly Sales Report',
    'reportGenerationsHistory.tableRow.reportType.ewallet_stats_by_users': 'Badge Balance by Customer',
    'reportGenerationsHistory.tableRow.generationStatus.succeed': 'Succeed',
    'reportGenerationsHistory.tableRow.generationStatus.in_progress': 'In Progress',
    'reportGenerationsHistory.tableRow.generationStatus.failed': 'Failed',
    'reportGenerationsHistory.tableRow.action.download': 'Download',
    'report.savedFiltersDropdown.placeholder': 'Saved filters',
    'report.savedFiltersDropdown.deleteModal.title': 'Warning',
    'report.savedFiltersDropdown.deleteModal.description': 'Are you sure you want to delete?',

    // Reports
    'report.emptyMessage': 'No result',
    'report.title.monthly_sales_report': 'Monthly Sales Report',
    'report.selectDateRangeButton.text': 'From {startDate} to {endDate}',
    'report.calendarModal.dateRage.errorMessage': 'You can’t select more than {maxRangeInDays} days',
    'report.calendarModal.title': 'Pick a period',
    'report.calendarModal.submit': 'Validate',
    'report.filtersButton.text': 'Filters',
    'report.filtersModal.title': 'Choose filtres',
    'report.filtersModal.submit': 'Filter',
    'report.filtersModal.form.restaurantLabel': 'Restaurants',
    'report.filtersModal.form.devicesLabel': 'Pos',
    'report.filtersModal.form.sourcesLabel': 'Sources',
    'report.filtersModal.form.tagsLabel': 'Tags',
    'report.filtersModal.form.consumptionModesLabel': 'Consumption modes',
    'report.filtersModal.form.sellersLabel': 'Sellers',
    'report.filtersModal.form.vatsLabel': 'Vat',
    'report.filtersModal.form.categoriesLabel': 'Categories',
    'report.filtersModal.form.loyaltyLabel': 'Display only orders payed with the loyalty program',
    'report.filtersModal.form.only_parentsLabel': 'Display parents category',
    'report.filtersModal.saveAs.placeholder': 'Save as ...',
    'report.filtersModal.saveAs.save': 'Save & Apply',
    'report.exportButton.text': 'Export',
    'report.exportResultModal.title': 'CSV Export',
    'report.exportResultModal.resultSuccess': 'The export generation is in progress',
    'report.exportResultModal.stayInPage': 'Stay on this page',
    'report.exportResultModal.redirectToGenerationHistory': 'See current exports',
    'report.exportResultModal.resultFail': 'Un problème est survenu, veuillez réessayer dans quelques instants',

    // Sales Summary
    'salesSummary.tableCard.title': 'Generate new export',
    'salesSummary.tableCard.subtitle': 'Select your filters, click on "Generate report".',
    'salesSummary.form.choosePeriod': 'Choose a period',
    'salesSummary.form.reportType': 'Report format',
    'salesSummary.form.reportType.collectiveCateringSalesSummary': 'Sales summary by account payment type',
    'salesSummary.form.reportType.collectiveCateringSalesSummaryExclTax':
        'Sales summary by account payment type with tax excluded',

    'salesSummary.form.reportType.salesSummary': 'Sales summary',
    'salesSummary.form.restaurants': 'Restaurants',
    'salesSummary.form.groups': 'Groups',
    'salesSummary.form.pricingRules': 'Pricing rules',
    'salesSummary.form.accountedOrders': 'Billed orders',
    'salesSummary.form.accountedOrders.all': 'Orders + Contra-entries',
    'salesSummary.form.accountedOrders.ordersOnly': 'Orders',
    'salesSummary.form.accountedOrders.contraEntriesOnly': 'Contra-entries',
    'salesSummary.exportResultModal.title': 'Export Generation',

    // Shifts
    'shift.default': 'Default',
    'shift.allDays': 'All days',
    'shift.period': 'From {start} to {end}',
    'shift.days.MON': 'Monday',
    'shift.days.TUE': 'Tuesday',
    'shift.days.WED': 'Wednesday',
    'shift.days.THU': 'Thursday',
    'shift.days.FRI': 'Friday',
    'shift.days.SAT': 'Saturday',
    'shift.days.SUN': 'Sunday',
    'shift.amount.required': 'The amount is required',
    'shift.amount.positive': 'The amount must be positive',
    'shift.threshold.positive': 'The threshold must be positive',
    'shift.ceiling.required': 'The ceiling is required for a rate grant',
    'shift.vat.required': 'The VAT is required',
    'shift.vat.positive': 'The VAT must be positive',

    // Brand's History
    'brandHistory.tableCard.title': 'History',
    'brandHistory.tableCard.subtitle': "Search through your brand's history",
    'brandHistory.emptyMessage': 'No history found',
    'brandHistory.searchPlaceholder': 'Search history',

    'brandHistory.entityType': 'Entity',
    'brandHistory.entityType.GRANT': 'Grant',
    'brandHistory.entityType.ENTRANCE_FEE': 'Entrance Fee',
    'brandHistory.entityType.PRICING_RULE': 'Pricing Rule',
    'brandHistory.entityType.PRODUCT': 'Product',
    'brandHistory.entityType.STEP': 'Step',
    'brandHistory.entityType.CATEGORY': 'Category',
    'brandHistory.entityType.MENU': 'Menu',
    'brandHistory.entityType.MODULE': 'Module',
    'brandHistory.entityType.CUSTOMER': 'Customer',
    'brandHistory.entityType.CUSTOMERS_IMPORT': 'Customers import',
    'brandHistory.entityType.CUSTOMERS_UPDATE': 'Customers update',
    'brandHistory.entityType.USER': 'User',
    'brandHistory.entityType.CHANNEL': 'Channel',
    'brandHistory.entityType.CONSUMPTION_MODE': 'Consumption mode',
    'brandHistory.entityType.ORDER': 'Order',
    'brandHistory.entityType.BRAND': 'Brand',
    'brandHistory.entityType.RESTAURANT': 'Restaurant',

    'brandHistory.entityName': 'Entity name',
    'brandHistory.restaurant': 'Restaurant',
    'brandHistory.user': 'User',
    'brandHistory.action': 'Action',
    'brandHistory.eventDate': 'Date',

    'brandHistory.action.create': 'Create',
    'brandHistory.action.open': 'Open',
    'brandHistory.action.activate': 'Activate',
    'brandHistory.action.duplicate': 'Duplicate',
    'brandHistory.action.delete': 'Delete',
    'brandHistory.action.close': 'Close',
    'brandHistory.action.deactivate': 'Deactivate',
    'brandHistory.action.cancel': 'Cancel',
    'brandHistory.action.update': 'Update',
    'brandHistory.action.import': 'Import',
    'brandHistory.action.unknown': 'Unknown',

    'brandHistory.modal.title': 'Report on actions taken',
    'brandHistory.modal.actions': 'Report on actions',
    'brandHistory.modal.logs': 'Report on logs',
    'brandHistory.modal.informations': 'Related informations',
    'brandHistory.modal.entityName': 'Entity name',
    'brandHistory.modal.user': 'User : ',
    'brandHistory.modal.date': 'Date of change : ',
    'brandHistory.modal.close': 'Close',
    'brandHistory.modal.empty': 'Nothing to see here 😰',

    // Cross-selling
    'crossSelling.name': "Cross-selling's page name",
    'crossSelling.page.title': 'Cross-selling',
    'crossSelling.page.description': 'Create and admin your cross-selling pages',
    'crossSelling.action.newCrossSelling': '+ New cross-selling page',
    'crossSelling.modal.duplicate.title': 'Duplicate cross-selling page',
    'crossSelling.modal.create.title': 'Create your cross-selling page',
    'crossSelling.modal.delete.title': 'Delete your cross-selling page',
    'crossSelling.modal.delete.description':
        'Do you really want to delete this cross-selling page : "{crossSellingName}"?',
    'crossSelling.modal.error.name': 'please enter a name',
    'crossSelling.modal.menu.name': 'Name of the cross-selling page',
    'crossSelling.page.create.title': 'Create a Cross-selling page',
    'crossSelling.page.update.title': 'Edit the Cross-selling page "{crossSellingName}"',
    'crossSelling.page.create.description': 'Cross-Selling page configuration',
    'crossSelling.page.update.description': 'Cross-Selling page configuration',
    'crossSelling.products.image': 'Image',
    'crossSelling.products.name': 'Name',
    'crossSelling.products.price': 'Price',
    'crossSelling.products.vat': 'VAT',
    'crossSelling.products.tags': 'Tags',
    'crossSelling.products.sku': 'SKU',
    'crossSelling.products.menuName': 'Menu',
    'crossSelling.products.menuState': 'Menu State',
    'crossSelling.products.restaurantName': 'Restaurant',
    'crossSelling.products.add': 'Add products',
    'crossSelling.products.menuState.enabled': 'Enabled',
    'crossSelling.products.menuState.disabled': 'Disabled',

    // Table Layout
    'tableLayout.name': 'Table layout name',
    'tableLayout.page.title': 'Tables layouts',
    'tableLayout.page.description': 'Create and manage your tables layouts',
    'tableLayout.table.associatedPos': 'Associated pos',
    'tableLayout.action.newTableLayout': '+ New table layout',
    'tableLayout.modal.create.title': 'Create a table layout',
    'tableLayout.modal.edit.title': 'Update the table layout "{tableLayoutName}"',
    'tableLayout.modal.delete.title': 'Delete a table layout',
    'tableLayout.modal.delete.description': 'Are you sure you want to delete the table layout: "{tableLayoutName}"?',
    'tableLayout.modal.publish.title': 'Publish a table layout',
    'tableLayout.modal.publish.description': 'Are you sure you want to publish the table layout: "{tableLayoutName}"?',
    'tableLayout.modal.error.name': 'Enter a name in the dedicated field',

    // Room
    'room.name': 'Room name',
    'room.page.title': 'Rooms',
    'room.page.description': 'Create and manage your rooms',
    'room.action.newRoom': '+ New room',
    'room.action.publish': 'Publish the tables layout',
    'room.modal.create.title': 'Create a room',
    'room.modal.edit.title': 'Update the room "{roomName}"',
    'room.modal.view.title': '"{roomName}" room',
    'room.modal.single': 'Add single table',
    'room.modal.single.placeholder': 'Main table',
    'room.modal.multiple': 'Add multiple tables',
    'room.modal.multiple.placeholder1': '1',
    'room.modal.multiple.placeholder2': '10',
    'room.modal.layout': 'Arrange your tables',
    'room.modal.delete.title': 'Delete a room',
    'room.modal.delete.description': 'Are you sure you want to delete the room : "{roomName}"?',
    'room.modal.error.name': 'Enter a name in the dedicated field',
    'room.modal.error.new_table_name': 'Enter a table name or number',
    'room.modal.error.fill_start_and_end': 'Enter a start value and an end value (greater than the start value)',
    'room.modal.error.max_count_table': 'You cannot have more than {maxCount} tables per room.',

    // POS config
    'pos.configuration': 'Configuration',
    'pos.devices': 'Registers',
    'pos.access': 'Roles and permissions',
    'pos.access.users': 'Users',
    'pos.access.roles': 'Roles',
    'pos.access.groups': 'Groups',
    'pos.users.page.title': 'Cash register`s Operators',
    'pos.roles.page.title': 'Cash register`s roles and permissions',
    'pos.groups.page.title': 'Cash register`s access groups',
    'pos.users.page.description':
        'Checkout operators allow defining the users who can interact with the cash register.',
    'pos.roles.page.description': 'Checkout roles allow defining permission groups for cash register`s users.',
    'pos.groups.page.description':
        'Access groups manage users and their association with the restaurant`s cash registers.',
    'pos.users.action.newUser': 'Create a new operator',
    'posUser.name.form.label': 'Operator Name',
    'posUser.name.form.placeholder': 'Cashier Operator Name',
    'posUser.pinCode.form.label': 'Operator PIN Code',
    'posUser.pinCode.form.placeholder': 'Cashier Operator PIN Code',
    'posUser.role.form.label': 'Operator Role',
    'posGroup.name.form.label': 'Group name',
    'posGroup.name.form.placeholder': "Type the access group's name",
    'posGroup.users.form.label': 'Operator',
    'posGroup.users.form.placeholder': 'Select associated operators',
    'posGroup.devices.form.label': 'Devices',
    'posGroup.devices.form.placeholder': 'Select associated devices',
    'posUser.create.form.title': 'Create new cashier operator',
    'posGroup.create.form.title': 'Create new access group',
    'posGroup.edit.form.title': 'Edit the access group',
    'posUser.edit.form.title': 'Edit cashier operator: ',
    'posUser.form.description': 'Please provide the information for your checkout operator.',
    'posGroup.form.description': 'Please provide the information for your access group.',
    'posUser.form.creation': 'Creation of a cashier operator',
    'posUser.form.edit': 'Editing a cashier operator',
    'posUser.form.update': 'Editing a cashier operator',

    'posRole.form.title': 'Cashier Role',
    'posRole.form.description': 'You can update the permissions for your cashier role from this page',
    'posRole.form.creation': 'Creation of a cashier role',
    'posRole.form.update': 'Editing a cashier role',
    'posGroup.form.creation': 'Creation of an access group',
    'posGroup.form.update': 'Editing of an access group',
    'posRole.form.rolePermissions': 'Role`s permissions',
    'posRole.form.name.title': 'Role Name',
    'posRole.form.name.placeholder': 'Role',

    // Default POS roles
    'posRole.Operator': 'Operator',
    'posRole.Manager': 'Manager',
    'posRole.Owner': 'Owner',
    'posRole.Auditor': 'Auditor',
    'posRole.Treasurer': 'Treasurer',
    'posRole.Support': 'Support',
    'posRole.Trainer': 'Trainer',
    'posRole.InCharge': 'In charge',
    'posRole.OperatorSupervisor': 'Operator supervisor',
    'posRole.AssistantOperator': 'Assistant operator',
    'posRole.AssistantToTheRegionalManager': 'Assistant manager',
    'posRole.CustomOperator1': 'Operator custom 1',
    'posRole.CustomOperator2': 'Operator custom 2',
    'posRole.CustomOperator3': 'Operator custom 3',

    'pos.groups.action.create': 'Create a new group',
    'permissions.permissions': 'Permissions',
    'assiciated.devices': 'Associated devices',
    'assiciated.operators': 'Associated operators',

    'channels.page.title': 'Channels list',
    'channels.page.description':
        'Ordering canals allow you to offer features such as web ordering, kiosk point-of-sale or loyalty management.',
    'channels.installed': 'Application Installed',
    'channels.button.configure': 'Setup',
    'channels.button.disable': 'Disable',
    'channels.button.enable': 'Enable',

    'channels.kiosk.name': 'Kiosk',
    'channels.kiosk.description': 'Reinvent the point-of-sale experience in the best way.',

    'channels.web.name': 'Web Ordering',
    'channels.web.description': 'A new point of sale from your own website.',

    'channels.reception.name': 'Tablet',
    'channels.reception.description': 'A dedicated interface for your web orders and kiosks.',

    'channels.pos.name': 'POS',
    'channels.pos.description': 'Your payment system is simple and integrated into your environment.',

    'channels.kds.name': 'Kitchen Display',
    'channels.kds.description': 'Further energize your kitchen with perfect organization.',

    'channels.loyalty.name': 'Loyalty',
    'channels.loyalty.description': 'Build loyalty, bring your customers back to the point of sale.',

    'channels.ewallet_kiosk.name': 'EWallet Kiosk',
    'channels.ewallet_kiosk.description': 'The new channel for quickly recharging your e-wallet.',

    'channels.vending_machine.name': 'Vending machine',
    'channels.vending_machine.description': 'Offer e-wallet payments on your coffee machines and beverage dispensers.',

    'accessFlags.CAN_ACCESS_BRAND_HISTORY': 'Can access brand history page',
    'accessFlags.CAN_ACCESS_CUSTOMERS_SECTION': 'Can access Customers section',
    'accessFlags.CAN_ACCESS_GRANTS_AND_ENTRANCE_FEES_SECTION': 'Can access Grants and entrance fees section',
    'accessFlags.CAN_ACCESS_IO_PAY': 'Can access the Payment section',
    'accessFlags.CAN_ARCHIVE_CUSTOMERS': 'Can archive his customers.',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_AMOUNT': 'Can create orders with a negative amount',
    'accessFlags.CAN_CREATE_ORDERS_WITH_NEGATIVE_BALANCE':
        "Can create orders that will make the customer's balance go into the negative",
    'accessFlags.CAN_CREDIT_POST_PAYMENT_CUSTOMERS_EWALLET': 'Can credit the ewallet of a post-payment customer',
    'accessFlags.CAN_EDIT_AREAS': 'Can edit delivery areas',
    'accessFlags.CAN_EDIT_AUTO_BILLING_REFERENTIAL': 'Auto billing: Can edit billing referential',
    'accessFlags.CAN_EDIT_CUSTOMERS_CREDENTIALS': 'Can edit customers credentials',
    'accessFlags.CAN_EXPORT_CUSTOMERS_CSV': 'Can export customer data and edit E-wallet balance',
    'accessFlags.CAN_FORCE_DEFAULT_CREDENTIALS_CHANGE':
        'Can force new customers to edit their credentials provided by default',
    'accessFlags.CAN_MANAGE_BO_USERS': 'Can manage backoffice users',
    'accessFlags.CAN_MANAGE_BRAND_EWALLET_OVERDRAFT': 'Can manage brand-level e-wallet overdraft settings',
    'accessFlags.CAN_MANAGE_CUSTOMER_EWALLET_OVERDRAFT': 'Can manage customer-level e-wallet overdraft settings',
    'accessFlags.CAN_ONLY_EDIT_PRICE_AND_PRODUCT_NAME': 'Can only edit price and name of related products and steps',
    'accessFlags.CAN_SYNC_SALES': 'Can synchronize restaurant sales',
    'accessFlags.CAN_EDIT_TABLE_LAYOUT': 'Can edit tables layouts',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE': 'Can create orders with a custom price',
    'accessFlags.CAN_CREATE_ORDER_WITH_CUSTOM_PRICE_FOR_ALL_PRODUCTS':
        'Can create orders with a custom price for all prodcuts',
    'accessFlags.MENU_CATEGORY_CREATE_OR_DELETE': 'Can create or delete categories',
    'accessFlags.MENU_CATEGORY_EDIT': 'Can edit categories',
    'accessFlags.MENU_CREATE_OR_DELETE': 'Can create or delete menus',
    'accessFlags.MENU_EDIT': 'Can edit menus',
    'accessFlags.MENU_PRODUCT_CREATE_OR_DELETE': 'Can create or delete products',
    'accessFlags.MENU_PRODUCT_EDIT': 'Can edit products',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_ONLY': 'Restrict editing to product price',
    'accessFlags.MENU_PRODUCT_EDIT_PRICE_BLOCKED_ONLY': 'Block editing of product price',
    'accessFlags.MENU_STEP_CREATE_OR_DELETE': 'Can create or delete steps',
    'accessFlags.MENU_STEP_EDIT': 'Can edit steps',
    'accessFlags.MENU_TAG_CREATE_OR_DELETE': 'Can create or delete tags',
    'accessFlags.MENU_TAG_EDIT': 'Can edit tags',
    'accessFlags.CAN_CHANGE_OWN_PASSWORD': 'Can edit his password',
    'accessFlags.CAN_CANCEL_ORDER_WITH_CONTRA_ENTRY': 'Can cancel an order (contra entry)',
    'accessFlags.CAN_CREATE_SKU': 'Can create SKUs',

    'accessFlagsGroups.customers': 'Customer Management',
    'accessFlagsGroups.financial': 'Financial / E-Wallet Management',
    'accessFlagsGroups.orders': 'Order Management',
    'accessFlagsGroups.catalog': 'Catalog Management',
    'accessFlagsGroups.subsidies': 'Subsidies & Entrance Fees',
    'accessFlagsGroups.configuration': 'Restaurant Configuration',
    'accessFlagsGroups.administration': 'Administration & Account',
    'accessFlagsGroups.others': 'Other Permissions',

    'accessFlagsSubsections.categories': 'Categories',
    'accessFlagsSubsections.menus': 'Menus',
    'accessFlagsSubsections.products': 'Products',
    'accessFlagsSubsections.steps': 'Steps',
    'accessFlagsSubsections.tags': 'Tags',

    'accessFlagsControl.expandAll': 'Expand all',
    'accessFlagsControl.collapseAll': 'Collapse all',
    'accessFlagsControl.permission': 'permission',
    'accessFlagsControl.permissions': 'permissions',

    'userRestaurants.noRestaurants': 'No restaurant available',

    'brandUsers.email': 'Email',
    'brandUsers.lastConnection': 'Last connection',
    'brandUsers.login': 'Login',
    'brandUsers.loginAs': 'Log as',
    'brandUsers.loginAsBrandGroup': 'Multi-brand account (non-connectable)',
    'brandUsers.newUser': '+ New user',
    'brandRestaurants.newRestaurant': '+ New restaurant',
    'brandRestaurants.create.restaurantInfo': 'Restaurant information',
    'brandRestaurants.create.restaurantName': 'Restaurant name',
    'brandRestaurants.create.phone': 'Phone number',
    'brandRestaurants.create.address': 'Address',
    'brandRestaurants.create.locale': 'Language',
    'brandRestaurants.create.currency': 'Currency',
    'brandRestaurants.create.operationZone': 'Operation zone',
    'brandRestaurants.create.operationZone.skip': 'Skip - configure later',
    'brandRestaurants.create.operationZoneConfigure': 'Operation zone configuration',
    'brandRestaurants.create.operationZone.selectProvider': 'Select compliance mode',
    'brandRestaurants.create.operationZone.currencyMismatch':
        "This zone uses a currency different from the brand's. A new brand is required to operate in this currency.",
    'brandRestaurants.create.manager': 'Manager',
    'brandRestaurants.create.selectExistingUser': 'Select existing user',
    'brandRestaurants.create.createNewUser': 'Create new user',
    'brandRestaurants.create.skipManager': 'Skip this step',
    'brandRestaurants.create.letUserChoosePassword': 'Let user choose password',
    'brandRestaurants.create.done.title': "You're done!",
    'brandRestaurants.create.done.message': "You're ready to configure {name}",
    'brandRestaurants.create.done.configure': 'Configure it',
    'user.create.title': 'Create a new user',
    'user.create.firstName': 'First name',
    'user.create.lastName': 'Last name',
    'user.create.phone': 'Phone number',
    'user.create.email': 'Email',
    'user.create.password': 'Password',
    'user.create.confirmPassword': 'Confirm password',
    'user.create.letUserChoosePassword': 'Let the user choose their password',
    'user.create.error.phone.length': 'Phone number must be 10 digits long.',
    'user.create.error.phone.valid': 'This needs to be a valid phone',
    'user.create.error.password.min': 'This needs to be a valid password (minimum 12 characters)',
    'user.create.error.passwordConfirm.sameAsPassword': 'The two passwords have to match.',

    'brands.restaurantscount': 'Restaurants',
    'brands.favorite': 'Favorite',
    'brands.create': '+ New brand',
    'brands.form.brandInfo': "Brand's information",
    'brands.form.brandInfo.title': 'Brand name',
    'brands.form.selectUser': "Select brand's manager",
    'brands.form.selectUser.title': 'Add brand manager',
    'brands.form.canals': "Select brand's channels",
    'brands.form.canals.title': 'Set up channels',
    'brands.form.brandName': 'Name',
    'brands.form.region': 'Region and language',
    'brands.form.currency': 'Currency',
    'brands.form.title': 'Add a new brand',
    'brands.form.firstName': 'First name *',
    'brands.form.lastName': 'Last name *',
    'brands.form.phoneNumber': 'Phone number *',
    'brands.form.email': 'Email *',
    'brands.form.password': 'Password *',
    'brands.form.confirmPassword': 'Confirm password *',
    'brands.form.error.phone.valid': 'This needs to be a valid phone',
    'brands.form.error.password.min': 'This needs to be a valid password (minimum 12 characters)',
    'brands.form.error.passwordConfirm.sameAsPassword': 'The two passwords have to match.',

    // Pos permissions
    'posPermissions.accessPermissions': 'Access permissions',
    'posPermissions.otherPermissions': 'Other permissions',
    'posPermissions.ACCESS_CATALOG_SCREEN': 'Catalog',
    'posPermissions.ACCESS_CUSTOMERS_SCREEN': 'Customers',
    'posPermissions.ACCESS_CUSTOMISATION_SCREEN': 'Customizations',
    'posPermissions.ACCESS_E_WALLET_SCREEN': 'E-Wallet',
    'posPermissions.ACCESS_MANAGE_CASH_FLOAT_SCREEN': 'Cash float',
    'posPermissions.ACCESS_MANAGE_DISCOUNT_SCREEN': 'Discount',
    'posPermissions.ACCESS_MANAGE_RUNNER_SCREEN': 'Runners',
    'posPermissions.ACCESS_MANAGE_TABLES_SCREEN': 'Table plan',
    'posPermissions.ACCESS_NEW_ORDER_SCREEN': 'New order',
    'posPermissions.ACCESS_ORDERS_FOLLOW_UP_SCREEN': 'Order follow up',
    'posPermissions.ACCESS_PARAMETER_SCREEN': 'Settings',
    'posPermissions.ACCESS_PRINTER_SCREEN': 'Printers',
    'posPermissions.ACCESS_RAZ_SCREEN': 'Reports',
    'posPermissions.ACCESS_TICKET_SCREEN': 'Tickets',
    'posPermissions.ACCESS_USER_SCREEN': 'Users',
    'posPermissions.APPLY_DISCOUNT': 'Apply discount',
    'posPermissions.CANCEL_ORDER': 'Cancel order',
    'posPermissions.CANCEL_VALIDATED_ORDER_ITEM': 'Cancel a product from validated order',
    'posPermissions.CREATE_GROUP': 'Create a group',
    'posPermissions.CREATE_PRODUCT': 'Create a product',
    'posPermissions.DELETE_DEFAULT_PRINTER': 'Delete default printer',
    'posPermissions.DISCONNECT': 'Disconnect POS',
    'posPermissions.ENTER_DISCOUNT_WHEN_PLACING_AN_ORDER': 'Enter a discount when placing an order',
    'posPermissions.EXPORT_ARCHIVE': 'Export archives',
    'posPermissions.FORCE_ORDER_SHIFT': 'Force the service of an order',
    'posPermissions.GENERATE_ARCHIVE': 'Generate fiscal archives',
    'posPermissions.JUSTIFY_ORDERS': 'Justify orders',
    'posPermissions.LINK_A_BADGE': 'Link a badge',
    'posPermissions.MODIFY_FEATURE_OPTIONS': 'Modify options',
    'posPermissions.MODIFY_FUNCTION_FROM_GRID': 'Modify a function with a long press',
    'posPermissions.MODIFY_GROUP_FROM_GRID': 'Modify a group with a long press',
    'posPermissions.MODIFY_ORDER_ITEM_PRICE': 'Modify product price in the cart',
    'posPermissions.MODIFY_PASSWORD': 'Change password',
    'posPermissions.MODIFY_PRODUCT_FROM_GRID': 'View product details',
    'posPermissions.MODIFY_SKU_BILLING_CODE_PURCHASE_PRICE': 'Modify SKU, billing code, and purchase price',
    'posPermissions.MODIFY_PRODUCT_PRICE': 'Modify product price in the product details',
    'posPermissions.MODIFY_PRODUCT_OTHER_INFO': 'Modify other properties in the product details',
    'posPermissions.MODIFY_TICKET': 'Modify tickets',
    'posPermissions.MODIFY_TICKET_GROUPS': 'Modify ticket groups',
    'posPermissions.MODIFY_TICKET_ORDER_PLACES': 'Modify ticket order place',
    'posPermissions.MODIFY_TICKET_ORDER_STATUS': 'Modify ticket order status',
    'posPermissions.MODIFY_TICKET_QUANTITY': 'Modify tickets quantity',
    'posPermissions.MODIFY_VALIDATED_ORDER_ITEM': 'Modify a product from validated order',
    'posPermissions.OFFER_PRODUCT_FOR_FREE': 'Offer product',
    'posPermissions.OPEN_CASH_DRAWER': 'Open cash drawer',
    'posPermissions.PRINT_VALID_TICKET': 'Print validated tickets',
    'posPermissions.REFUND_CLIENT': 'Refund customer',
    'posPermissions.REMOVE_PRODUCT_FROM_CATALOG': 'Remove a product from catalog',
    'posPermissions.REOPEN_ORDER': 'Reopen orders',
    'posPermissions.SEARCH_CLIENT': 'Manually search customer',
    'posPermissions.SHOW_APPLY_PRICING_RULE_BUTTON': 'Show apply pricing rule button',
    'posPermissions.SYNC_ARCHIVE': 'Synchronize archives',
    'posPermissions.VIEW_AUDIT_TRAIL': 'View audit trail',
    'posPermissions.VIEW_FEATURE_OPTIONS': 'View options',
    'posPermissions.VIEW_ORDER_AUDIT': 'View order audit',
    'posPermissions.VIEW_REVENUE_IN_FOLLOW_UP': 'View revenue in reports',
    'posPermissions.VIEW_TICKET_AUDIT': 'View ticket audit',
    'posPermissions.VIEW_TICKET_TEMPLATE': 'View ticket templates',
    'posPermissions.MODIFY_TICKET_PRINTER': 'Modify ticket printer',
    'posPermissions.VALIDATE_EPT_PAYMENT_OPERATIONS': 'Validate TPE operations',

    'multiBrand.user': 'User',

    // badge reader
    'badgeReader.empty': 'No badge reader configured',
    'badgeReader.notConfigured': "It seems that you don't have a badge reader configured. Please visit our",
    'badgeReader.help': 'help section.',
    'badgeReader.create': 'Create a badge reader',
    'badgeReader.table.title': 'Badge Readers',
    'badgeReader.table.name': 'Reader Name',
    'badgeReader.table.deviceUuid': 'Reader UUID',
    'badgeReader.table.driver': 'Reader Technology',
    'badgeReader.table.driverConfigs': 'Technology Variables',
    'badgeReader.table.readingConditions': 'Reading Rules',
    'badgeReader.table.keyboardLayout': 'Keyboard layout',
    'badgeReader.driverConfigs':
        'Baudrate = <b>{baudRate}</b> {br}Bits = <b>{dataBits}</b> {br}Parity = <b>{parity}</b> {br}Stop Bits = <b>{stopBits}</b>',
    'badgeReader.readingCondition.number': 'Condition #{index}:',
    'badgeReader.readingCondition.stringLength': '• If length = {stringLength} characters',
    'badgeReader.readingCondition.convertBefore.none': '• No conversion',
    'badgeReader.readingCondition.convertBefore.hex-dec': '• Convert to decimal = {stringLength}',
    'badgeReader.readingCondition.convertBefore.dec-hex': '• Convert to hexadecimal = {stringLength}',
    'badgeReader.readingCondition.convertBefore.hex-ascii': '• Convert to ASCII = {stringLength}',
    'badgeReader.readingCondition.convertBefore.remove-zero': '• Remove zero characters',
    'badgeReader.readingCondition.convertBefore.hex-inverter': '• Invert characters',
    'badgeReader.readingCondition.convertBefore.prefix': '• Add prefix {prefix} until {substrLength} characters',
    'badgeReader.readingCondition.substrPositionStart': '• Read from {substrPositionStart} characters',
    'badgeReader.readingCondition.substrLength': '• Read {substrLength} characters',
    'badgeReader.readingCondition.convertAfter.none': '• No conversion for these {substrLength} characters',
    'badgeReader.readingCondition.convertAfter.hex-dec': '• Convert these decimal characters to {convertAfter}',
    'badgeReader.readingCondition.convertAfter.dec-hex': '• Convert these hexadecimal characters to {convertAfter}',
    'badgeReader.readingCondition.convertAfter.hex-ascii': '• Convert these ASCII characters to {convertAfter}',
    'badgeReader.readingCondition.convertAfter.remove-zero': '• Remove zero characters',
    'badgeReader.readingCondition.convertAfter.hex-inverter': '• Invert these {substrLength} characters',
    'badgeReader.delete.confirmation': 'Are you sure you want to delete ?',
    'badgeReader.delete.warning': 'Attention',
    'badgeReader.cancel.confirmation': 'Are you sure you want to cancel the configuration?',
    'badgeReader.cancel.warning': 'Warning',
    // badge reader drivers
    'badgeReader.driver.keyboard': 'Keyboard Output',
    'badgeReader.driver.serial': 'Serial Protocol (RS232)',
    'badgeReader.driver.toqla': 'Toqla',
    // badge reader keyboard layouts
    'badgeReader.keyboardLayout.QWERTY': 'QWERTY',
    'badgeReader.keyboardLayout.AZERTY': 'AZERTY',
    // badge reader drivers
    'badgeReader.convertion.none': 'no conversion',
    'badgeReader.convertion.hex-dec': 'hexadecimal to decimal',
    'badgeReader.convertion.hex-ascii': 'hexadecimal to ASCII',
    'badgeReader.convertion.dec-hex': 'decimal to hexadecimal',
    // badge reader steps
    'badgeReader.step.information': 'Reader Creation',
    'badgeReader.step.driverConfigs': 'Technology Variables',
    'badgeReader.step.readingCondition': 'Reading Rules',
    // badge reader Form
    'badgeReader.form.name': 'Reader Name',
    'badgeReader.form.deviceId': 'Reader USB Identifier',
    'badgeReader.form.deviceUuid': 'Reader UUID',
    'badgeReader.form.driver': 'Reader Technology',
    'badgeReader.form.driverConfigBaudRate': 'Baud Rate',
    'badgeReader.form.driverConfigDataBits': 'Data Bits',
    'badgeReader.form.driverConfigParity': 'Parity',
    'badgeReader.form.driverConfigStopBits': 'Stop Bits',
    'badgeReader.form.keyboardLayout': 'keyboard layout',
    'badgeReader.form.readingCondition.order': 'Condition No.',
    'badgeReader.form.readingCondition.stringLength': 'Length',
    'badgeReader.form.readingCondition.convertBefore': 'Convert Before?',
    'badgeReader.form.readingCondition.substrPositionStart': 'Start Position / Prefix',
    'badgeReader.form.readingCondition.substrLength': 'Substring Length',
    'badgeReader.form.readingCondition.convertAfter': 'Convert After?',
    'badgeReader.step.readingCondition.add': 'Add +',
    // badge reader Form conversions
    'badgeReader.form.convertion.none': 'Disabled',
    'badgeReader.form.convertion.hex-dec': 'Hex > Dec',
    'badgeReader.form.convertion.hex-ascii': 'Hex > ASCII',
    'badgeReader.form.convertion.dec-hex': 'Dec > Hex',
    'badgeReader.form.convertion.remove-zero': 'Remove Zero',
    'badgeReader.form.convertion.qwerty-azerty': 'Qwerty > Azerty',
    'badgeReader.form.convertion.hex-inverter': 'Hexadecimal bitwise inversion',
    'badgeReader.form.convertion.prefix': 'Prefix',

    // POS device
    'posDevice.catalogHistory.title': 'Catalog History',
    'posDevice.catalogHistory.table.hash': 'Hash',
    'posDevice.catalogHistory.table.date': 'Creation Date',
    'posDevice.catalogHistory.table.actions': 'Actions',
    'posDevice.catalogHistory.button.download': 'Download',

    'passwordUpdate.title': 'Password Update',
    'passwordUpdate.currentPassword': 'Old password',
    'passwordUpdate.newPassword': 'New Password',
    'passwordUpdate.confirmPassword': 'Confirm New Password',
    'passwordUpdate.update': 'Save',
    'passwordUpdate.passwordMismatch': 'The new password and the confirmation password do not match.',
    'passwordUpdate.passwordMinLength': 'The password must be at least 12 characters long.',
    'passwordUpdate.success': 'Password updated successfully',

    // Notification
    'notification.guestHierarchy.title': 'New',
    'notification.guestHierarchy.content': 'The guest account hierarchy configuration is evolving.',
    'notification.guestHierarchy.link': 'Click here to learn more',

    // Guest hierarchy Training
    'guestHierarchyTraining.page1.title': 'Welcome to the client journey monitoring',
    'guestHierarchyTraining.page1.content':
        'The client journey monitoring allows a strict configuration of the guest accounts in the Back-Office (BO). It is based on a hierarchy in <b>Group → Section → Sub-section</b> and the assignment of <b>tariff rates</b> to these elements. This structuring ensures an optimized and consistent management.',
    'guestHierarchyTraining.page2.title': 'Access the Hierarchy',
    'guestHierarchyTraining.page2.content':
        'Open the new <b>Hierarchy</b> tab. This space allows you to <b>create, modify</b> groups, sections and sub-sections.',
    'guestHierarchyTraining.page3.title': 'Create or modify a Group',
    'guestHierarchyTraining.page3.content':
        '• Access <b>Hierarchy > Groups.</b> {br}• Click on <b>"Create a group"</b> or modify an existing one. {br}• A group has a <b>unique label</b> (1) {br}• Define the <b>allowed tariff rates</b> for guests associated with this group (2)',
    'guestHierarchyTraining.page4.title': 'Create or modify a Section',
    'guestHierarchyTraining.page4.content':
        '• Access <b>Hierarchy > Sections.</b> {br}• Click on <b>"Create a section"</b> or modify an existing one. {br}• Assign a section to an <b>existing group</b>. (1) {br}• A unique label is required. (2) {br} • Define the <b>allowed tariff rates</b> for guests associated with this section (3)',
    'guestHierarchyTraining.page5.title': 'Create or modify a Sub-section',
    'guestHierarchyTraining.page5.content':
        '• Access <b>Hierarchy > Sub-sections.</b> {br}• Click on <b>"Create a sub-section"</b> or modify an existing one. {br}• Assign a sub-section to an <b>existing section</b>. (1 and 2) {br}• A unique label is required. (3) {br} • Define the <b>allowed tariff rates</b> for guests associated with this sub-section (4)',

    // Guest hierarchy info
    'guestHierarchyInfo.title': 'Creating a guest',
    'guestHierarchyInfo.content':
        'When creating a guest, the proposed tariff rates are automatically filtered based on the selected group, section or sub-section.',

    // Loyalty
    'loyalty.features.title': 'Enabled features',
    'loyalty.features.MultiRewardSelection': 'Multiple reward selection',
    'loyalty.features.Promocode': 'Promo Codes',
    'loyalty.features.Deals': 'Deals',
    'loyalty.features.PointPayment': 'Point payment',

    // Splio
    'splio.title': 'Integration - Splio Loyalty',
    'splio.description':
        'Fill in the API key in the following field to associate your Splio program with your restaurant and Innovorder products.\nThis API key is to be retrieved from your Splio interface.',
    'splio.apiKey': 'Splio API Key',
    'splio.integrationEnabled': 'Integration enabled from {date}',
    'splio.apiKey.placeholder': 'Enter your Splio API Key',
    'splio.optIn': 'OptIn associated to the marketing newsletter',
    'splio.allowCustomerRewardUsage': 'Allow customer reward usage',
    'splio.programId': 'Loyalty program',
    'splio.formLink': 'Registration form link',
    'splio.memberIdentifier': 'Identifier to register',
    'splio.useCasualTone': 'Messages in casual version',
    'splio.authenticationMethods': 'Allowed loyalty authentication methods',
    'splio.registerMethods': 'Allowed loyalty registration methods',
    'splio.methods.email': 'E-mail',
    'splio.methods.phone': 'Phone',
    'splio.methods.externalId': 'Loyalty identifier',
    'splio.update.success': 'Splio integration updated successfully',
    'splio.subscriptionToMarketingNewsletter': 'Subscription to marketing newsletter',
    'splio.subscriptionToLoyaltyNewsletter': 'Subscription to loyalty newsletter',
    'splio.deleteModal.title': 'Splio integration deletion',
    'splio.deleteModal.text': 'Are you sure you want to delete the Splio integration?',
    'splio.error.changeProvider': 'A loyalty integration is already set up for this restaurant, please remove it first',
    'splio.error.formLinkInvalid': 'Invalid form link',

    // Pickup points
    'pickupPoint.page.title': 'Pickup points',
    'pickupPoint.page.description': 'Create and manage your pickup points',
    'pickupPoint.action.create': 'Create a pickup point',
    'pickupPoint.modal.createPickupPoint': 'Creation of a pickup point',
    'pickupPoint.modal.editPickupPoint': 'Modification of a pickup point',
    'pickupPoint.modal.deletePickupPoint': 'Deletion of a pickup point',
    'pickupPoint.modal.delete.title': 'Delete a pickup point',
    'pickupPoint.modal.delete.description': 'Are you sure you want to delete the pickup point "{name}"?',
    'pickupPoint.modal.pickupPoint.name': 'Name',
    'pickupPoint.modal.pickupPoint.address': 'Address',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo': 'Additional address info',
    'pickupPoint.modal.pickupPoint.name.placeholder': 'Pickup point name',
    'pickupPoint.modal.pickupPoint.address.placeholder': 'Pickup point address',
    'pickupPoint.modal.pickupPoint.additionalAddressInfo.placeholder': 'Pickup point additional address info',
    'pickupPoint.modal.warn.shift.title': 'Attention',
    'pickupPoint.modal.warn.shift.text':
        'Ensure that no orders are in progress before deleting this pickup point. Once deleted, it will no longer be visible to clients and any in-progress orders will be lost.',
    'pickupPoint.modal.warn.shift.button': 'Understood',

    // Como
    'como.title': 'Integration - Como Loyalty',
    'como.description':
        'Fill in the API key in the following field to associate your Como program with your restaurant and Innovorder products.\nThis API key is to be retrieved from your Como interface.',
    'como.apiKey': 'Como API Key',
    'como.integrationEnabled': 'Integration enabled from {date}',
    'como.apiKey.placeholder': 'Enter your Como API Key',
    'como.formLink': 'Registration form link',
    'como.useCasualTone': 'Messages in casual version',
    'como.authenticationMethods': 'Allowed loyalty authentication methods',
    'como.registerMethods': 'Allowed loyalty registration methods',
    'como.methods.email': 'E-mail',
    'como.methods.phone': 'Phone',
    'como.methods.externalId': 'Loyalty identifier',
    'como.error.formLinkInvalid': 'Invalid form link',
    'como.update.success': 'Como integration updated successfully',
    'como.deleteModal.title': 'Como integration deletion',
    'como.deleteModal.text': 'Are you sure you want to delete the Como integration?',
    'como.error.changeProvider': 'A loyalty integration is already set up for this restaurant, please remove it first',
    'como.error.invalidApiKey': 'The provided API key is invalid.',

    // Zerosix
    'zerosix.title': 'Integration - Zerosix Loyalty',
    'zerosix.description':
        'Fill in the API key in the following field to associate your Zerosix program with your restaurant and Innovorder products.\nThis API key is to be retrieved from your Zerosix interface.',
    'zerosix.apiKey': 'Clé API Zerosix',
    'zerosix.integrationEnabled': 'Integration enabled from {date}',
    'zerosix.apiKey.placeholder': 'Enter your Zerosix API Key',
    'zerosix.formLink': 'Links to the registration form',
    'zerosix.useCasualTone': 'Use casual tone',
    'zerosix.authenticationMethods': 'Allowed loyalty authentication methods',
    'zerosix.registerMethods': 'Allowed loyalty registration methods',
    'zerosix.methods.email': 'E-mail',
    'zerosix.methods.phone': 'Phone',
    'zerosix.methods.externalId': 'Loyalty identifier',
    'zerosix.error.formLinkInvalid': 'Invalid form link',
    'zerosix.update.success': 'Zerosix integration updated successfully',
    'zerosix.deleteModal.title': 'Zerosix integration deletion',
    'zerosix.deleteModal.text': 'Are you sure you want to delete the Zerosix integration?',
    'zerosix.error.changeProvider':
        'A loyalty integration is already set up for this restaurant, please remove it first',
    'zerosix.error.invalidApiKey': 'The provided API key is invalid.',

    // Restaurant Info
    'restaurantInfo.title': 'Restaurant information',
    'restaurantInfo.information.title': 'About the restaurant',
    'restaurantInfo.name': "Restaurant's name",
    'restaurantInfo.address': "Restaurant's address",
    'restaurantInfo.contactName': "Contact's name",
    'restaurantInfo.contactEmail': 'Mail address',
    'restaurantInfo.contactPhone': 'Phone number',
    'restaurantInfo.externalId': 'External Id',
    'restaurantInfo.tag': 'Restaurant tag',
    'restaurantInfo.families': 'Restaurant families',
    'restaurantInfo.searchFamilies': 'Search a family',
    'restaurantInfo.image': 'Restaurant image',
    'restaurantInfo.legal.title': 'Legals informations',
    'restaurantInfo.legal.description': 'This is displayed on a dedicated page within Web and Full sites channels.',
    'restaurantInfo.legal.socialReason': 'Corporate name',
    'restaurantInfo.legal.organizationType': 'Activity code',
    'restaurantInfo.legal.capital': 'Capital',
    'restaurantInfo.legal.commerceRegistryCity': 'Head office City',
    'restaurantInfo.legal.siren': 'Company Registration Number',
    'restaurantInfo.legal.taxNumber': 'VAT registration number',
    'restaurantInfo.legal.industryClassificationCode': 'Industry classification code',
    'restaurantInfo.legal.publicationDirectorName': 'Chief editor name',
    'restaurantInfo.legal.publicationDirectorFunction': 'Chief editor role',
    'restaurantInfo.legal.webmasterName': 'Webmaster name',
    'restaurantInfo.legal.webmasterEmail': 'Webmaster email',
    'restaurantInfo.ewalletMinimum.title': 'Minimum balance amount configuration',
    'restaurantInfo.ewalletMinimum.inputTitle': 'MINIMUM AMOUNT',
    'restaurantInfo.ewalletMinimum.caseZero':
        'In order not to put a minimum amount, indicate 0 in the field then save.',
    'restaurantInfo.delete.title': 'Delete Restaurant',
    'restaurantInfo.delete.description': 'This restaurant have been created at',
    'restaurantInfo.delete.button': 'Delete the restaurant',
    'restaurantInfo.save.error': 'An error occurred while saving, please try again.',
    'restaurantInfo.delete.error': 'An error occurred, please try again.',
    'restaurantInfo.delete.confirmTitle': 'Delete Restaurant',
    'restaurantInfo.delete.confirmDescription':
        'Are you sure you want to delete this restaurant? This action cannot be undone.',
    'restaurantInfo.schedule.title': 'Authorized collection hours',
    'restaurantInfo.schedule.manualEdit': 'Manual editing',
    'restaurantInfo.schedule.autoEdit': 'Automatic editing',
    'restaurantInfo.schedule.autoEditDescription': 'Allows you to create time slots quickly.',
    'restaurantInfo.schedule.description':
        "You can set different collection times for your restaurant. These slots correspond to your restaurant's opening hours, during which your customers will be able to pick up their orders placed online.",
    'restaurantInfo.schedule.open': 'Open',
    'restaurantInfo.schedule.closed': 'Closed',
    'restaurantInfo.schedule.day.mon': 'Mon',
    'restaurantInfo.schedule.day.tue': 'Tue',
    'restaurantInfo.schedule.day.wed': 'Wed',
    'restaurantInfo.schedule.day.thu': 'Thu',
    'restaurantInfo.schedule.day.fri': 'Fri',
    'restaurantInfo.schedule.day.sat': 'Sat',
    'restaurantInfo.schedule.day.sun': 'Sun',
    'restaurantInfo.schedule.mass.startHour': 'Start hour',
    'restaurantInfo.schedule.mass.endHour': 'End hour',
    'restaurantInfo.schedule.mass.granularity': 'Interval',
    'restaurantInfo.schedule.mass.15min': '15 min',
    'restaurantInfo.schedule.mass.30min': '30 min',
    'restaurantInfo.schedule.mass.1h': '1 hour',
    'restaurantInfo.schedule.mass.overwrite': 'Overwrite existing schedules',
    'restaurantInfo.schedule.mass.apply': 'Apply',
    'restaurantInfo.schedule.mass.noDays': 'Select at least one day.',
    'restaurantInfo.schedule.mass.midnight': 'midnight',

    // Order
    'order.customer.loyalty.anonymous': 'Anonymous - {email}',

    // VAT Rates Matrix
    'route.vatRatesMatrix': 'VAT Reference',
    'vatRatesMatrix.title': 'Global VAT Reference',
    'vatRatesMatrix.subtitle':
        'Single source of truth for the taxation of all Innovorder products. Changes are automatically applied to new products.',
    'vatRatesMatrix.vatGroup': 'VAT Family',
    'vatRatesMatrix.codeLabel': 'Code',
    'vatRatesMatrix.eatIn': 'Eat in',
    'vatRatesMatrix.takeAway': 'Take away',
    'vatRatesMatrix.delivery': 'Delivery',
    'vatRatesMatrix.exportCsv': 'Export CSV',
    'vatRatesMatrix.exportError': 'An error occurred while exporting the CSV. Please try again.',
    'vatRatesMatrix.filterByZone': 'Filter by zone',
    'vatRatesMatrix.filterByGroup': 'Filter by family',
    'vatRatesMatrix.filterByMode': 'Filter by mode',
    'vatRatesMatrix.loading': 'Loading...',
    'vatRatesMatrix.error': 'Error loading data.',
    'vatRatesMatrix.family.FOOD': 'Food',
    'vatRatesMatrix.family.NON_ALCOHOL': 'Non Alcohol',
    'vatRatesMatrix.family.ALCOHOL': 'Alcohol',
    'vatRatesMatrix.family.NORMAL': 'Normal',
    'vatRatesMatrix.family.NONE': 'None',

    // Promotional Banners
    'route.promotionalBanners': 'Promotional Banners',
    'promotionalBanner.page.title': 'Banner Management',
    'promotionalBanner.page.subtitle': 'Create and manage your promotional banners to display on your kiosk.',
    'promotionalBanner.page.emptyState':
        'Create a promotional banner to promote your products and categories on your kiosk.',
    'promotionalBanner.page.emptyStateCta': 'Create a banner',
    'promotionalBanner.page.noActiveMenu.title': 'No active kiosk menu',
    'promotionalBanner.page.noActiveMenu.desc': '👉 Activate a kiosk menu to access the banner configuration.',
    'promotionalBanner.page.noActiveMenu.cta': 'Manage my menus',
    'promotionalBanner.action.create': 'Create a banner',
    'promotionalBanner.action.edit': 'Edit',
    'promotionalBanner.action.view': 'View',
    'promotionalBanner.action.delete': 'Delete',
    'promotionalBanner.action.activate': 'Activate',
    'promotionalBanner.action.deactivate': 'Deactivate',
    'promotionalBanner.table.listTitle': 'Promotional banners list',
    'promotionalBanner.modal.createTitle': 'Create a banner',
    'promotionalBanner.modal.editTitle': 'Edit banner',
    'promotionalBanner.modal.viewTitle': 'View banner',
    'promotionalBanner.modal.close': 'Close',
    'promotionalBanner.modal.name': 'Name',
    'promotionalBanner.modal.channel': 'Channel',
    'promotionalBanner.modal.image': 'Image',
    'promotionalBanner.modal.linkType': 'Link type',
    'promotionalBanner.modal.linkTarget': 'Target',
    'promotionalBanner.modal.activateAndSave': 'Activate and save',
    'promotionalBanner.modal.saveAsDraft': 'Save as draft',
    'promotionalBanner.modal.updateBanner': 'Update banner',
    'promotionalBanner.modal.deactivateBanner': 'Deactivate banner',
    'promotionalBanner.modal.imageSizeError': 'Image must not exceed 5 MB',
    'promotionalBanner.modal.nameHelper': 'This name is only visible in the back office.',
    'promotionalBanner.modal.nameLabel': 'Banner name',
    'promotionalBanner.modal.channelLabel': 'Target channel',
    'promotionalBanner.modal.channelKiosk': 'Kiosk',
    'promotionalBanner.modal.channelKioskDesc':
        'Display the banner at the beginning of the ordering flow on the kiosk.',
    'promotionalBanner.modal.channelWeb': 'Online ordering',
    'promotionalBanner.modal.channelWebDesc': 'Display in the online ordering flow.',
    'promotionalBanner.modal.channelWebDisabled': 'Coming soon.',
    'promotionalBanner.modal.imageLabel': 'Banner image',
    'promotionalBanner.modal.imageSpecs': 'JPG, PNG, WebP · Max 5 MB · 3:1 aspect ratio',
    'promotionalBanner.modal.image.error.ratio': 'Image must have a 3:1 aspect ratio',
    'promotionalBanner.modal.imageFileDescription': '{name} · 1920×500px',
    'promotionalBanner.modal.linkTypeLabel': 'Link type',
    'promotionalBanner.modal.linkNone': 'No link',
    'promotionalBanner.modal.linkNoneDesc': 'Informational and not clickable.',
    'promotionalBanner.modal.linkProduct': 'Product',
    'promotionalBanner.modal.linkProductDesc': 'Redirects to the product page when clicked.',
    'promotionalBanner.modal.linkCategory': 'Category',
    'promotionalBanner.modal.linkCategoryDesc': 'Redirects to the category when clicked.',
    'promotionalBanner.modal.activateBanner': 'Activate banner',
    'promotionalBanner.modal.replace': 'Replace',
    'promotionalBanner.modal.searchCategory': 'Search a category...',
    'promotionalBanner.modal.searchProduct': 'Search a product by name or SKU...',
    'promotionalBanner.table.name': 'Name',
    'promotionalBanner.table.status': 'Status',
    'promotionalBanner.table.source': 'Source',
    'promotionalBanner.table.linkType': 'Link type',
    'promotionalBanner.table.actions': 'Actions',
    'promotionalBanner.table.sourceRestaurant': 'Restaurant',
    'promotionalBanner.table.sourceBrand': 'Brand',
    'promotionalBanner.table.linkNone': 'No link',
    'promotionalBanner.table.linkCategory': 'Category',
    'promotionalBanner.table.linkProduct': 'Product',
    'promotionalBanner.table.statusActive': 'Active',
    'promotionalBanner.table.statusInactive': 'Inactive',
    'promotionalBanner.table.linkDeleted': 'deleted',
    'promotionalBanner.confirm.title': 'A service is currently in progress',
    'promotionalBanner.confirm.message': 'This action will reload all kiosks and interrupt orders in progress.',
    'promotionalBanner.confirm.confirm': 'Confirm',
    'promotionalBanner.confirm.cancel': 'Cancel',
    'promotionalBanner.delete.title': 'Delete banner',
    'promotionalBanner.delete.description': 'Are you sure you want to delete this banner?',

    // Bulk reload (Lot 3)
    'promotionalBanner.confirm.message.bulk':
        'This action will reload the kiosks of {count} restaurants and interrupt orders in progress.',

    // Duplicate (restaurant page, Lot 3)
    'promotionalBanner.action.duplicate': 'Duplicate',
    'promotionalBanner.duplicate.fallback.title': 'Banner duplicated without link',
    'promotionalBanner.duplicate.fallback.product':
        'The copy of "{sourceName}" was created without a link: the SKU was not found in your active kiosk menu.',
    'promotionalBanner.duplicate.fallback.category':
        'The copy of "{sourceName}" was created without a link: the category was not found in your active kiosk menu.',
    'promotionalBanner.duplicate.fallback.dismiss': 'Got it',

    // Route label (Lot 3)
    'route.brand.promotionalBanners': 'Promotional banners',

    // Brand promotional banners page (Lot 3)
    'brandPromotionalBanner.page.title': 'Brand promotional banners',
    'brandPromotionalBanner.page.subtitle': "Configure and propagate banners across your brand's restaurants.",
    'brandPromotionalBanner.page.empty': 'No banners yet.',
    'brandPromotionalBanner.action.create': 'Create a banner',

    // Brand table
    'brandPromotionalBanner.table.name': 'Name',
    'brandPromotionalBanner.table.status': 'Status',
    'brandPromotionalBanner.table.source': 'Source',
    'brandPromotionalBanner.table.link': 'SKU or category',
    'brandPromotionalBanner.table.activeRestaurants': '{count} active restaurants',
    'brandPromotionalBanner.table.actions': 'Actions',

    // Brand modal
    'brandPromotionalBanner.modal.createTitle': 'Create a brand banner',
    'brandPromotionalBanner.modal.editTitle': 'Edit banner',
    'brandPromotionalBanner.modal.name.label': 'Banner name',
    'brandPromotionalBanner.modal.image.label': 'Image',
    'brandPromotionalBanner.modal.image.hint': '3:1 aspect ratio, max 5 MB',
    'brandPromotionalBanner.modal.image.error.ratio': 'Image must have a 3:1 aspect ratio',
    'brandPromotionalBanner.modal.image.error.size': 'Image exceeds 5 MB',
    'brandPromotionalBanner.modal.channel.label': 'Channel',
    'brandPromotionalBanner.modal.channel.comingSoon': 'Coming soon',
    'brandPromotionalBanner.modal.link.label': 'Link type',
    'brandPromotionalBanner.modal.link.none': 'No link',
    'brandPromotionalBanner.modal.link.product': 'Product (SKU)',
    'brandPromotionalBanner.modal.link.category': 'Category',
    'brandPromotionalBanner.modal.link.product.hint':
        "If the SKU is not found in a restaurant's active kiosk menu, the banner will be displayed without a link for that restaurant.",
    'brandPromotionalBanner.modal.link.category.hint':
        "If the category is not found in a restaurant's active kiosk menu, the banner will be displayed without a link for that restaurant.",
    'brandPromotionalBanner.modal.restaurants.label': 'Target restaurants',
    'brandPromotionalBanner.modal.restaurants.empty': 'Select at least one restaurant',
    'brandPromotionalBanner.modal.button.cancel': 'Cancel',
    'brandPromotionalBanner.modal.button.saveDraft': 'Save as draft',
    'brandPromotionalBanner.modal.button.activate': 'Activate banner',
    'brandPromotionalBanner.modal.button.deactivate': 'Deactivate banner',
    'brandPromotionalBanner.modal.button.update': 'Update banner',

    // Brand delete
    'brandPromotionalBanner.delete.title': 'Delete banner?',
    'brandPromotionalBanner.delete.message': 'The banner will be removed from all associated restaurants.',

    // Carousel delay
    'brandPromotionalBanner.carousel.title': 'Display delay between two banners',
    'brandPromotionalBanner.carousel.description': 'Set the display time between two active banners.',
    'brandPromotionalBanner.carousel.helper': 'Wait time between the display of two active banners.',
    'brandPromotionalBanner.carousel.seconds': 'seconds',
    'brandPromotionalBanner.carousel.save': 'Save',
    'brandPromotionalBanner.carousel.saved': 'Delay updated',
    'brandPromotionalBanner.carousel.help':
        'This delay will apply to all restaurants in the brand at the next kiosk reload.',

    // Non-eligible restaurants
    'brandPromotionalBanner.modal.restaurants.ineligible.noChannel':
        'This restaurant does not have the kiosk channel enabled.',
    'brandPromotionalBanner.modal.restaurants.ineligible.noMenu': 'This restaurant does not have an active kiosk menu.',

    // Shifts (service slots) — brand-level tab
    'shift.tableCard.title': 'Services',
    'shift.tableCard.subtitle': 'Create and manage the services (time slots) for your restaurants.',
    'shift.tableCard.action': '+ Add a service',
    'shift.emptyMessage': 'No service configured for this restaurant.',
    'shift.selectRestaurantPrompt': 'Select a restaurant to view its services.',
    'shift.search': 'Search a service',
    'shift.adminOnly': 'This page is only accessible to administrators.',
    'shift.restaurantSelector': 'Restaurant',
    'shift.restaurantSelector.placeholder': 'Select a restaurant',
    'shift.column.name': 'Name',
    'shift.column.restaurant': 'Restaurant',
    'shift.column.daysOfWeek': 'Days',
    'shift.column.hours': 'Hours',
    'shift.column.isEnabled': 'Enabled',
    'shift.column.isDefault': 'Default',
    'shift.column.action': 'Action',
    'shift.badge.enabled': 'Enabled',
    'shift.badge.disabled': 'Disabled',
    'shift.badge.default': 'Default',
    'shift.day.MON': 'Mon',
    'shift.day.TUE': 'Tue',
    'shift.day.WED': 'Wed',
    'shift.day.THU': 'Thu',
    'shift.day.FRI': 'Fri',
    'shift.day.SAT': 'Sat',
    'shift.day.SUN': 'Sun',
    'shift.form.title.create': 'New service',
    'shift.form.title.edit': 'Edit service',
    'shift.form.subtitle': 'Define the days, hours and options of the service.',
    'shift.field.name': 'Name',
    'shift.field.name.placeholder': 'E.g. Lunch service',
    'shift.field.restaurant': 'Restaurant',
    'shift.field.restaurant.placeholder': 'Select a restaurant',
    'shift.field.restaurant.hint.edit': 'The restaurant cannot be changed after creation.',
    'shift.field.daysOfWeek': 'Days of the week',
    'shift.field.daysOfWeek.placeholder': 'Select days',
    'shift.field.start': 'Start',
    'shift.field.end': 'End',
    'shift.field.endsTomorrow': 'Ends the next day',
    'shift.field.color': 'Color',
    'shift.field.isEnabled': 'Service active',
    'shift.field.isDefault': 'Default service',
    'shift.field.isDefault.hint': 'The default service cannot be changed after creation.',
    'shift.error.daysOfWeek.required': 'Select at least one day.',
    'shift.error.hours.format': 'Invalid format (HH:mm).',
    'shift.error.hours.inconsistency': 'End time must be after start time.',
    'shift.error.color.format': 'Invalid color.',
    'shift.delete.modal.warning': 'Warning',
    'shift.delete.modal.confirmDelete': 'Are you sure you want to delete this service?',
    'shift.delete.modal.title': 'Deletion not allowed',
    'shift.delete.modal.defaultBlocked': 'The default service cannot be deleted.',
    'shift.api.error.shift_cannot_delete_default': 'The default service cannot be deleted.',
    'shift.api.error.shift_overlap': 'The service overlaps with an existing service.',
    'shift.api.error.shift_default_already_exists': 'A default service already exists for this restaurant.',
    'shift.api.error.shift_wrong_days_of_week_format': 'Invalid days format.',
    'shift.api.error.shift_wrong_hours_format': 'Invalid hours format.',
    'shift.api.error.shift_hours_inconsistency': 'Start time must be less than end time.',
    'shift.api.error.shift_cannot_edit_default': 'The default service cannot be edited.',
};

export default translationEn;
